import React, { Component, Fragment } from "react";
import { Stage, Layer, Group, Rect, Arc, Text } from "react-konva";
// import betchipsnd from "././../../../../../assets/sounds/betoncard.mp3";
// import betrussiansnd from "././../../../../../assets/sounds/bet.mp3";
// import pokerchipsnd from "././../../../../../assets/sounds/pokerchip_snd.mp3";
// import plyerwin_snd from "././../../../../../assets/sounds/successNew.mp3";
// import cardsdropping_snd from "././../../../../../assets/sounds/carddroping.mp3";
// import cardsshuffle from "././../../../../../assets/sounds/shuffle-cards.mp3";
// import reaveldealer_cards from "././../../../../../assets/sounds/dealercards_reavel.mp3";
// import clear_snd from "././../../../../../assets/sounds/clear.mp3";
// import selectCard from "../../../../../assets/sounds/selectcard.mp3";
// import unselectCard from "../../../../../assets/sounds/unselectcard.mp3";
// import playerWin from "../../../../../assets/sounds/successNew.mp3"
// import playerLose from "../../../../../assets/sounds/successNew.mp3"
// import playerLose from "../../../../../assets/sounds/duplose.mp3"
import Cards from "./UI/Oasiscards";
import Rutablewindows from "../../../../../assets/games/russianPoker/russiantblewindows2.webp";

import chip_10 from "../../../../../assets/games/russianPoker/black.png";
import chip_25 from "../../../../../assets/games/russianPoker/Purple chip.svg";
import chip_50 from "../../../../../assets/games/russianPoker/blue.png";
import chip_100 from "../../../../../assets/games/russianPoker/red.png";
import chip_500 from "../../../../../assets/games/russianPoker/yellow.png";
import chip_1000 from "../../../../../assets/games/russianPoker/Whitechip.svg"
// import "./OasisPoker.css";
import "../../../games/non_timer/oasisPoker/OasisPoker.css"

import oasisPoBG from "../../../../../assets/games/oasisgoldenpoker/OasisPotraitBG12.webp";
import mutesnds from "../../../../../assets/games/russianPoker/mute_snds.png"
// import pokertableruss from "../../../../../assets/games/russianPoker/AssetTable.png";
// import pokertablelandsp from "../../../../../assets/games/russianPoker/landscapetable.png";
import landscapebg from "../../../../../assets/games/oasisgoldenpoker/OasisLandBG12.webp";
import porttraitejson from "./OP_portraite&landscape.json";
import balanceicon from "../../../../../assets/games/russianPoker/Balance icon.png";
import balanceiconwindows from "../../../../../assets/games/russianPoker/balancewindows.png";
import exitrussian_popup from "../../../../../assets/games/russianPoker/logOut.png";
// import exitrussian from "../../../../../assets/games/russianPoker/logOut.png";
import exitrussian from "../../../../../assets/games/russianPoker/logOut.png";
import popupExit from "../../../../../assets/common_imgs/exit_btn.png"
// import exitrussian from "../../../../../assets/games/russianPoker/Exit.png";
import beticonTP from "../../../../../assets/games/russianPoker/Bet icon.png";
import beticonwindows from "../../../../../assets/games/russianPoker/betwindows.png";
import winnericn from "../../../../../assets/games/russianPoker/winnericon.png";
import winnericnwindows from "../../../../../assets/games/russianPoker/winnericonwindows.png";
import informicon from "../../../../../assets/games/tropicalstudpoker/i_1.svg";
// import informicon from "../../../../../assets/games/russianPoker/i.png";
import russiantitle from "../../../../../assets/games/russianPoker/russiantitle.png";
import russianlabelimg from "../../../../../assets/games/russianPoker/russianlabel.png";
import optionbtn from "../../../../../assets/games/russianPoker/Option.png";
// import optionbtnwindows from "../../../../../assets/games/tropicalstudpoker/menu.svg";
import optionbtnwindows from "../../../../../assets/games/russianPoker/optionbtnwindows.png";
import volumeimg from "../../../../../assets/games/tropicalstudpoker/volume.svg";
import russianbetbtnup from "../../../../../assets/games/russianPoker/up.png";
import russianbetbtright from "../../../../../assets/games/tropicalstudpoker/TP_btn_backn.png";
import russianbetbtnleft from "../../../../../assets/games/tropicalstudpoker/TP_btn_backn.png";
import russianbetbtndown from "../../../../../assets/games/tropicalstudpoker/TP_btn_backn.png";
import russianbetcle from "../../../../../assets/games/tropicalstudpoker/TP_btn_backn.png";
import betincerementdecrement from "../../../../../assets/games/tropicalstudpoker/betincreamenTP.png";
// import betincerementdecrement1 from "../../../../../assets/games/russianPoker/Balance icon.png"
import betchipsRussian from "../../../../../assets/games/russianPoker/black.png";
import Tropicalbgwindows from "../../../../../assets/games/oasisgoldenpoker/OasisPokerBG.webp";
// import Drawbtn from "../../../../../assets/games/russianPoker/drawbtn.png";
import Drawbtn from "../../../../../assets/games/tropicalstudpoker/drawbtnwindows.png";
import Drawbtnwindows from "../../../../../assets/games/tropicalstudpoker/drawbtnwindows.png";
import bnsactiveTP from "../../../../../assets/games/tropicalstudpoker/Active_TP.svg";
import Buybtn from "../../../../../assets/games/russianPoker/buybtn.png";
import Buybtnwindows from "../../../../../assets/games/russianPoker/buybtnwindows.png";
import Betbtn from "../../../../../assets/games/tropicalstudpoker/betbtnWindow.png";
// import Betbtn from "../../../../../assets/games/russianPoker/betbtn.png"
// import Foldbn from "../../../../../assets/games/russianPoker/foldbtn.png";
import Foldbn from "../../../../../assets/games/tropicalstudpoker/foldWindow.png";
import Foldbnwindows from "../../../../../assets/games/tropicalstudpoker/foldWindow.png";
import useridlmg from "../../../../../assets/games/russianPoker/userid.png";
import Russiandeck from "../../../../../assets/games/tropicalstudpoker/DeckTP.png";
import gsap from "gsap";
import DealerCardsContainer from "./UI/OasisDealerCardsContainer";
import resultCards from "./UI/OasisresultCards";
import Title from "../RussianPoker/Russiantitle";
import { connect } from "react-redux";

import loadedwindowimg from "../../../../../assets/games/oasisgoldenpoker/OasisPokerwinTable.webp"
import loadedLandimg from "../../../../../assets/games/oasisgoldenpoker/land.webp"
import loadedportaiteimg from "../../../../../assets/games/oasisgoldenpoker/OSprotraiteTable.webp"
import Howlersounds from "../../../Utillitys/howlersounds";
import { Howl } from "howler";
import CoinBurst from "../../../games/CoinBurst"

const Russianpokerassets = [
  chip_10,
  chip_25,
  chip_50,
  chip_100,
  chip_500,
  chip_1000,
  oasisPoBG,
  mutesnds,
  landscapebg,
  balanceicon,
  balanceiconwindows,
  exitrussian_popup,
  popupExit,
  beticonTP,
  beticonwindows,
  winnericn,
  winnericnwindows,
  informicon,
  russiantitle,
  russianlabelimg,
  optionbtn,
  optionbtnwindows,
  volumeimg,
  russianbetbtnup,
  russianbetbtright,
  russianbetbtnleft,
  russianbetbtndown,
  russianbetcle,
  betincerementdecrement,
  betchipsRussian,
  Tropicalbgwindows,
  Drawbtn,
  Drawbtnwindows,
  bnsactiveTP,
  Buybtn,
  Buybtnwindows,
  Betbtn,
  Foldbn,
  Foldbnwindows,
  useridlmg,
];

// npm i react-konva@17.0.1-3
class OasisPoker extends Component {
  constructor(props) {
    super(props);
    this.cardsRef = React.createRef();
    this.dealerCardsContainer = React.createRef();
    this.Howlersounds = React.createRef();
    this._timeouts = [];
    // this.pokerchipsnd = new Audio(pokerchipsnd);

    // antebetresult and shuffled result : ---------
    this.randomPlayerCards = [];
    this.shuffledPlayerCards = [];
    this.randomDealerCards = [];
    // replaceCards (userSelectedCards) : ---------
    this.replaceCards = [];
    // serverResponse (after draw cards) : ---------
    this.unsequenceDrawCards = [];
    this.sequenceDrawCards = [];
    // clickOnBuyCard : ---------
    this.buyCardUnsequenceArray = [];
    this.buyCardsequenceArray = [];
    // DEALER CARDS
    this.dealerCardsRandom = [];
    this.dealerShuffledCards = [];
    // CONFIRM_DEALER_CARD : -----------------
    this.dealerUnsequenceDrawCards = [];
    this.dealerSequenceDrawFinalCards = [];
    this.balnce = this.props.balance;
    this.antebet = 0;
    this.betsamount = 0;
    this.roundNumber = 0;
    this.betAmount = 0;
    this.tableImg = null;
    this.NavigateState = null;
    this.intialEnter = true;

    this.state = {
      isPlayingChip: false,
      playersound12: false,
      isPlayingBet: false,
      sound12: null,
      isplayerinfoupdate: false,
      playerrankinghand: [],
      myOrient: "land",
      betshigh_balnce: null,
      keyboardhandle: false,
      dealenable: false,
      disClearBtn: 1,
      disDrawbtn: 1,
      disBuybtn: 1,
      cmfrmdealeraction: 0,
      cmfrmdealeractionNO: 0,
      FoldbtnTP: 1,
      handId: 0,
      Yesbtn: 1,
      Nobtn: 1,
      betBtnValue: 0,
      disBetBtn: 1,
      playerhand_status: "",
      isoptionmenu: false,
      ShowGamerules: false,
      buttontext: "",
      drawbuttonhandle: false,
      ShowLimits: false,
      isactiveoptionsmenu: false,
      ishistorytable: false,
      balance_rsp: 0,
      updateBet: 0,
      betdeductions: 0,
      antebetcircle: false,
      betchipincrementbtn: false,
      multibuttonsebledsble: false,
      mutesounds: false,
      totalbet: 0,
      count: 1,
      pokerranking: "",
      pokerrankingdeler: "",
      storebetchips: [],
      storeantebetchips: [],
      prevStatestoreantebetchips: [],
      totalwinRussian: 0,
      betdecreamentbtn: false,
      idincrement: 0,
      anteBetAmount: 0,
      previousAnteBetAmount: 0,
      disablemultibutton: false,
      isMobilePortraitLndsp: null,
      betbutton: "DEAL",
      activeScreen: null,
      // //GroupProperties
      heightOfLayer: null,
      widthOfLayer: null,
      dealerDistanceFromX: null,
      playerDistanceFromX: null,
      dealerDistanceFromY: null,
      PlayerDistanceFromY: null,
      // SpriteSheetProps
      revealCard: false,
      infoText: this.props.infoText,
      buydrawCheck: false,
      lowBalaceErrorInfo: "",
      ShowHistory: false,
      disableBuyButton: false,
      betactvglwcss: null,
      betbuttoncss: null,
      betbtntextcss: null,
      foldbuttoncss: null,
      foldbtntextcss: null,
      buybtncss: null,
      buybtntxtcss: null,
      drawbtncss: null,
      drawbtntxtcss: null,
      betchipstoantebetcss: null,
      chipsstoredcontainercss: null,
      antebetpdvcss: null,
      antechpimgcss: null,
      antespntxtcss: null,
      betbtntxtcss: null,
      betchiptobetbtncss: null,
      betchiptobetbtncss: null,
      betbtntxtcss: null,
      drawchipcss: null,
      drawchiptextcss: null,
      dealerhandcss: null,
      playerhandcss: null,
      mobileAntiMaskCovercss: null,
      betpannelrussiancovercss: null,
      rankinginfodelercss: null,
      inforussiancss: null,
      drawbtnnewClass: false,
      drawChipXd: null,
      drawChipYd: null,
      drawChipRetrunXd: null,
      drawChipRetrunYd: null,
      PayouyBetBounusData: [],
      PayoutTableToggle: false,
      Winnindanimation: false,
      AnteWinCHanimation: false,
      DelarAnteWinProLandAN: null
    };
    this.winPopupContainer = React.createRef();
    this.dropdownRef = React.createRef();
    this.chipref = React.createRef();
    this.chiprefee = React.createRef();
    this.chipdrawref = React.createRef();
    this.chipvalue = React.createRef();
    this.chipsarray = React.createRef();
    this.chipbetref = React.createRef();
    this.no = React.createRef();
    this.cardsRef = React.createRef();
    // this.dealerCardsContainer = React.createRef();
    this.buyDealerCardDrawn = React.createRef();
    this.handleResize = this.handleResize.bind(this);
    this.isMobile = false;
    this.dealenable = false;
    this.resetAnimationChips = false;
    this.wanttobuydelercrd = null;

    this.drawReplaceCards = false;

    this.betchipactivated = false;
    this.buydrawchipactivated = false;
    this.ConfirmbuydealercardactivePopup = false;
    this.resetPyrWnCpsAmn = false;

    this.clearTimingLeft = [
      this.clertime1, this.clertime2, this.clertime3, this.clertime4, this.clertime5, this.clertime6, this.clertime7, this.clertime8, this.clertime9,
      this.clertime11, this.clertime12, this.clertime13, this.clertime14, this.clertime15, this.clertime16, this.clertime17, this.clertime18, this.clertime19,
      this.clertime21, this.clertime22, this.clertime23, this.clertime24, this.clertime25, this.clertime26, this.clertime27, this.clertime28, this.clertime29,
      this.clertime31, this.clertime32, this.clertime33, this.clertime34, this.clertime35, this.clertime36, this.clertime37, this.clertime38, this.clertime39,
      this.clertime41, this.clertime42, this.clertime43, this.clertime44, this.clertime45, this.clertime46, this.clertime47, this.clertime48, this.clertime49,
      this.clertime50, this.clertime51, this.clertime52, this.clertime53, this.clertime54, this.clertime55, this.clertime56, this.clertime57
    ]
    this.GameRules = [
      { "name": "The game is played using one 52-card deck. The game uses standard poker rules for ranking and comparing hands." },
      { "name": "The player places his mandatory Ante wager, plus an optional bet." },
      { "name": "The player and the dealer are dealt five cards, with the dealers last (5th) card turned face up." },
      { "name": "The player must make a decision to either Fold, Bet, or Draw." },
      { "name": "FOLD: The players five cards are discarded. The dealer will collect the losing Ante." },
      { "name": "BET: The player places a wager of 2x the Ante in the BET box." },
      { "name": "You have an opportunity to change all of your cards before taking final decision. The change is allowed once times per round." },
      { "name": "DRAW: If you change 1-5 cards, it will cost you your Ante." },
      { "name": "To change a card, click on the card, and then click DRAW." },
      { "name": "If the player invoked the Exchange option, then the Fold or Bet decision will be made based on the new hand." },
      { "name": "The dealers cards are then opened and the poker value of the hand declared." },
      { "name": "If the dealer qualifies with a hand of Ace-King or higher, the players hand will be settled as follows:" },
      { "name": "In the case that the dealer’s hand does not Qualify, you receive a 1 to 1 payout to Ante." },
      { "name": "Player wins: If the dealer’s cards have Qualify but you have the better cards, you get back your bets, and receive a 1 to 1 payout to your Ante, and the Bet is paid out according to your card combination as indicated in the paytable." },
      { "name": "Tie: If the dealer qualifies but your cards completely equal to dealer’s ones, you get back your Ante and Bet." },
      { "name": "Dealer wins: If the dealer qualifies but your cards lose to dealer’s ones, Ante and Bet return to the dealer." }
    ]
    this.chipVal = [
      { src: chip_10, key: 1, label: "10", val: 10 },
      { src: chip_25, key: 1, label: "20", val: 20 },
      { src: chip_50, key: 1, label: "50", val: 50 },
      { src: chip_100, key: 1, label: "100", val: 100 },
      { src: chip_500, key: 1, label: "500", val: 500 },
      { src: chip_1000, key: 1, label: "1000", val: 1000 },
    ];
    this.updatePlayerInfo = this.updatePlayerInfo.bind(this);
    // this.handleOrientationChange = this.handleOrientationChange.bind(this)

  }
  clearallsettimeouts = () => {
    for (let i = 1; i <= this.clearTimingLeft.length; i++) {
      clearTimeout(this.clearTimingLeft[i]);
      // console.log(this.clearTimingLeft[i]);
    }
  }
  handleDocumentClick = (event) => {
    /// payout table
    const dropdownElement = this.dropdownRef.current;
    const infrmiconElement = document.getElementById("infrmiconTP");

    const clickedInsideDropdown = dropdownElement && dropdownElement.contains(event.target);
    const clickedOnInfrmicon = infrmiconElement && infrmiconElement.contains(event.target);
    console.log(clickedInsideDropdown || clickedOnInfrmicon);

    if (!clickedInsideDropdown && !clickedOnInfrmicon) {
      if (this.state.PayoutTableToggle) {
        this.setState({ PayoutTableToggle: false });
      }
      console.log("enter...............................");
    }

  }

  componentDidMount() {
    this.NavigateState = (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    document.addEventListener('click', this.handleDocumentClick);
    console.log(this.props.OS_payouts)
    document.addEventListener('keydown', this.handleKeyDown)

    const BetPayout_split = this.props.OS_payouts.map((item) => ({
      ...item,
      value: item.value.replace("X", " to "),
    }));

    console.log(BetPayout_split)
    this.setState({
      PayouyBetBounusData: BetPayout_split
      // PayouyBetBounusData: this.props.OS_payouts
    })

    this.newSound = null

    const { childRef } = this.props;
    childRef(this);
    this.preloadassetsRussianpoker(Russianpokerassets)
    document.addEventListener("keydown", this.Russian_handleKeyboardEvent);
    this.setState({ buttontext: "clear", betdeductions: 0 });

    this.setState({ buttontext: "clear", })

    if (this.props.os_chipValues) {
      let newChips = this.props.os_chipValues.split(",");
      let lblTxt = "";
      for (let i = 0; i < newChips.length; i++) {
        if (Number(newChips[i]) >= 1000 && Number(newChips[i]) <= 999999) {
          lblTxt = "K"
        } else if (Number(newChips[i]) >= 1000000 && Number(newChips[i]) <= 999999999) {
          lblTxt = "M"
        } else if (Number(newChips[i]) > 999999999) {
          lblTxt = "B"
        }
        this.chipVal[i].val = newChips[i]
        this.checkChipValueTropical(Number(this.chipVal[i].val), lblTxt, i);
      }

    }
    // this.betrussiansnd = new Audio(betrussiansnd);
    // this.reaveldealer_cards = new Howl({ src: [reaveldealer_cards], html5: true, });

    // this.selectCard = new Audio(selectCard);
    // this.unselectCard = new Audio(unselectCard);
    // this.cardsshuffle = new Audio(cardsshuffle);

    // this.pokerchipsnd = this.initializeChipSound();
    // this.betchipsnd = this.initializeBetSound();
    // this.playerWin = this.initializePlayerWinSound();
    // this.playerLose = this.initializePlayerLoseSound();

    document.getElementById("Tropicalgamecover").style.display = "none";
    // document.getElementById("Tropicalgamecover").classList.add("gamecover_enbledisableOS")

    window.addEventListener("resize", this.handleResize);

    // window.addEventListener("resize", this.handleOrientationChange);

    this.handleOrientationChange();

    let decreasrDisable = document.getElementById('betdecrementTP')
    decreasrDisable.classList.add('icon_autoAlpha')

    const betchipsRussianpoker = document.getElementById("betchipsTP");
    this.setState({ infoText: this.props.language.Place_antebet })
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      // document.getElementById("Payout_TPS").style.display = "block"

      document.getElementById("landscapeInfoTP").style.display = "none";
      document.getElementById("infocontainerTP").classList.add("infotext_windowsOS")

      document.getElementById("infrmiconTP").classList.add("addpointerOS")
      document.getElementById("TspoptionTP").classList.add("addpointerOS")
      const buybutton = document.getElementById("buybtnTP");
      buybutton.classList.add("addpointerOS")

      document.getElementById("minmaxbetsTP").classList.add("minmaxbets_windowsOS");
      this.setState({
        activeScreen: 0
      })

      document.getElementById("container_playerdealerOS").classList.add("container_playerdealerOS");
      document.getElementById("Dealer").classList.add("Dealer_windowsOS")
      document.getElementById("Player").classList.add("Player_windowsOS")
      // document.getElementById("TspoptionTP").style.display = "none"

      document.getElementById("buydrawTropical").classList.add("insurencenodropOS")
      document.getElementById("betTropical").classList.add("insurencenodropOS")
      document.getElementById('volumeTropical').classList.add("addpointerOS")
      document.getElementById("drawtextTP").classList.add("drawtextwindowsOS");
      document.getElementById("betpannelTropicalcover").style.display = "none";
      document.getElementById("betpannelTropicalcover").classList.add("pannelcoverTP");

      document.getElementById("betcontainerTP").classList.add("betpannelrussianwindowsOS");
      document.getElementById("infoTropicalP").classList.add("windowsinfoOS");

      document.getElementById("TPbetcircle").classList.add("addpointerOS");
      document.getElementById("betbtnTP").classList.add("addpointerOS");
      document.getElementById("FoldbtnTP").classList.add("addpointerOS");

      switch (this.state.count) {
        case 1:
          betchipsRussianpoker.src = chip_10;
          if (document.getElementById("val0")) {
            document.getElementById("val0").classList.remove("valtext_windowsOS");
            document.getElementById("val0").textContent = this.chipVal[0].label;
            document.getElementById("val0").classList.add("valtext_windows_chip10OS", "chip_10textOS");

          }
          break;
        case 2:
          betchipsRussianpoker.src = chip_25;
          break;
        case 3:
          betchipsRussianpoker.src = chip_50;
          break;
        case 4:
          betchipsRussianpoker.src = chip_100;
          break;
        case 5:
          betchipsRussianpoker.src = chip_500;
          break;
        case 6:
          betchipsRussianpoker.src = chip_1000;
          break;
        default:
          break;
      }
      Object.assign(betchipsRussianpoker.style, porttraitejson.betchpwindows);


    } else {

      this.setState({
        activeScreen: 1
      })
      const confirmbuydealerElement = document.getElementById("confirmbuydealer_popupTP");
      const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_greaterthanbalnceTP");
      popupbetGreaterthanBalnceElement.classList.add("popupbetshighMobileIntialOS");
      const containerPlayerdealerElement = document.getElementById("container_playerdealerOS");
      const betbutton = document.getElementById("betbtnTP");
      const foldbutton = document.getElementById("FoldbtnTP");
      const drawbutton = document.getElementById("drawbtnTP");
      drawbutton.classList.add("drwnodropOS")
      const buybutton = document.getElementById("buybtnTP");

      containerPlayerdealerElement.className = "";
      containerPlayerdealerElement.style.cssText = "";

      drawbutton.src = "";
      drawbutton.style.cssText = "";
      buybutton.src = "";
      buybutton.style.cssText = "";
      betbutton.src = "";
      betbutton.style.cssText = "";
      foldbutton.src = "";
      foldbutton.style.cssText = "";

      switch (this.state.count) {
        case 1:
          betchipsRussianpoker.src = chip_10;
          document.getElementById("val0").textContent = this.chipVal[0].label;

          break;
        case 2:
          betchipsRussianpoker.src = chip_25;
          break;
        case 3:
          betchipsRussianpoker.src = chip_50;
          break;
        case 4:
          betchipsRussianpoker.src = chip_100;
          break;
        case 5:
          betchipsRussianpoker.src = chip_500;
          break;
        case 6:
          betchipsRussianpoker.src = chip_1000;
          break;

        default:
          break;
      }

      document.getElementById("val0").style.cssText = "";
      document.getElementById("infoTropicalP").className = "";
      document.getElementById("infoTroppicalland").className = "";
      confirmbuydealerElement.classList.add('confirmbuy-dealerpopupOS');
      if (window.innerWidth < window.innerHeight) {
        document.getElementById("infocontainerTP").style.display = "block"
        document.getElementById("landscapeInfoTP").style.display = "none"

        document.getElementById("val0").classList.add("valtextPortraitOS", "valtextPortrait1OS");

        document.getElementById("betpannelTropicalcover").style.display = "none";
        document.getElementById("betpannelTropicalcover").classList.add("PlayerCardpannelcoverPortraitOS");
        document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
        document.getElementById("mobileAntiMaskCoverOS").classList.add("mobileAntiMaskCoverOS");
        document.getElementById("val0").classList.remove('valtext0');
        // confirmbuydealerElement.classList.add('confirmbuy-dealerpopupOS');

        document.getElementById("infoTropicalP").classList.add("portraitinfoOS");
        // document.getElementById('volumeTropical').classList.add("addpointerOS")
        // betChipText.style.cssText = "";

        containerPlayerdealerElement.classList.add("cntr_pyrdlr_prtOS");
        document.getElementById("Player").style.fontSize = "80px";

      } else {
        document.getElementById("landscapeInfoTP").style.display = "block";
        document.getElementById("infocontainerTP").style.display = "none"

        document.getElementById("betpannelTropicalcover").style.display = "none";
        document.getElementById("betpannelTropicalcover").classList.add("PlayerCardpannelcoverLndspOS");

        document.getElementById("val0").classList.add("valtextLandscapeOS", "valtextPortrait1OS");
        containerPlayerdealerElement.classList.add("cntr_pyrdlr_lnspOS");
        document.getElementById("Player").style.fontSize = "80px";

        document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
        document.getElementById("mobileAntiMaskCoverOS").classList.add("mobileLndspAntiMaskCoverOS");

        document.getElementById("infoTroppicalland").classList.add("lndspinfoOS");

      }
      document.addEventListener("visibilitychange", this.handleVisibilityChange);
    }

    this.showPreviousBetsStatus();
  }

  setSafeTimeout(callback, delay) {
    const id = setTimeout(() => {
      callback();
      // Optional: remove the timeout ID from the list after it fires
      this._timeouts = this._timeouts.filter(t => t !== id);
    }, delay);

    this._timeouts.push(id);
    return id;
  }

  clearAllTimeouts() {
    this._timeouts.forEach(clearTimeout);
    this._timeouts = [];
  }

  handleKeyDown = (event) => {
    console.log(event.key)
    //   if (event.key === 'Tab' || "Enter") {

    event.preventDefault();  // Disable the Tab key globally
    console.log('Tab key is disabled globally!');
    // }

  };

  preloadassetsRussianpoker = (Russainassets) => {
    Russainassets.forEach((loadedimages) => {
      const img = new Image();
      img.src = loadedimages;
    });

  }

  checkChipValueTropical(chipValue, chpTxt, i) {
    if (chipValue >= 1000) {
      chipValue = chipValue / 1000;
      this.checkChipValueTropical(chipValue, chpTxt, i)
    } else {
      // console.log(chpTxt);
      this.showResultChipValueTropical(chipValue, chpTxt, i);
      return chipValue
    }
  }
  showResultChipValueTropical(chVal, chipTxt, index) {
    this.chipVal[index].label = chVal + "" + chipTxt;
    console.log(this.chipVal)
  }
  componentWillUnmount() {
    this.intialEnter = true;
    // document.removeEventListener("keydown", this.Russian_handleKeyboardEvent);
    this.clearAllTimeouts()

    document.removeEventListener('keydown', this.handleKeyDown);

    window.removeEventListener("resize", this.handleResize);
    // this.betchipsnd.pause();
    // this.betrussiansnd.pause();
    // // this.reaveldealer_cards.pause();

    // this.selectCard.pause();
    // this.unselectCard.pause();
    // this.playerWin.pause();
    // this.playerLose.pause();
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }

  handleVisibilityChange = () => {

    if (document.visibilityState === "hidden") {
      console.log("The game is in the background or the user switched tabs.");
      // Pause the game, animations, or sound

    } else if (document.visibilityState === "visible") {

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        this.setState({
          heightOfLayer: 1105,
          widthOfLayer: 2200,
        })
      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          this.setState({
            heightOfLayer: 1200,
            widthOfLayer: 800,

          })
        }
        else {
          this.setState({
            heightOfLayer: 1050,
            widthOfLayer: 760,
          })

        }

      }



      console.log("The user returned to the game.");

      // Resume the game, animations, or sound
      const body = {
        sessionId: sessionStorage.getItem("sessionId"),
        CN: "GET_GAME_STATE",
        object: {
          // gameId: this.state.gameId,
          gameId: this.props.gameId,
          playerId: Number(this.props.playerId),
          // handId:this.handId,

        },
      };
      this.props.network.sendof(body);
      console.log(body);
      this.body = {};
    }

  };


  clearActivesWeDid = () => {

    this.setState({
      pokerranking: "",
      pokerrankingdeler: "",
    });

    this.randomPlayerCards = [];
    this.shuffledPlayerCards = [];
    this.randomDealerCards = [];
    this.replaceCards = [];
    this.unsequenceDrawCards = [];
    this.sequenceDrawCards = [];
    this.buyCardUnsequenceArray = [];
    this.buyCardsequenceArray = [];
    this.dealerCardsRandom = [];
    this.dealerShuffledCards = [];
    this.dealerUnsequenceDrawCards = [];
    this.dealerSequenceDrawFinalCards = [];

    if (document.getElementById('rankinginfodelerOS')) {
      document.getElementById('rankinginfodelerOS').className = "";
      document.getElementById('rankinginfodelerOS').textContent = "";
      document.getElementById("bettextOS").style.color = "";
    }

    if (document.getElementById('rankinginfoOS')) {

      document.getElementById('rankinginfoOS').className = "";
      document.getElementById('rankinginfoOS').textContent = "";
    }

    this.cardsRef.current.ReBet();
    this.dealerCardsContainer.current.ReBet();

    this.betchipactivated = false;
    this.buydrawchipactivated = false;
    this.ConfirmbuydealercardactivePopup = false;
    this.resetPyrWnCpsAmn = false;
  }
  handleResize() {
    // console.log("calling resize");
    // document.getElementById("bacaratbgimTP");
    this.handleOrientationChange();
  }

  handleOrientationChange = () => {
    console.log((navigator.userAgentData && navigator.userAgentData.platform &&
      navigator.userAgentData.platform == "Windows"))

    const imgTable = document.querySelector("#pokertableimos");
    this.clertime57 = setTimeout(() => {
      if (imgTable?.getAttribute("src") === "") {
        // src exists but is empty
        imgTable.style.display = "none";
      } else {
        imgTable.style.display = "block";
      }
    }, 50)


    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      if (this.NavigateState) {
      } else {
        window.location.reload()
      }
    } else {
      if (this.NavigateState) {
        window.location.reload()
      } else {
      }
    }

    document.getElementById("buybtnTP").style.opacity = "1"
    this.setState({ disableBuyButton: false })

    if (document.getElementById("optionsmenubuttonTP")) {
      gsap.to('#optionsmenubuttonTP', { autoAlpha: 0 })
    }
    this.setState({ isoptionmenu: false, ShowLimits: false, ShowGamerules: false });

    if (document.getElementById("histry_oasis")) {
      document.getElementById("histry_oasis").className = "";

    }
    if (document.getElementById("exithistoryTP")) {
      document.getElementById("exithistoryTP").className = "";

    }
    if (document.getElementById("prevhistoryTP")) {
      document.getElementById("prevhistoryTP").className = "";

    }
    if (document.getElementById("histry_bodyOS")) {
      document.getElementById("histry_bodyOS").className = "";
    }
    if (document.getElementById("heading_hstiryOS")) {
      document.getElementById("heading_hstiryOS").className = "";

    }
    const isPortrait = window.innerHeight > window.innerWidth;
    if (isPortrait) {
      // console.log(" -----------  PORT     -------------------");
      this.setState({
        myOrient: "port",
      });
    } else {
      // console.log(" -----------  LAND     -------------------");
      this.setState({
        myOrient: "land",
      });
    }


    const betactiveElement = document.getElementById("betactiveOS");
    const tropicaldeck = document.getElementById("tropicaldeck");

    const bacaratbgimTP = document.getElementById("bacaratbgimTP");
    const pokertable = document.getElementById("pokertableimos");
    const pokertablelnspe = document.getElementById("pokertablelandscapeos");
    const useriddetl = document.getElementById("useridTP");
    const russiantiname = document.getElementById("tropicaltitle");
    const russianlabel = document.getElementById("tropicaltitle");
    const russianbncicon = document.getElementById("balnceiconTP");
    const exitbtnTP = document.getElementById("exitbtnTP");
    const beticonrussian = document.getElementById("beticonTP");
    const winnericonrussian = document.getElementById("winnericonTP");
    const informi = document.getElementById("infrmiconTP");
    const optionrussianbtn = document.getElementById("TspoptionTP");
    const volumeRussianimg = document.getElementById("volumeTropical");
    const buydrawRussiangme = document.getElementById("buydrawTropical");
    const betRussiangme = document.getElementById("betTropical");
    const betcirclerussian = document.getElementById("TPbetcircle");
    const betchipincrementbtn = document.getElementById("betincrenetTP");
    const betchipdecrementbtn = document.getElementById("betdecrementTP");
    const betchipsRussianpoker = document.getElementById("betchipsTP");

    const Russianbgwindowsimg = document.getElementById("Tropicalbgwindows");
    const Russiantblewindows = document.getElementById("Osntblewindows");
    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    const drawbutton = document.getElementById("drawbtnTP");
    const buybutton = document.getElementById("buybtnTP");
    const drwtext = document.getElementById("drawtextTP");
    const betbtntextTP = document.getElementById("betbtntextTP");
    const foldbtntext = document.getElementById("foldtextTP");
    const dealerBuyCardElement = document.getElementById("dealerBuyCardOS");
    const dealerChipsAddToBuyElement = document.getElementById("dealerChipsAddToBuyButtonOS");
    const winpopuprspelement = document.getElementById("winpopup_TP");
    const playerDetailsElement = document.getElementById("playerDetailsTP");
    const containerPlayerdealerElement = document.getElementById("container_playerdealerOS");
    const chipsstoredcontainerElement = document.getElementById('chipsstoredcontainerTP');
    const minmaxbetsElement = document.getElementById("minmaxbetsTP")

    const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_greaterthanbalnceTP");
    const cardDeckDivElment = document.getElementById("TropicaPokerDeck")



    containerPlayerdealerElement.className = "";
    playerDetailsElement.className = "";
    minmaxbetsElement.className = "";



    bacaratbgimTP.style.cssText = "";

    optionrussianbtn.src = "";
    optionrussianbtn.style.cssText = "";

    betcirclerussian.src = "";
    betcirclerussian.style.cssText = "";

    russianbncicon.src = "";
    russianbncicon.style.cssText = "";

    beticonrussian.src = "";
    beticonrussian.style.cssText = "";

    exitbtnTP.src = "";
    exitbtnTP.style.cssText = "";


    winnericonrussian.src = "";
    winnericonrussian.style.cssText = "";

    informi.src = "";
    informi.style.cssText = "";


    volumeRussianimg.src = "";
    volumeRussianimg.style.cssText = "";

    betchipincrementbtn.src = "";
    betchipincrementbtn.style.cssText = "";

    // betchipsRussianpoker.src = "";
    // betchipsRussianpoker.style.cssText="";

    betchipdecrementbtn.src = "";
    betchipdecrementbtn.style.cssText = "";


    useriddetl.src = "";
    useriddetl.style.cssText = "";
    // betactiveElement.className = ""

    dealerBuyCardElement.className = "";
    dealerChipsAddToBuyElement.className = "";
    winpopuprspelement.className = "";
    if (chipsstoredcontainerElement !== null) {
      chipsstoredcontainerElement.className = "";
    }

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      this.tableImg = loadedwindowimg;

      this.setState({
        heightOfLayer: 1105,
        widthOfLayer: 2200,
        // dealerDistanceFromX: 250,
        // playerDistanceFromX: 1020,    
        dealerDistanceFromX: 590,
        playerDistanceFromX: 580,
        dealerDistanceFromY: -195,
        PlayerDistanceFromY: 330,
        // PlayerDistanceFromY: 450,
        isMobilePortraitLndsp: false,
        scaleX: 1.8,
        scaleY: 1.8,
        activeScreen: 0
      });
      this.isMobile = false;
      this.systemOS = "Windows";
      document.getElementById("topcardscontainerTP").classList.remove("topcardsOS");
      document.getElementById("betcontainerTP").classList.remove("betpannelOasis");
      document.getElementById("betcontainerTP").classList.add("betpannelrussianwindowsOS");
      playerDetailsElement.classList.add("playerIdDetailswindowsOS");
      document.getElementById("infocontainerTP").style.display = "block"
      document.getElementById("landscapeInfoTP").style.display = "none";

      containerPlayerdealerElement.classList.add("container_playerdealerOS");
      if (russiantiname) {
        russiantiname.src = russiantitle;
        russiantiname.style.cssText = "";

      }
      tropicaldeck.src = Russiandeck
      Object.assign(tropicaldeck.style, porttraitejson.tropicaldeck)

      drwtext.classList.remove("drawtextportraiteOS");
      betbtntextTP.classList.remove("betportraiteOS");
      foldbtntext.classList.remove("foldtextportraiteOS");

      drwtext.classList.add("drawtextwindowsOS");
      betbtntextTP.classList.add("betwindowsOS");
      foldbtntext.classList.add("foldtextwindowsOS");
      document.getElementById("antetextTP").classList.remove("antetextlnspeOS,antetextportraiteOA");
      document.getElementById("antetextTP").classList.add("antetextwindowsOS");
      drwtext.classList.remove("drawtextlandspeOS");
      betbtntextTP.classList.remove("betLandscapeOS");
      foldbtntext.classList.remove("foldtextLandscapeOS");

      Russianbgwindowsimg.style.background = `url(${Tropicalbgwindows})`;

      Object.assign(Russianbgwindowsimg.style, porttraitejson.russianbgwindows)

      // Russiantblewindows.src = Rutablewindows;
      // Object.assign(Russiantblewindows.style, porttraitejson.russtablewindows)


      optionrussianbtn.src = optionbtnwindows;

      Object.assign(optionrussianbtn.style, porttraitejson.optionbtnwindows)

      russianbncicon.src = balanceiconwindows;
      Object.assign(russianbncicon.style, porttraitejson.balanceiconwindows)

      document.getElementById("balance").classList.remove("balanceportraiteOS,balancelndscapeOS");
      document.getElementById("balance").classList.add("balancewindowsOS");

      useriddetl.src = useridlmg;
      Object.assign(useriddetl.style, porttraitejson.useridwindowsTP)



      document.getElementById("useridtextTP").classList.remove("useridportraiteOS,useridlandscapeOS");
      document.getElementById("useridtextTP").classList.add("useridwindowsOS");

      beticonrussian.src = beticonwindows;

      Object.assign(beticonrussian.style, porttraitejson.beticonwindows);
      document.getElementById("betsTP").classList.remove("betslandspeOS,betsportraiteOS");
      document.getElementById("betsTP").classList.add("betswindowsOS");



      if (russiantiname) {
        russiantiname.src = russiantitle;
        Object.assign(russiantiname.style, porttraitejson.russiantitlewindows);

      }

      winnericonrussian.src = winnericnwindows;
      Object.assign(winnericonrussian.style, porttraitejson.winnericonwindows);

      document.getElementById("winsTP").classList.remove("winslandspeOS,winsportraiteOS");
      document.getElementById("winsTP").classList.add("winswindowsOS");

      informi.src = informicon;
      Object.assign(informi.style, porttraitejson.infrmicnlnspewindows);

      volumeRussianimg.src = volumeimg;
      Object.assign(volumeRussianimg.style, porttraitejson.volumewindows);


      betchipincrementbtn.src = betincerementdecrement;
      Object.assign(betchipincrementbtn.style, porttraitejson.beincrementwindows);


      betchipdecrementbtn.src = betincerementdecrement;
      Object.assign(betchipdecrementbtn.style, porttraitejson.bedecrementwindows);

      betcirclerussian.src = russianbetcle;
      Object.assign(betcirclerussian.style, porttraitejson.becirclewindows);


      buydrawRussiangme.src = russianbetbtnleft;
      Object.assign(buydrawRussiangme.style, porttraitejson.drawbuybtnwindows);

      document.getElementById("buydrawtextOS").classList.add("buydrawtextOS");

      betRussiangme.src = russianbetbtndown;
      Object.assign(betRussiangme.style, porttraitejson.betbtnwindows);

      document.getElementById("bettextOS").classList.remove("bettextlndspeOS,bettextportraiteOS");
      document.getElementById("bettextOS").classList.add("bettextOS");


      document.getElementById("playerDealerCardContainerTP").classList.remove("stage-top-mobile-portrait_OS");
    } else {
      tropicaldeck.src = Russiandeck
      cardDeckDivElment.className = ""
      document.getElementById("infoTropicalP").className = "";
      document.getElementById("infoTroppicalland").className = "";

      document.getElementById("crdscoverOS").className = "";
      document.getElementById("crdscoverOS").cssText = "";

      popupbetGreaterthanBalnceElement.className = "";

      document.getElementById("playerDealerCardContainerTP").classList.remove("stage-top-mobile-portrait_OS");
      document.getElementById("playerDealerCardContainerTP").classList.remove("stage-top-mobile-landscape_OS");
      let betcontainerElement = document.getElementById("betcontainerTP");

      Russianbgwindowsimg.style.cssText = "";
      useriddetl.src = "";
      useriddetl.style.cssText = "";

      bacaratbgimTP.style.cssText = "";

      optionrussianbtn.src = "";
      optionrussianbtn.style.cssText = "";

      russianbncicon.src = "";
      russianbncicon.style.cssText = "";

      beticonrussian.src = "";
      beticonrussian.style.cssText = "";

      exitbtnTP.src = "";
      exitbtnTP.style.cssText = "";

      russiantiname.className = "";
      if (russiantiname) {
        russiantiname.src = russiantitle;
        russiantiname.style.cssText = "";
      }
      winnericonrussian.src = "";
      winnericonrussian.style.cssText = "";

      informi.src = "";
      informi.style.cssText = "";

      volumeRussianimg.src = "";
      volumeRussianimg.style.cssText = "";

      betchipsRussianpoker.src = "";
      betchipsRussianpoker.style.cssText = "";

      betchipincrementbtn.src = "";
      betchipincrementbtn.style.cssText = "";

      betchipdecrementbtn.src = "";
      betchipdecrementbtn.style.cssText = "";

      let chipsElementText = document.getElementById("val0");
      betcontainerElement.style.cssText = "";
      chipsElementText.className = "";
      let chipsElmtextclass = "";

      const betTextaddtoBetElement = document.getElementById("betTextaddtoBetTP");

      if (this.betchipactivated === true) {
        if (isPortrait) {
          gsap.to(this.chipbetref.current, {
            x: 213,
            // x: -27,
            y: -625,
            duration: 0.000001
          });


          gsap.to(betTextaddtoBetElement, {
            x: 244,
            y: -1230,
            duration: 0.000001
          });

        } else {
          gsap.to(this.chipbetref.current, {
            x: -527,
            y: -198,
            duration: 0.000001
          });


          gsap.to(betTextaddtoBetElement, {
            x: -527,
            y: -198,
            duration: 0.000001

          });


        }

      } else {
        this.betchipactivated = false;
      }


      if (this.buydrawchipactivated === true) {
        if (isPortrait) {
          gsap.to(this.chipdrawref.current, {
            x: 389,
            y: -741,
            duration: 0.000001,
          });
        } else {
          gsap.to(this.chipdrawref.current, {
            x: -406,
            y: 169,
            duration: 0.000001,
          });
        }
      } else {
        this.buydrawchipactivated = false
      }

      const confirmbuydealerPopupElement = document.getElementById("confirmbuydealer_popupTP");
      if (this.ConfirmbuydealercardactivePopup === true) {
        confirmbuydealerPopupElement.display = "block"
        confirmbuydealerPopupElement.className = "";
        if (isPortrait) {
          confirmbuydealerPopupElement.classList.add("popup_cnfrmbuydealrcardPortrait_OS");
          // confirmbuydealerPopupElement.classList.add("popup_cnfrmbuydealrcardLndsp_OS");
        } else {
          // confirmbuydealerPopupElement.classList.remove("popup_cnfrmbuydealrcardPortrait_OS");
          confirmbuydealerPopupElement.classList.add("popup_cnfrmbuydealrcardLndsp_OS");
        }

      } else {
        this.ConfirmbuydealercardactivePopup = false;
      }


      switch (this.state.count) {
        case 1:
          betchipsRussianpoker.src = chip_10;
          chipsElementText.textContent = this.chipVal[0].label;
          chipsElmtextclass = "valtextPortrait1OS";

          break;
        case 2:
          betchipsRussianpoker.src = chip_25;
          chipsElementText.textContent = this.chipVal[1].label;
          chipsElmtextclass = "bet-text-addtoBet20OS";
          break;
        case 3:
          betchipsRussianpoker.src = chip_50;
          chipsElementText.textContent = this.chipVal[2].label;
          chipsElmtextclass = "bet-text-addtoBet20OS";
          break;
        case 4:
          betchipsRussianpoker.src = chip_100;
          chipsElementText.textContent = this.chipVal[3].label;
          chipsElmtextclass = "bet-text-addtoBet20OS";
          break;
        case 5:
          betchipsRussianpoker.src = chip_500;
          chipsElementText.textContent = this.chipVal[4].label;
          chipsElmtextclass = "bet-text-addtoBet20OS";
          break;
        case 6:
          betchipsRussianpoker.src = chip_1000;
          chipsElementText.textContent = this.topLable_rsp(this.chipVal[5].val);
          chipsElmtextclass = "bet-text-addtoBet20OS";
          break;

        default:
          break;

      }


      const rankinginfodelerElement = document.getElementById("rankinginfodelerOS");
      const rankinginfoElement = document.getElementById("rankinginfoOS");
      rankinginfodelerElement.className = "";
      rankinginfoElement.className = "";
      rankinginfoElement.style.cssText = "";

      betbtntextTP.className = "";
      foldbtntext.className = "";

      winpopuprspelement.classList.add("winPopupForMptIntlOS");
      let betchipsdraw = document.getElementById("betchipsaddtodrawOS");
      // betchipsdraw.classList.remove("betchipsaddtodrawPositionOS")
      const winamtElement12 = document.getElementById("winamt_TPS");
      if (isPortrait) {
        this.tableImg = loadedportaiteimg;
        document.getElementById("infocontainerTP").style.display = "block"
        document.getElementById("landscapeInfoTP").style.display = "none";

        console.log(this.state.Winnindanimation)
        if (this.state.Winnindanimation) {
          gsap.to("#chipcenterpositionTP", { autoAlpha: 0, zIndex: -10 });
          gsap.to("#betchipsaddtobetTP", {
            autoAlpha: 0, zIndex: -10, onComplete: () => {
              // betText.textContent = this.topLable_rsp( Number((res.anteWinAmount + res.winAmount).toFixed(2)));
            }
          });
          gsap.to("#betTextaddtoBetTP", { autoAlpha: 0, zIndex: -10 });

          winpopuprspelement.classList.add("winPopupForMptSwOS");
          winamtElement12.classList.add("winamtMpSwOS");
          winpopuprspelement.classList.remove("winPopupForMLspOS");
        }
        if (this.state.AnteWinCHanimation) {
          gsap.to("#dealerchipTP", { autoAlpha: 0, zIndex: -10, autoAlpha: 0 });
        }

        if (this.state.PayoutTableToggle) {
          if (document.getElementById("PAYOUTTABLETPS")) {
            document.getElementById("PAYOUTTABLETPS").classList.add("showPayoutOSprtrt")
            document.getElementById("PAYOUTTABLETPS").classList.remove("showPayoutLandscpeOS")
          }
        }

        if (this.state.betshigh_balnce !== null) {
          popupbetGreaterthanBalnceElement.classList.add("popupbetshighPortraitOS")
        }

        document.getElementById("infoTropicalP").classList.add("portraitinfoOS");
        minmaxbetsElement.classList.add("minmaxbets_portraitOS");

        drwtext.classList.remove("drawtextlandspeOS");
        drwtext.classList.remove("drawtextwindowsOS");

        if (this.state.drawbtnnewClass) {
          //  betchipsdraw.classList.add("betchipsaddtodrawPositionOS")
        }

        // document.getElementById("antetextTP").classList.remove("antetextwindowsOS");
        document.getElementById("antetextTP").classList.remove("antetextlnspeOS,antetextwindowsOS");


        containerPlayerdealerElement.classList.add("cntr_pyrdlr_prtOS");
        document.getElementById("Player").style.fontSize = "80px"
        // pokertablelnspe.src = "";
        // pokertablelnspe.style.cssText = "";

        playerDetailsElement.classList.add("playerIdDetailsPortraitOS");
        document.getElementById("playerDealerCardContainerTP").classList.add("stage-top-mobile-portrait_OS");
        document.getElementById("topcardscontainerTP").classList.add("topcardsOS");

        Object.assign(betcontainerElement.style, porttraitejson.betpannelrussianPortrait);

        drwtext.classList.add("drawtextportraiteOS");
        betbtntextTP.classList.add("betportraiteOS");
        foldbtntext.classList.add("foldtextportraiteOS");
        document.getElementById("antetextTP").className = "";
        document.getElementById("antetextTP").classList.add("antetextportraiteOA");
        if (document.getElementById("val0") && chipsElmtextclass !== "") {
          document.getElementById("val0").classList.add("valtextPortraitOS", chipsElmtextclass);
        } else {
          document.getElementById("val0").classList.add("valtextPortraitOS");
        }

        bacaratbgimTP.style.background = `url(${oasisPoBG})`;
        bacaratbgimTP.style.backgroundSize = "cover";
        bacaratbgimTP.style.width = porttraitejson.bacaratbg.width;
        bacaratbgimTP.style.height = porttraitejson.bacaratbg.height;
        bacaratbgimTP.style.backgroundSize = porttraitejson.bacaratbg.background;
        bacaratbgimTP.style.left = 0;

        // betchipsRussianpoker.src = betchipsRussian;
        Object.assign(betchipsRussianpoker.style, porttraitejson.betchp);


        betchipincrementbtn.src = betincerementdecrement;
        Object.assign(betchipincrementbtn.style, porttraitejson.beincrementportraite);

        betchipdecrementbtn.src = betincerementdecrement;
        Object.assign(betchipdecrementbtn.style, porttraitejson.bedecrement)


        volumeRussianimg.src = volumeimg;
        Object.assign(volumeRussianimg.style, porttraitejson.volume)

        buydrawRussiangme.src = russianbetbtnleft;
        buydrawRussiangme.style.position = porttraitejson.drawbuybtn.position;
        buydrawRussiangme.style.width = porttraitejson.drawbuybtn.width;
        buydrawRussiangme.style.height = porttraitejson.drawbuybtn.height;
        buydrawRussiangme.style.top = porttraitejson.drawbuybtn.top;
        buydrawRussiangme.style.left = porttraitejson.drawbuybtn.left;
        document.getElementById("buydrawtextOS").className = "";

        document.getElementById("buydrawtextOS").classList.add("buydrawtextportraiteOS");

        betRussiangme.src = russianbetbtndown;

        Object.assign(betRussiangme.style, porttraitejson.betbtnTP);


        document.getElementById("bettextOS").className = "";

        document.getElementById("bettextOS").classList.add("bettextportraiteOS");

        betcirclerussian.src = russianbetcle;
        Object.assign(betcirclerussian.style, porttraitejson.becircle);

        // optionrussianbtn.style.display = "none";
        optionrussianbtn.src = optionbtn;
        Object.assign(optionrussianbtn.style, porttraitejson.optionbtn);

        dealerBuyCardElement.classList.add('dealerBuyCardOS');
        dealerChipsAddToBuyElement.classList.add('dealerBuyCardDrawButtonPortraitOS');


        if (pokertable) {
          // pokertable.src = pokertableruss;
          // pokertable.style.backgroundSize = "cover";

          // Object.assign(pokertable.style, porttraitejson.pokertable);
        }

        // russianbncicon.src = balanceicon;
        russianbncicon.src = balanceiconwindows;
        Object.assign(russianbncicon.style, porttraitejson.balanceiconportraite);


        document.getElementById("balance").className = "";
        document.getElementById("balance").classList.add("balanceportraiteOS");
        // document.getElementById("balance").classList.remove("balancelndscapeOS");

        // beticonrussian.src = beticonTP;
        beticonrussian.src = beticonwindows;

        Object.assign(beticonrussian.style, porttraitejson.beticonTP);


        document.getElementById("betsTP").className = "";
        // document.getElementById("betsTP").classList.remove("betslandspeOS");
        document.getElementById("betsTP").classList.add("betsportraiteOS");

        // exitbtnTP.src = exitrussian;
        Object.assign(exitbtnTP.style, porttraitejson.exit);



        if (russiantiname) {
          russiantiname.src = russiantitle;

          Object.assign(russiantiname.style, porttraitejson.russiantitle);


        }

        winnericonrussian.src = winnericn;
        Object.assign(winnericonrussian.style, porttraitejson.winnericonTP);



        document.getElementById("winsTP").className = "";
        document.getElementById("winsTP").classList.add("winsportraiteOS");

        informi.src = informicon;
        Object.assign(informi.style, porttraitejson.infrmicn);


        useriddetl.src = useridlmg;
        Object.assign(useriddetl.style, porttraitejson.useridportraiteTP);

        document.getElementById("useridtextTP").className = "";
        document.getElementById("useridtextTP").classList.add("useridportraiteOS");



        if (this.state.pokerrankingdeler !== "") {
          document.getElementById('rankinginfodelerOS').className = "";
          rankinginfodelerElement.classList.add("pokerrankingdelerPortraitOS")
        } else {
          document.getElementById('rankinginfodelerOS').className = "";

        }

        if (this.state.pokerranking !== "") {
          rankinginfoElement.classList.add("pokerrankingPortaitOS")
        } else {
          document.getElementById('rankinginfoOS').className = "";
        }


        if (this.state.isMobilePortraitLndsp) {
          rankinginfoElement.style.left = "35%";
        }


        cardDeckDivElment.classList.add("cardDeckPortraitOS")
        this.setState({
          // heightOfLayer: 1500,
          heightOfLayer: 1200,
          widthOfLayer: 800,
          // widthOfLayer: 550,
          dealerDistanceFromX: -280,
          playerDistanceFromX: -120,

          dealerDistanceFromY: -150,
          PlayerDistanceFromY: 720,
          // PlayerDistanceFromY: 650,
          isMobilePortraitLndsp: true,
          scaleX: 2.8,
          scaleY: 2.8,
          activeScreen: 1,
          betactvglwcss: "betactivePortraitOS",
          betbuttoncss: porttraitejson.Betbtnportraite,
          betbtntextcss: "betportraitOS",
          foldbuttoncss: porttraitejson.foldbtnportraite,
          foldbtntextcss: "rebettextportraitOS",
          buybtncss: porttraitejson.Buybtnportraite,
          buybtntxtcss: "buytextPortraitOS",
          drawbtncss: porttraitejson.Drawbtnportraite,
          drawbtntxtcss: "drawtextPortraitOS",
          betchipstoantebetcss: porttraitejson.Betchiptoanteprotrait,
          chipsstoredcontainercss: "",
          antebetpdvcss: "chip-center-position-OS",
          antechpimgcss: "chip20centerpositionPortraitOS",
          antespntxtcss: "antebetChipPortrait20OS",
          betchiptobetbtncss: porttraitejson.BetchiptobetPortrait,
          // betbtntxtcss:"bet-text-addtoBet-portrait",
          betbtntxtcss: `bet-text-addtoBet-portrait-OS ${chipsElmtextclass}`,
          buydrawcontainer: "drawChipDivOS",
          drawchipcss: "betchipsaddtodrawOS",
          // drawchiptextcss:"betTextaddtodrawOS" ,
          drawchiptextcss: `betTextaddtodrawOS ${chipsElmtextclass}`,
          dealerhandcss: "pokerrankingdelerPortraitOS",
          playerhandcss: "pokerrankingPortaitOS",
          mobileAntiMaskCovercss: "mobileAntiMaskCoverOS",
          betpannelrussiancovercss: "PlayerCardpannelcoverPortraitOS",
          rankinginfodelercss: "pokerrankingdelerPortraitOS",
          inforussiancss: "portraitinfoOS",
          drawChipXd: 350,
          drawChipYd: -2500,
          drawChipRetrunXd: 608,
          drawChipRetrunYd: -116,
          DelarAnteWinProLandAN: porttraitejson.dealerchipstoplayerPortrait
        })

      } else {
        this.tableImg = loadedLandimg;
        document.getElementById("playerDealerCardContainerTP").classList.add("stage-top-mobile-landscape_OS");
        document.getElementById("landscapeInfoTP").style.display = "block";
        document.getElementById("infocontainerTP").style.display = "none"

        console.log(this.state.Winnindanimation)
        if (this.state.Winnindanimation) {

          gsap.to("#chipcenterpositionTP", { autoAlpha: 0, zIndex: -10 });
          gsap.to("#betchipsaddtobetTP", {
            autoAlpha: 0, zIndex: -10, onComplete: () => {
              // betText.textContent = this.topLable_rsp( Number((res.anteWinAmount + res.winAmount).toFixed(2)));
            }
          });
          gsap.to("#betTextaddtoBetTP", { autoAlpha: 0, zIndex: -10 });
          winpopuprspelement.classList.add("winPopupForMLspOS");
          winamtElement12.classList.add("winamtMpSwOS");
          winpopuprspelement.classList.remove("winPopupForMptSwOS");

        }
        if (this.state.AnteWinCHanimation) {
          gsap.to("#dealerchipTP", { autoAlpha: 0, zIndex: -10, autoAlpha: 0 });
        }

        if (this.state.PayoutTableToggle) {
          if (document.getElementById("PAYOUTTABLETPS")) {
            document.getElementById("PAYOUTTABLETPS").classList.add("showPayoutLandscpeOS")
            document.getElementById("PAYOUTTABLETPS").classList.remove("showPayoutOSprtrt")
          }
        }

        this.setState({
          // dealerDistanceFromX: -385,
          // playerDistanceFromX: 615,
          // dealerDistanceFromY: 200,
          // PlayerDistanceFromY: 220,
          heightOfLayer: 1050,

          widthOfLayer: 760,
          dealerDistanceFromX: -300,
          playerDistanceFromX: -150,
          // dealerDistanceFromX: -270,
          // playerDistanceFromX: -130,
          dealerDistanceFromY: -330,
          // dealerDistanceFromY: -200,
          PlayerDistanceFromY: 480,
          isMobilePortraitLndsp: true,
          scaleX: 2.8,
          scaleY: 2.8,
          activeScreen: 1,
          betactvglwcss: "betactiveLndspOS",
          betbuttoncss: porttraitejson.Betbtnlndspe,
          betbtntextcss: "betLandscapeOS",
          foldbuttoncss: porttraitejson.foldbtnlndspe,
          foldbtntextcss: "foldtextLandscapeOS",
          buybtncss: porttraitejson.Buybtnlndspe,
          buybtntxtcss: "buytextLndspOS",
          drawbtncss: porttraitejson.Drawbtnlndspe,
          drawbtntxtcss: "drawtextLndspOS",
          betchipstoantebetcss: porttraitejson.betchiplndspe,
          chipsstoredcontainercss: "chipsstoredcontainerLndspOS",
          antebetpdvcss: "chip-center-position-lndsp-OS",
          antechpimgcss: "chip20centerpositionPortraitOS",
          antespntxtcss: "antebetChipPortrait20OS",
          betchiptobetbtncss: porttraitejson.BetchiptobetLndsp,
          // betbtntxtcss:"bet-text-addtoBet-lndsp",
          betbtntxtcss: `bet-text-addtoBet-lndsp-OS ${chipsElmtextclass}`,
          buydrawcontainer: "drawChipDivLndspOS",
          drawchipcss: "betchipsaddtodrawOS",
          // drawchiptextcss:"betTextaddwLndspOS",
          drawchiptextcss: `betTextaddwLndspOS ${chipsElmtextclass}`,
          dealerhandcss: "pokerrankingdelerLndSpeOS",
          playerhandcss: "pokerrankingPlayerLndspOS",
          mobileAntiMaskCovercss: "mobileLndspAntiMaskCoverOS",
          betpannelrussiancovercss: "PlayerCardpannelcoverLndspOS",
          rankinginfodelercss: "pokerrankingdelerLndSpeOS",
          inforussiancss: "lndspinfoOS",
          drawChipXd: -1250,
          drawChipYd: -1000,
          drawChipRetrunXd: 130,
          drawChipRetrunYd: -36,
          DelarAnteWinProLandAN: porttraitejson.dealerchipstoplayerLndsp
        });
        cardDeckDivElment.classList.add("cardDeckLandscapeOS")
        if (this.state.pokerrankingdeler !== "") {
          document.getElementById('rankinginfodelerOS').className = "";
          rankinginfodelerElement.classList.add("pokerrankingdelerLndSpeOS")
        } else {
          document.getElementById('rankinginfodelerOS').className = "";
        }

        if (this.state.pokerranking !== "") {
          document.getElementById('rankinginfoOS').className = "";
          rankinginfoElement.classList.add("pokerrankingPlayerLndspOS")
        } else {
          document.getElementById('rankinginfoOS').className = "";
        }

        if (this.state.isMobilePortraitLndsp) {
          // rankinginfoElement.style.left = "62.5%";
          rankinginfoElement.style.left = "43.5%";
        }

        if (this.state.betshigh_balnce !== null) {
          popupbetGreaterthanBalnceElement.classList.add("popupbetshighLndspOS")
        }
        document.getElementById("infoTroppicalland").classList.add("lndspinfoOS");
        minmaxbetsElement.classList.add("minmaxbets_lndspOS");

        containerPlayerdealerElement.classList.add("cntr_pyrdlr_lnspOS");

        if (chipsstoredcontainerElement) {
          chipsstoredcontainerElement.classList.add("chipsstoredcontainerLndspOS");
        }

        document.getElementById("Player").style.fontSize = "80px";

        document.getElementById("infoTroppicalland").classList.add("lndspinfoOS");


        document.getElementById("topcardscontainerTP").classList.remove("topcardsOS");
        document.getElementById("betcontainerTP").classList.remove("betpannelOasis");

        if (document.getElementById("val0") && chipsElmtextclass !== "") {
          document.getElementById("val0").classList.add("valtextLandscapeOS", chipsElmtextclass);
        } else {
          document.getElementById("val0").classList.add("valtextLandscapeOS");
        }
        Object.assign(betcontainerElement.style, porttraitejson.betpannelrussianIandscape);

        drwtext.classList.remove("drawtextportraiteOS");

        drwtext.classList.remove("drawtextwindowsOS");
        // foldbtntext.className = "";
        // betbtntextTP.className = "";

        drwtext.classList.add("drawtextlandspeOS");
        betbtntextTP.classList.add(this.state.betbtntextcss);
        foldbtntext.classList.add(this.state.foldbtntextcss);
        // betbtntextTP.classList.add("betLandscapeOS");
        // foldbtntext.classList.add("foldtextLandscapeOS");

        betcirclerussian.src = "";
        betcirclerussian.style.cssText = "";
        betRussiangme.src = "";
        betRussiangme.style.cssText = "";


        buydrawRussiangme.src = "";
        buydrawRussiangme.style.cssText = "";


        playerDetailsElement.classList.add("playerIdDetailsLandscapeOS");
        bacaratbgimTP.style.background = `url(${landscapebg})`;
        bacaratbgimTP.style.backgroundSize = "cover";
        bacaratbgimTP.style.width = porttraitejson.bacaratbg.width;
        bacaratbgimTP.style.height = porttraitejson.bacaratbg.height;
        bacaratbgimTP.style.left = 0;

        dealerBuyCardElement.classList.add('dealerBuyCardLndspOS');
        dealerChipsAddToBuyElement.classList.add('dealerBuyCardDrawButtonPortraitOS');
        Object.assign(betchipsRussianpoker.style, porttraitejson.betchiplndspe);

        russiantiname.src = russiantitle;
        Object.assign(russiantiname.style, porttraitejson.russiantitlelndscape);


        buydrawRussiangme.src = russianbetbtnleft;
        Object.assign(buydrawRussiangme.style, porttraitejson.drawbuybtnlndspe);


        document.getElementById("buydrawtextOS").className = "";

        document.getElementById("buydrawtextOS").classList.add("buydrawtextlndspeOS");

        document.getElementById("antetextTP").className = "";
        document.getElementById("antetextTP").classList.add("antetextlnspeOS");

        betRussiangme.src = russianbetbtndown;
        Object.assign(betRussiangme.style, porttraitejson.betbtnlndspe);


        document.getElementById("bettextOS").className = "";
        document.getElementById("bettextOS").classList.add("bettextlndspeOS");

        betcirclerussian.src = russianbetcle;
        Object.assign(betcirclerussian.style, porttraitejson.becirclelndspe);


        volumeRussianimg.src = volumeimg;
        Object.assign(volumeRussianimg.style, porttraitejson.volumelnspe);


        useriddetl.src = useridlmg;
        Object.assign(useriddetl.style, porttraitejson.useridlndspe);


        document.getElementById("useridtextTP").className = "";
        document.getElementById("useridtextTP").classList.add("useridlandscapeOS");

        // optionrussianbtn.style.display = "none";
        optionrussianbtn.src = optionbtn;
        Object.assign(optionrussianbtn.style, porttraitejson.optionbtnlandspe);

        beticonrussian.src = beticonwindows;
        // beticonrussian.src = beticonTP;
        Object.assign(beticonrussian.style, porttraitejson.beticonlandspe);


        document.getElementById("betsTP").className = "";
        document.getElementById("betsTP").classList.add("betslandspeOS");
        // beticonrussian.style.transform =porttraitejson.beticonlandspe.transform;

        // russianbncicon.src = balanceicon;
        russianbncicon.src = balanceiconwindows;
        Object.assign(russianbncicon.style, porttraitejson.balanceiconlndspe);


        document.getElementById("balance").className = "";
        document.getElementById("balance").classList.add("balancelndscapeOS");
        // russianbncicon.style.transform = porttraitejson.balanceicon.transform;

        // exitbtnTP.src = exitrussian;
        Object.assign(exitbtnTP.style, porttraitejson.exitlanspe);


        winnericonrussian.src = winnericn;
        Object.assign(winnericonrussian.style, porttraitejson.winnericonlndspe);


        document.getElementById("winsTP").className = "";
        document.getElementById("winsTP").classList.add("winslandspeOS");

        informi.src = informicon;
        Object.assign(informi.style, porttraitejson.infrmicnlnspe);

        betchipincrementbtn.src = betincerementdecrement;
        Object.assign(betchipincrementbtn.style, porttraitejson.betincreamentlndspe);



        betchipdecrementbtn.src = betincerementdecrement;
        Object.assign(betchipdecrementbtn.style, porttraitejson.bedecrementlndspe);

      }

      const drawtextElement = document.getElementById("drawtextTP");
      if (drawtextElement) {
        drawtextElement.classList.add("drawtextautoAlphaOS");
      }

    }
  };

  showPreviousBetsStatus = () => {
    const { response } = this.props.gameState;
    console.log(response)
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      if (response) {
        document.getElementById("betpannelTropicalcover").style.display = "block";
        document.getElementById("betpannelTropicalcover").classList.add("bet_pannelcoverOS");
      }
      else {
        document.getElementById("betpannelTropicalcover").style.display = "none";
        document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelcoverOS");

      }
    }

    if (response) {
      this.buyCardUnsequenceArray = [...this.props?.gameState?.response?.playerFinalCards];

      this.highlightPlayerCardsName(response.playerHand);

      this.setState({
        anteBetAmount: response.anteBetAmount,
        // playerrankinghand: handrank

      });

      switch (response.action) {
        case "PARAM_BET":

          this.showcardsAdBetsParamState(response, response.playerFinalCards, response.dealerCards);
          this.showParamBetStatus(false);
          this.ShowbonusstatusTousr(response);

          this.setState({
            infoText: response.message
          })

          break;
        case "BET":
          this.showrussianPokerresp(response);
          break;
        case "FOLD":
          // this.Show_FoldHandresp(response);
          if (
            (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
            (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
          ) {

            const drawbutton = document.getElementById("drawbtnTP");
            const buybutton = document.getElementById("buybtnTP");
            const betbutton = document.getElementById("betbtnTP");
            const foldbutton = document.getElementById("FoldbtnTP");

            const drawtextElement = document.getElementById("drawtextTP");
            const betbtntextElement = document.getElementById("betbtntextTP");
            const foldtextElement = document.getElementById("foldtextTP");

            betbtntextElement.textContent = "";
            foldtextElement.textContent = "";
            drawtextElement.textContent = "";

            drawbutton.src = "";
            drawbutton.style.cssText = "";
            buybutton.src = "";
            buybutton.style.cssText = "";

            betbutton.src = "";
            betbutton.style.cssText = "";


            foldbutton.src = "";
            foldbutton.style.cssText = "";
            this.Show_FoldHandresp(response);

          } else {
            this.showPlayerorDealerorFold(response);
          }

          break;
        case "CONFIRM_FOLD":
          // this.Show_FoldHandresp(response);
          if (
            (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
            (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
          ) {
            this.Show_FoldHandresp(response);

          } else {
            this.showPlayerorDealerorFold(response);
          }


          break;
        case "REPLACE_CARDS":
          this.replaceCards = []
          // this.ShowrpReplaceCards(response);
          this.drawReplaceCards = true;

          this.ShowBuyplayercardresp(response, 'REPLACE_CARDS');


          break;

        default:
          return []
      }

    }




  }


  showcardsAdBetsParamState = (response, playerFinalCards, dealerCards) => {
    setTimeout(() => {
      this.setState({
        totalbet: response.totalBetAmount,
      })
    }, 250)

    let convrAntebt = this.topLable_rsp(response.anteBetAmount);
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      if (Number(response.anteBetAmount) > 0) {
        let antebetstatebetamount = this.topLable_rsp(response.anteBetAmount)
        this.setState((prevState) => ({
          storebetchips: [
            ...prevState.storebetchips,
            <div id="chipcenterpositionTP">
              <img id="centerchipsTP" className="chip10centerpositionGO"
                src={this.ReturnChipBasedAmount(response.anteBetAmount)}
                // src={chip_10}
                alt="Chip 10"
              />
              <span id="antebetval_10TP" className="antebet_textval10OS">{antebetstatebetamount}</span>
            </div>

          ],
        }));
      }

      if (response.playerBuyCardAmount > 0 || response.playerReplaceCardAmount > 0) {

        gsap.set("#betchipsaddtodrawOS", { clearProps: "transform" });
        setTimeout(() => {
          gsap.to("#betchipsaddtodrawOS", {
            x: -1084,
            y: -598,
            duration: 0.1
          });
        }, 10);

        let betexttodraw = document.getElementById("betchipsaddtodrawTextTP");
        betexttodraw.classList.add("bet-text-addtodrawOS", "bet-text-addtoinsurence10OS")
        gsap.to("#betTextaddtodrawOS", { autoAlpha: 2, zIndex: 15 })
        let betchipsdraw = document.getElementById("betchipsaddtodrawOS");


        // console.log(betexttodraw)

        let betTextaddtoBetClass = "bet-text-addtodraw20OS";
        // this.setState((prevState) => ({
        //   totalbet: prevState.totalbet + prevState.anteBetAmount

        // }));
        let buyreplacestatebet
        // Object.assign(betchipsdraw.style,porttraitejson.drawchpgamestatewindows)
        Object.assign(betchipsdraw.style, porttraitejson.betchipsdrawwindows)

        if (response.playerBuyCardAmount > 0) {

          betchipsdraw.src = chip_10;
          buyreplacestatebet = this.topLable_rsp(response.playerBuyCardAmount)
          betexttodraw.textContent = buyreplacestatebet
          gsap.to("#betchipsaddtodrawOS", { x: -4, y: -2, duration: 0.1 })
          document.getElementById("betchipsaddtodrawTextTP").classList.add("bet-text-addtodrawOS,bet-text-addtodraw10OS")
          // console.log(betexttodraw)
        }
        else {
          betchipsdraw.src = chip_10;
          buyreplacestatebet = this.topLable_rsp(response.playerReplaceCardAmount)
          document.getElementById("betchipsaddtodrawTextTP").classList.add("bet-text-addtodrawOS,bet-text-addtodraw10OS")
          betexttodraw.textContent = buyreplacestatebet
          // console.log(betexttodraw)
        }
      }
    }
    else {

      if (Number(response.anteBetAmount) > 0) {
        document.getElementById("mobileAntiMaskCoverOS").style.display = "block";
        this.setState((prevState) => ({
          storeantebetchips: [
            ...prevState.storeantebetchips,
            { chip: this.ReturnChipBasedAmount(response.anteBetAmount), chipvalue: convrAntebt, chipcolor1: "valtextPortrait1OS" },

          ],
        }));

      }

    }
    this.shuffledPlayerCards = [...playerFinalCards]
    this.randomDealerCards = []
    for (let m = 0; m < dealerCards.length; m++) {
      if (dealerCards[m] === '-1') {
        this.randomDealerCards.push('xx')

      } else {
        this.randomDealerCards.push(dealerCards[m]);


      }
    }

    let cnt = this.shuffledPlayerCards.length;
    let cnt2 = this.randomDealerCards.length;
    for (let i = 0; i < cnt2; i++) {
      let b1 = this.randomDealerCards[i];
      switch (i) {
        case 0:
          this.dealerCardsContainer.current.showPreviousDealercards("cardZero", b1, cnt);
          break;
        case 1:
          this.dealerCardsContainer.current.showPreviousDealercards("cardOne", b1, cnt);
          break;
        case 2:
          this.dealerCardsContainer.current.showPreviousDealercards("cardTwo", b1, cnt);
          break;
        case 3:
          this.dealerCardsContainer.current.showPreviousDealercards("cardThree", b1, cnt);
          break;
        case 4:
          this.dealerCardsContainer.current.showPreviousDealercards("cardFour", b1, cnt);
          break;
        case 5:
          this.dealerCardsContainer.current.showPreviousDealercards("cardFive", b1, cnt);
          break;
        default:
          break;
      }
    }

    for (let i = 0; i < cnt; i++) {
      let b2 = this.shuffledPlayerCards[i];
      switch (i) {
        case 0:
          this.cardsRef.current.showPreviousPlayercards("cardZero", b2, cnt);
          break;
        case 1:
          this.cardsRef.current.showPreviousPlayercards("cardOne", b2, cnt);
          break;
        case 2:
          this.cardsRef.current.showPreviousPlayercards("cardTwo", b2, cnt);
          break;
        case 3:
          this.cardsRef.current.showPreviousPlayercards("cardThree", b2, cnt);
          break;
        case 4:
          this.cardsRef.current.showPreviousPlayercards("cardFour", b2, cnt);
          break;
        case 5:
          this.cardsRef.current.showPreviousPlayercards("cardFive", b2, cnt);
          // this.cardsRef.current.addCards("cardFive", b2, cnt);
          break;
        default:
          break;
      }

    }
  }

  ShowbonusstatusTousr = (res) => {
    let info = "";
    let spokerranking = "";
    let betactiveOS = ""

    setTimeout(() => {
      this.setState({ drawbuttonhandle: true, disDrawbtn: 1 });
      document.getElementById("drawtextTP").classList.add("drawtextautoAlphaOS");
      document.getElementById("drawbtnTP").classList.add("drwnodropOS");

    }, 500)

    let mode = ""
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      document.getElementById("playerDealerCardContainerTP").classList.add("addpointerOS")
      info = "windowsinfoOS";
      spokerranking = "windowspokerrankingOS";
      betactiveOS = "betactiveOS"
      mode = "Windows"

    } else {
      document.getElementById("betpannelTropicalcover").style.display = "none";
      if (window.innerWidth > window.innerHeight) {
        spokerranking = "pokerrankingPlayerLndspOS";
        info = "lndspinfoOS";
        betactiveOS = this.state.betactvglwcss;
        mode = "landscape";
      } else {
        info = "portraitinfoOS";
        betactiveOS = this.state.betactvglwcss;
        spokerranking = "pokerrankingPortaitOS";
        mode = "portrait";
      }
    }
    if (document.getElementById("infoTropicalP")) {
      document.getElementById("infoTropicalP").classList.add(info);
      document.getElementById("infoTroppicalland").classList.add(info);
    };

    this.setState({
      pokerranking: res.playerHand,
      infoText: res.message,
      multibuttonsebledsble: false,
      disablemultibutton: false

    });

    document.getElementById("rankinginfoOS").className = "";
    document.getElementById("rankinginfoOS").classList.add(spokerranking);

    this.highlightPlayerCardsName(res.playerHand);

    document.getElementById("betactiveOS").src = bnsactiveTP;
    document.getElementById("bettextOS").style.color = "#ffffff";
    if (mode === "Windows") {
      document.getElementById("betTropical").classList.add("addpointerOS");
      document.getElementById("betactiveOS").classList.add(betactiveOS);

    } else {

    }
    this.setState({
      revealCard: true,
      buttontext: "fold",
      betbutton: "Bet",
    });

  }

  showPlayerorDealerorFold = (res) => {

    if (res.message === `Attention! You have a ${res.playerHand}. Are you sure you want to fold?`) {
      this.showcardsAdBetsParamState(res, res.playerFinalCards, res.dealerCards);
      // this.showParamBetStatus(false); //  disble the all button chips,  if we have are you sure you want to fold cards?
      this.ShowbonusstatusTousr(res);
      this.ConfirmbuydealercardactivePopup = true;
      if (res.playerReplaceCardAmount > 0 || res.playerBuyCardAmount > 0) {
        this.drawReplaceCards = true;
        //  if(res.playerBuyCardAmount > 0){
        this.prevstateBuyorDrawChip(res);
      }

      this.setState({
        infoText: res.message,
        cmfrmdealeraction: 2,
        cmfrmdealeractionNO: 2
      })
      const confirmbuydealerPopupElement = document.getElementById("confirmbuydealer_popupTP");
      if (window.innerHeight > window.innerWidth) {

        confirmbuydealerPopupElement.className = "";
        confirmbuydealerPopupElement.style.display = "block";
        confirmbuydealerPopupElement.classList.add("popup_cnfrmbuydealrcardPortrait_OS");
        document.getElementById("alertTxtOS").innerHTML = res.message;
        document.getElementById("alertTxtOS").classList.add('alertTxtPortraitOS');
        document.getElementById("yesTP").classList.add("yesbutton_popup_portraitOS")
        document.getElementById("noTP").classList.add("nobutton_popup_portraitOS")

      }
      else {
        confirmbuydealerPopupElement.classList.add("popup_cnfrmbuydealrcardLndsp_OS");
        document.getElementById("alertTxtOS").innerHTML = res.message;
        document.getElementById("alertTxtOS").classList.add('alertTxtPortraitOS');
        document.getElementById("yesTP").classList.add("yesbutton_popup_portraitOS")
        document.getElementById("noTP").classList.add("nobutton_popup_portraitOS")

      }
    } else {
      const betbutton = document.getElementById("betbtnTP");
      const foldbutton = document.getElementById("FoldbtnTP");
      const betbtntextElement = document.getElementById("betbtntextTP");
      const foldtextElement = document.getElementById("foldtextTP");
      const rankinginfodelerElement = document.getElementById("rankinginfodelerOS");
      const rankinginfoElement = document.getElementById("rankinginfoOS");

      this.setState({
        previousAnteBetAmount: res.anteBetAmount,
        infoText: this.props.language.Place_antebet,
        totalbet: 0,
        anteBetAmount: 0,
        pokerranking: "",
        pokerrankingdeler: "",
        //  totalbet:res.totalBetAmount,,
        betbutton: "REBET",
        buttontext: "REBETX2",
      });


      document.getElementById("betpannelTropicalcover").style.display = "none";
      betbutton.src = Betbtn;
      foldbutton.src = Foldbnwindows;

      betbtntextElement.className = "";
      foldtextElement.className = "";
      rankinginfodelerElement.className = "";
      rankinginfoElement.className = "";

      betbtntextElement.textContent = this.props.language.Rebet;
      foldtextElement.textContent = this.props.language.RebetX2;

      if (Number(res.anteBetAmount) > 0) {
        let convrAntebt = this.topLable_rsp(res.anteBetAmount);
        this.setState((prevState) => ({
          // storeantebetchips: [
          prevStatestoreantebetchips: [
            ...prevState.storeantebetchips,
            { chip: this.ReturnChipBasedAmount(res.anteBetAmount), chipvalue: convrAntebt, chipcolor1: "valtextPortrait1OS" },

          ],
        }));

      }

      if (window.innerHeight > window.innerWidth) {
        // portrait;
        setTimeout(() => {
          if (document.getElementById("chipcenterpositionTP")) {
            gsap.to("#chipcenterpositionTP", { x: 13, y: 1200, duration: 0.000001, zIndex: -2, autoAlpha: 0 });
          }

          if (document.getElementById("betchipsaddtobetTP")) {
            gsap.to("#betchipsaddtobetTP", { x: 1, y: 76, duration: 0.000001, zIndex: -2, autoAlpha: 0 });
            gsap.to("#betTextaddtoBetTP", { x: 153, y: 185, duration: 0.000001, zIndex: -2, autoAlpha: 0 });
          }

          gsap.to(this.chipdrawref.current, { x: 608, y: -116, duration: 0.000001, zIndex: -5, autoAlpha: 0 });

          if (this.buyDealerCardDrawn.current) {
            gsap.to(this.buyDealerCardDrawn.current, { x: 0, y: 0, duration: 0.000001, zIndex: -2, autoAlpha: 0 });
          }

        }, 100);

        // betbtntextElement.classList.add("betportraitOS");
        // Object.assign(betbutton.style, porttraitejson.Betbtnportraite);

        betbtntextElement.classList.add(this.state.betbtntextcss);
        Object.assign(betbutton.style, this.state.betbuttoncss);

        // Object.assign(betbtntextElement.style, porttraitejson.betportraiteTP);
        // Object.assign(foldbutton.style, porttraitejson.foldbtnportraite);
        // foldtextElement.classList.add("rebettextportraitOS");

        Object.assign(foldbutton.style, this.state.foldbuttoncss);
        foldtextElement.classList.add(this.state.foldbtntextcss);

      } else {

        Object.assign(betbutton.style, this.state.betbuttoncss);
        betbtntextElement.classList.add(this.state.betbtntextcss);

        Object.assign(foldbutton.style, this.state.foldbuttoncss);
        foldtextElement.classList.add(this.state.foldbtntextcss);

        setTimeout(() => {

          if (document.getElementById("chipcenterpositionTP")) {
            gsap.to("#chipcenterpositionTP", { x: 0, y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0 });
          }

          if (document.getElementById("betTextaddtoBetTP")) {
            gsap.to("#betTextaddtoBetTP", { x: 0, y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0 });
            gsap.to("#betchipsaddtobetTP", { x: 0, y: 0, duration: 0.0001 });

          }
          if (this.chipdrawref) {
            gsap.to(this.chipdrawref.current, { x: 0, y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0 });
          }

          if (this.buyDealerCardDrawn) {
            gsap.to(this.buyDealerCardDrawn.current, { autoAlpha: 0, x: 0, y: 0, zIndex: -2, duration: 0.0001 })
          }


          if (document.getElementById("dealerchipTP")) {
            gsap.set('#dealerchipTP', { x: 0, y: 0, autoAlpha: 0, zIndex: -10, duration: 0.00001 })
          }

        }, 100)

      }

      setTimeout(() => {

        this.clearActivesWeDid();
      }, 500)

    }

  }

  betChipsIncrementDecremenAction = () => {
    const betchipsRussianpoker = document.getElementById("betchipsTP");
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      document.getElementById("val0").classList.remove("chip_10textOS");
      switch (this.state.count) {
        case 1:
          betchipsRussianpoker.src = chip_10;
          document.getElementById("val0").classList.remove("valtext_windowsOS");
          document.getElementById("val0").textContent = this.chipVal[0].label;
          document.getElementById("val0").classList.add("valtext_windows_chip10OS", "chip_10textOS");

          break;
        case 2:
          document.getElementById("val0").textContent = this.chipVal[1].label;
          document.getElementById("val0").classList.add("valtext_windowsOS");
          betchipsRussianpoker.src = chip_25;
          break;
        case 3:
          document.getElementById("val0").textContent = this.chipVal[2].label;
          document.getElementById("val0").classList.add("valtext_windowsOS");
          betchipsRussianpoker.src = chip_50;

          break;
        case 4:
          document.getElementById("val0").textContent = this.chipVal[3].label;
          document.getElementById("val0").classList.add("valtext_windowsOS");
          betchipsRussianpoker.src = chip_100;

          break;
        case 5:
          document.getElementById("val0").textContent = this.chipVal[4].label;
          document.getElementById("val0").classList.add("valtext_windowsOS");
          betchipsRussianpoker.src = chip_500;
          break;
        case 6:
          console.log(this.chipVal[5].label)
          console.log(this.chipVal)
          document.getElementById("val0").textContent = this.topLable_rsp(this.chipVal[5].val);
          // document.getElementById("val0").textContent = this.chipVal[5].label ;
          document.getElementById("val0").classList.add("valtext_windowsOS");
          betchipsRussianpoker.src = chip_1000;
          break;

        default:
          break;
      }

      betchipsRussianpoker.style.position = porttraitejson.betchpwindows.position;
      betchipsRussianpoker.style.width = porttraitejson.betchpwindows.width;
      betchipsRussianpoker.style.top = porttraitejson.betchpwindows.top;
      betchipsRussianpoker.style.left = porttraitejson.betchpwindows.left;
      betchipsRussianpoker.style.zIndex = porttraitejson.betchpwindows.zIndex;
    } else {
      const isPortrait = window.innerHeight > window.innerWidth;

      document.getElementById("val0").textContent = "";
      document.getElementById("val1").textContent = "";
      document.getElementById("val2").textContent = "";
      document.getElementById("val3").textContent = "";

      document.getElementById("val0").classList.remove("valtextPortrait1OS");

      switch (this.state.count) {
        case 1:
          betchipsRussianpoker.src = chip_10;
          document.getElementById("val0").textContent = this.chipVal[0].label;
          document.getElementById("val0").classList.add("valtextPortraitOS", "valtextPortrait1OS");

          break;
        case 2:
          document.getElementById("val0").textContent = this.chipVal[1].label;
          document.getElementById("val0").classList.add("valtextPortraitOS");

          betchipsRussianpoker.src = chip_25;
          break;
        case 3:
          document.getElementById("val0").textContent = this.chipVal[2].label;
          document.getElementById("val0").classList.add("valtextPortraitOS");
          betchipsRussianpoker.src = chip_50;

          break;
        case 4:
          document.getElementById("val0").textContent = this.chipVal[3].label;
          document.getElementById("val0").classList.add("valtextPortraitOS");
          betchipsRussianpoker.src = chip_100;
          break;
        case 5:
          document.getElementById("val0").textContent = this.chipVal[4].label;
          document.getElementById("val0").classList.add("valtextPortraitOS");
          betchipsRussianpoker.src = chip_500;
          break;
        case 6:
          document.getElementById("val0").textContent = this.topLable_rsp(this.chipVal[5].val);
          // document.getElementById("val0").textContent = this.chipVal[5].label;
          document.getElementById("val0").classList.add("valtextPortraitOS");
          betchipsRussianpoker.src = chip_1000;
          break;
        default:
          break;
      }
      if (isPortrait) {
        Object.assign(betchipsRussianpoker.style, porttraitejson.betchp);
      } else {
        Object.assign(betchipsRussianpoker.style, porttraitejson.betchiplndspe);
      }
    }

  }

  IncreamentBetchips = () => {
    let addDisable = document.getElementById('betincrenetTP')
    let decreasrDisable = document.getElementById('betdecrementTP')

    console.log(this.state.count)
    document.getElementById("TPbetcircle").classList.remove("insurencenodropOS")

    if (this.state.count < 6) {
      this.Howlersounds.current?.playSound("betchipsnd");
      this.setState(
        (prevState) => ({
          count: prevState.count + 1,
        }),
        () => {
          if (this.state.count > 6) {
            this.setState({ betchipincrementbtn: true, betdecreamentbtn: false });
          }
          else {
            this.Howlersounds.current?.playSound("betchipsnd");
            this.setState({ betchipincrementbtn: false });

          }
          this.betChipsIncrementDecremenAction()
          console.log(this.state.count)

          if (this.state.count < 6) {
            decreasrDisable.classList.remove('icon_autoAlpha')
          } else {
            addDisable.classList.add('icon_autoAlpha')
            decreasrDisable.classList.remove('icon_autoAlpha')
          }

        })
    }
    // console.log("this.state.count", this.state.count, "betdecreamentbtn", this.state.betdecreamentbtn, 'betchipincrementbtn', this.state.betchipincrementbtn)
  };

  DecreamentBetchips = () => {
    // console.log("this.state.count", this.state.count, "betdecreamentbtn", this.state.betdecreamentbtn, 'betchipincrementbtn', this.state.betchipincrementbtn)
    let addDisable = document.getElementById('betincrenetTP')
    let decreasrDisable = document.getElementById('betdecrementTP')

    const betchipsRussianpoker = document.getElementById("betchipsTP");
    document.getElementById("TPbetcircle").classList.remove("insurencenodropOS")

    if (this.state.count > 1) {
      this.setState(
        (prevState) => ({
          count: prevState.count - 1,
        }),
        () => {

          if (this.state.count < 1) {
            this.setState({ betdecreamentbtn: true, betchipincrementbtn: false });
          } else {
            this.Howlersounds.current?.playSound("betchipsnd");
            this.setState({ betdecreamentbtn: false });
          }

          this.betChipsIncrementDecremenAction();
          console.log(this.state.count)

          if (this.state.count > 1) {
            addDisable.classList.remove('icon_autoAlpha')
          } else {
            decreasrDisable.classList.add('icon_autoAlpha')
            addDisable.classList.remove('icon_autoAlpha')
          }
        }
      );
    }
  };

  anteBet = () => {
    if (this.state.PayoutTableToggle) {
      this.setState({ PayoutTableToggle: false });
    }

    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }

    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");

    // if (this.state.mutesounds) {
    //   this.betrussiansnd.pause();
    // }
    // else {
    //   this.betrussiansnd.play();
    // }
    this.Howlersounds.current?.playSound("betchipsnd");

    document.getElementById("betincrenetTP").classList.add("drwnodropOS")
    document.getElementById("betdecrementTP").classList.add("drwnodropOS")

    const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_greaterthanbalnceTP");
    if (popupbetGreaterthanBalnceElement) {
      popupbetGreaterthanBalnceElement.className = "";
      popupbetGreaterthanBalnceElement.classList.add("popupbetshighMobileIntialOS");
    }
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      if (this.state.anteBetAmount <= this.props.maxBetAmt) {

        document.getElementById("buttons_coverOS").classList.remove("buttons_coverOS")
      } else {
        document.getElementById("buttons_coverOS").classList.add("buttons_coverOS")

      }

      document.getElementById("foldtextTP").innerHTML = "";

      document.getElementById("crdscoverOS").classList.add("crdscoverOS")

      document.getElementById("betpannelTropicalcover").style.display = "block";
      document.getElementById("betpannelTropicalcover").classList.add("bet_pannelcoverOS");
      // console.log(this.state.anteBetAmount)
      if (this.state.anteBetAmount >= this.props.minBetAmt) {
        this.setState({
          infoText: "", betchipincrementbtn: true, betdecreamentbtn: true,
          disBetBtn: 1, keyboardhandle: false, multibuttonsebledsble: true, disablemultibutton: true
        })

        if (this.state.anteBetAmount <= this.props.maxBetAmt) {
          document.getElementById("betpannelTropicalcover").style.display = "block";
          document.getElementById("betpannelTropicalcover").classList.add("bet_pannelcoverOS");
          const betbutton = document.getElementById("betbtnTP");
          const foldbutton = document.getElementById("FoldbtnTP");
          betbutton.src = "";
          betbutton.style.display = "none"
          betbutton.style.cssText = ""
          foldbutton.src = "";
          foldbutton.style.display = "none"
          foldbutton.style.cssText = ""
          let betbtntextElement = document.getElementById("betbtntextTP")
          let foldtextElement = document.getElementById("foldtextTP")
          betbtntextElement.textContent = ""
          foldtextElement.textContent = ""
          const body = {
            sessionId: sessionStorage.getItem("sessionId"),
            CN: "POKER_GOLDEN_OASIS_BET",
            object: {
              gameId: this.props.gameId,
              action: "PARAM_BET",
              playerId: Number(this.props.playerId),
              anteBetAmount: Number(this.state.anteBetAmount.toFixed(2)),
              handId: Number(this.props.gameState.handId)
            },
          };
          this.props.network.sendof(body);
          this.setState({ multibuttonsebledsble: false })

        }
        else {

          this.setState({ multibuttonsebledsble: true, disablemultibutton: false })
          let betbtntextElement = document.getElementById("betbtntextTP")
          let foldtextElement = document.getElementById("foldtextTP")
          betbutton.src = Betbtn;
          Object.assign(betbutton.style, porttraitejson.Betbtnwindows);
          betbtntextElement.classList.add("betbtntextTP");
          betbtntextElement.textContent = this.props.language.Deal;

          foldbutton.src = Foldbn;
          Object.assign(foldbutton.style, porttraitejson.foldbtnwindows);
          foldtextElement.classList.add("foldtextTP");
          foldtextElement.textContent = this.props.language.RP_Clear;
          this.setState({
            infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl,
            multibuttonsebledsble: true
          })
        }
      }
      else {
        this.setState({ betdecreamentbtn: false, betchipincrementbtn: false });
        document.getElementById("foldtextTP").innerHTML = this.props.language.RP_Clear
        document.getElementById("betpannelTropicalcover").style.display = "none";
        document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelcoverOS");
        this.setState({
          infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl,
          multibuttonsebledsble: true
        })
      }
    } else {
      this.setState({
        buydrawCheck: false
      })
      let betbtntextElement = document.getElementById("betbtntextTP")
      let foldtextElement = document.getElementById("foldtextTP")

      if (this.state.anteBetAmount >= this.props.minBetAmt) {
        if (this.state.anteBetAmount <= this.props.maxBetAmt) {
          this.setState({
            infoText: "", betchipincrementbtn: true, betdecreamentbtn: true,
            disBetBtn: 1, keyboardhandle: false, multibuttonsebledsble: true, disablemultibutton: true

          })

          document.getElementById("mobileAntiMaskCoverOS").style.display = "block";
          document.getElementById("betpannelTropicalcover").style.display = "block";
          document.getElementById("playerDealerCardContainerTP").style.zIndex = 20;

          betbtntextElement.textContent = "";
          foldtextElement.textContent = "";

          betbutton.src = "";
          foldbutton.src = "";
          betbutton.style.cssText = "";
          foldbutton.style.cssText = "";
          const body = {
            sessionId: sessionStorage.getItem("sessionId"),
            CN: "POKER_GOLDEN_OASIS_BET",
            object: {
              gameId: this.props.gameId,
              action: "PARAM_BET",
              playerId: Number(this.props.playerId),
              anteBetAmount: Number(this.state.anteBetAmount.toFixed(2)),
              handId: Number(this.props.gameState.handId)
            },
          };
          ;
          this.props.network.sendof(body);
          this.setState({ multibuttonsebledsble: false })

        }

        else {
          betbutton.src = Betbtn;
          foldbutton.src = Foldbn;
          betbutton.style.cssText = Betbtn;
          foldbutton.style.cssText = Foldbn;
          if (window.innerHeight > window.innerWidth) {

            // Object.assign(betbutton.style, porttraitejson.Betbtnportraite);
            // betbtntextElement.classList.add("betportraitOS");

            Object.assign(betbutton.style, this.state.betbuttoncss);
            betbtntextElement.classList.add(this.state.betbtntextcss);

            betbtntextElement.textContent = this.props.language.Deal;


            Object.assign(foldbutton.style, this.state.foldbuttoncss);
            foldtextElement.classList.add("foldtextportraitOS");
            foldtextElement.textContent = this.props.language.RP_Clear;

          } else {

            Object.assign(betbutton.style, this.state.betbuttoncss);
            betbtntextElement.classList.add(this.state.betbtntextcss);
            betbtntextElement.textContent = this.props.language.Deal;


            Object.assign(foldbutton.style, this.state.foldbuttoncss);
            foldtextElement.classList.add(this.state.foldbtntextcss);
            foldtextElement.textContent = this.props.language.RP_Clear;

          }
          this.setState({
            infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl,
            // multibuttonsebledsble: true
          })
        }
      }
      else {
        document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
        document.getElementById("betpannelTropicalcover").style.display = "block";
        betbutton.src = Betbtn;
        foldbutton.src = Foldbn;
        if (window.innerHeight > window.innerWidth) {

          Object.assign(betbutton.style, this.state.betbuttoncss);
          // betbtntextElement.classList.add("betportraitOS");
          betbtntextElement.classList.add(this.state.betbtntextcss);
          betbtntextElement.textContent = this.props.language.Deal;


          Object.assign(foldbutton.style, this.state.foldbuttoncss);
          foldtextElement.classList.add("foldtextportraitOS");
          foldtextElement.textContent = this.props.language.RP_Clear;

        } else {

          Object.assign(betbutton.style, this.state.betbuttoncss);
          betbtntextElement.classList.add(this.state.betbtntextcss);
          betbtntextElement.textContent = this.props.language.Deal;

          Object.assign(foldbutton.style, this.state.foldbuttoncss);
          // foldtextElement.classList.add("foldtextLandscapeOS");
          foldtextElement.classList.add(this.state.foldbtntextcss);
          foldtextElement.textContent = this.props.language.RP_Clear;

        }

        // document.getElementById("betpannelTropicalcover").style.display = "none";
        // document.getElementById("betpannelTropicalcover").classList.add("bet_pannelcoverOS");
        this.setState({
          infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl,
          // multibuttonsebledsble: true
        })
      }
    }
  };

  clearbets() {
    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }
    if (this.state.PayoutTableToggle) {
      this.setState({ PayoutTableToggle: false });
    }
    this.clearallsettimeouts()
    // this.updateplayerbalnace();
    const body2 = {
      CN: "GET_PLAYER_INFO",
      object: {
        gameId: Number(this.props.gameId,),
        playerId: Number(this.props.playerId),

      },
      sessionId: sessionStorage.getItem('sessionId'),
    }
    this.props.network.sendof(body2);
    this.body2 = {};

    document.getElementById("TPbetcircle").classList.remove("insurencenodropOS")

    this.setState({ multibuttonsebledsble: false })
    // document.getElementById("betbtnTP").classList.add("addpointerOS")
    // document.getElementById("betbtnTP").classList.remove("drwnodropOS")
    this.clertime1 = setTimeout(() => {
      gsap.to(`#betchipsaddtoanteTP${this.state.idincrement}`, { zIndex: -2 });
      document.getElementById("betpannelTropicalcover").style.display = "none";
      document.getElementById("betpannelTropicalcover").classList.add("bet_pannelcoverOS");
    }, 1000);

    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");

    betbutton.src = "";
    document.getElementById("betbtntextTP").classList.remove("betwindowsOS");
    document.getElementById("betbtntextTP").textContent = "";
    document.getElementById("betbtntextTP").innerHTML = "";
    betbutton.style.cssText = ""

    foldbutton.src = "";
    document.getElementById("foldtextTP").classList.remove("foldtextwindowsOS");
    document.getElementById("foldtextTP").textContent = "";
    document.getElementById("foldtextTP").innerHTML = "";
    foldbutton.style.cssText = ""

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      this.Howlersounds.current?.playSound("clearSnd");
      this.setState({
        totalbet: 0,
        disClearBtn: 1,
        anteBetAmount: 0,
        // infoText: this.props.language.Play_Njoy 
        infoText: this.props.language.Place_antebet
      });

      document.getElementById("TPbetcircle").classList.add("addpointerOS");
      document.getElementById("TPbetcircle").classList.remove("nonpointerOS")
      if (document.getElementById("popupbet_greaterthanbalnceTP")) {
        this.hidepopup_betshigh();
      }
      gsap.to(`#betchipsaddtoanteTP${this.state.idincrement}`, {
        x: 1,
        y: 0,
        duration: 0.1,
        ease: "power2.inOut",
        zIndex: 2,
        autoAlpha: 0
      });

      this.hidepopup_betshigh();

      document.getElementById("betpannelTropicalcover").style.display = "block";
      document.getElementById("betpannelTropicalcover").classList.add("pannelcoverTP");
      setTimeout(() => {
        if (document.getElementById("chipcenterpositionTP")) {
          gsap.to("#chipcenterpositionTP", {
            x: 965,
            y: 235,
            duration: 0.5,
            ease: "power2.inOut",
            zIndex: -2,
            autoAlpha: 0
          });
        }
      }, 500)
    } else {
      document.getElementById("mobileAntiMaskCoverOS").style.display = "block";
      setTimeout(() => {
        document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
      }, 2000)

      setTimeout(() => {
        this.Howlersounds.current?.playSound("clearSnd");

        this.setState({
          totalbet: 0,
          disClearBtn: 1,
          anteBetAmount: 0,
          // infoText: this.props.language.Play_Njoy 
          infoText: this.props.language.Place_antebet
        });

        gsap.to(`#betchipsaddtoanteTP${this.state.idincrement}`, {
          x: 1,
          y: 0,
          duration: 0.3,
          ease: "power2.inOut",
          zIndex: 2,
        });

        setTimeout(() => {
          this.setState({
            // storebetchips:[]
            storeantebetchips: []
          })
        }, 1000)

        const isPortrait = window.innerHeight > window.innerWidth;
        // if(this.state.betshigh_balnce){
        if (document.getElementById("popupbet_greaterthanbalnceTP")) {
          this.hidepopup_betshigh();
        }
        // }
        document.getElementById("betpannelTropicalcover").style.display = "block";
        if (isPortrait) {
          if (document.getElementById("chipcenterpositionTP")) {
            gsap.to("#chipcenterpositionTP", {
              x: 25,
              y: 1200,
              duration: 0.5,
              ease: "power2.inOut",
              zIndex: 2,
              autoAlpha: 0
            });
          }

        } else {

          if (document.getElementById("chipcenterpositionTP")) {
            gsap.to("#chipcenterpositionTP", {
              x: 1050,
              y: 0,
              duration: 0.5,
              ease: "power2.inOut",
              zIndex: 2,
              autoAlpha: 0
            });
          }

        }

      }, 1000);
    }
  }

  Showbonustouser = (res) => {

    let info = "";
    let spokerranking = "";
    let betactiveOS = ""

    let mode = ""
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      mode = "Windows"
      betactiveOS = "betactiveOS"
    } else {
      document.getElementById("betpannelTropicalcover").style.display = "none";
      if (window.innerWidth > window.innerHeight) {
        betactiveOS = "betactiveLndspOS";
        // betactiveOS = this.state.betactvglwcss;
        mode = "landscape";
      } else {
        betactiveOS = "betactivePortraitOS";
        // betactiveOS = this.state.betactvglwcss;
        mode = "portrait";
      }
    }

    document.getElementById("betactiveOS").classList.add(betactiveOS);

    this.clertime2 = setTimeout(() => {
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        document.getElementById("playerDealerCardContainerTP").classList.add("addpointerOS");
        info = "windowsinfoOS";
        spokerranking = "windowspokerrankingOS"
        mode = "Windows"

      } else {
        // document.getElementById("betpannelTropicalcover").style.display = "none";
        if (window.innerWidth > window.innerHeight) {
          spokerranking = "pokerrankingPlayerLndspOS";
          info = "lndspinfoOS";
          mode = "landscape";
        } else {
          info = "portraitinfoOS";
          spokerranking = "pokerrankingPortaitOS";
          mode = "portrait";
        }
      }
      if (document.getElementById("infoTropicalP")) {
        document.getElementById("infoTropicalP").classList.add(info);
        document.getElementById("infoTroppicalland").classList.add(info);
      };

      this.setState({
        pokerranking: res.playerHand,
        // infoText: res.message,
        multibuttonsebledsble: false,
        disablemultibutton: false
        // betBtnValue:1,
      });
      document.getElementById("rankinginfoOS").className = "";
      document.getElementById("rankinginfoOS").classList.add(spokerranking);
    }, 4000);

    if (mode === "Windows") {

    } else {
      document.getElementById("betactiveOS").classList.add(betactiveOS);
    }

    setTimeout(() => {
      if (mode === "Windows") {
        document.getElementById("betTropical").classList.add("addpointerOS");
        document.getElementById("betactiveOS").classList.add(betactiveOS);
      }
    }, 5500)

    this.randomPlayerCards = [];
    this.shuffledPlayerCards = [];

    this.setState({
      revealCard: true,
      buttontext: "fold",
      betbutton: "Bet",
    });

  }

  OSAnteResultRes = (res) => {
    // this.intialEnter = false;
    this.Showbonustouser(res);
    this.setState({ disClearBtn: 1, disBuybtn: 0 })
    this.randomPlayerCards = [...res.playerCards];
    this.shuffledPlayerCards = [...res.playerFinalCards];
    // console.log(this.randomPlayerCards)
    // console.log(this.shuffledPlayerCards)

    // this.randomDealerCards = [...res.dealerCards];

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      const betbutton = document.getElementById("betbtnTP");
      const foldbutton = document.getElementById("FoldbtnTP");
      betbutton.style.display = "none"
      foldbutton.style.display = "none"
      let betbtntextElement = document.getElementById("betbtntextTP")
      let foldtextElement = document.getElementById("foldtextTP")
      betbtntextElement.textContent = ""
      foldtextElement.textContent = ""

      document.getElementById("buttons_coverOS").classList.add("buttons_coverOS")
      setTimeout(() => {
        this.setState({ infoText: res.message })
      }, 7500)

    }

    for (let m = 0; m < res.dealerCards.length; m++) {
      if (res.dealerCards[m] === '-1') {
        this.randomDealerCards.push('xx')

      } else {
        this.randomDealerCards.push(res.dealerCards[m]);
      }
    }
    let cnt = this.randomPlayerCards.length;

    // let mutesounds = this.state.mutesounds;

    // function playSound(i) {
    //   let audio = new Audio(cardsdropping_snd);
    //   audio.currentTime = 0;
    //   if (mutesounds) {
    //     audio.pause();
    //   } else {
    //     audio.play();
    //   }

    //   audio.addEventListener('ended', function () {
    //     if (i + 1 < cnt) {
    //       this.clertime46 = setTimeout(() => {
    //         playSound(i + 1);
    //       }, 200)
    //       // },250)
    //     }
    //   });
    // }

    for (let i = 0; i < cnt; i++) {
      var b1 = this.randomPlayerCards[i];

      switch (i) {
        case 0:
          this.cardsRef.current.addCards("cardZero", b1, cnt);
          break;
        case 1:
          this.cardsRef.current.addCards("cardOne", b1, cnt);
          break;
        case 2:
          this.cardsRef.current.addCards("cardTwo", b1, cnt);
          break;
        case 3:
          this.cardsRef.current.addCards("cardThree", b1, cnt);
          break;
        case 4:
          this.cardsRef.current.addCards("cardFour", b1, cnt);
          break;
        case 5:
          this.cardsRef.current.addCards("cardFive", b1, cnt);
          break;
        default:
          break;
      }
    }

    document.getElementById("betpannelTropicalcover").style.display = "block";
    this.clertime4 = setTimeout(() => {
      this.setState({
        pokerranking: res.playerHand,

      });
      this.onDrawingCards(this.shuffledPlayerCards, false, res, true);
      if (this.state.isMobilePortraitLndsp === true) {
        document.getElementById("playerDealerCardContainerTP").style.zIndex = 1;
      }
      // }, 1300)
    }, cnt * 2 * 500);

    setTimeout(() => {
      document.getElementById("betpannelTropicalcover").style.display = "none";
    }, 7000)


    let dealerCardsLength = this.randomDealerCards.length;

    this.clertime5 = setTimeout(() => {
      for (let i = 0; i < dealerCardsLength; i++) {
        var a1 = this.randomDealerCards[i];
        // playSound(i);
        switch (i) {
          case 0:
            this.dealerCardsContainer.current.addCards(
              "cardZero",
              a1,
              dealerCardsLength
            );
            break;
          case 1:
            this.dealerCardsContainer.current.addCards(
              "cardOne",
              a1,
              dealerCardsLength
            );
            break;
          case 2:
            this.dealerCardsContainer.current.addCards(
              "cardTwo",
              a1,
              dealerCardsLength
            );
            break;
          case 3:
            this.dealerCardsContainer.current.addCards(
              "cardThree",
              a1,
              dealerCardsLength
            );
            break;
          case 4:
            this.dealerCardsContainer.current.addCards(
              "cardFour",
              a1,
              dealerCardsLength
            );
            break;
          default:
            break;
        }
      }
      // const foldbutton = document.getElementById("FoldbtnTP");
      // foldbutton.src = Foldbnwindows;
      // document.getElementById("foldtextTP").textContent = "Fold";
      // document.getElementById("foldtextTP").classList.add("foldtextwindowsOS");
      // foldbutton.style.position = porttraitejson.foldbtnwindows.position;
      // foldbutton.style.top = porttraitejson.foldbtnwindows.top;
      // foldbutton.style.right = porttraitejson.foldbtnwindows.right;
      // foldbutton.style.width = porttraitejson.foldbtnwindows.width;
      // foldbutton.style.zIndex = porttraitejson.foldbtnwindows.zIndex;
      // }, dealerCardsLength * 300);
    }, dealerCardsLength * 400);

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      document.getElementById("TPbetcircle").classList.add("addpointerOS")
      document.getElementById("TPbetcircle").classList.remove("insurencenodropOS");
    }

  };

  onDrawingCards(data, drawBuyHideAndShow, res, cardBasedOnSound) {
    let cnt = data.length;
    for (let i = 0; i < cnt; i++) {
      var b1 = data[i];
      // this.cardsshuffle = new Audio(cardsshuffle);
      // this.cardsshuffle.currentTime = 0;

      switch (i) {
        case 0:
          this.cardsRef.current.SuffleCard("cardZero", b1, cnt);
          break;
        case 1:
          this.cardsRef.current.SuffleCard("cardOne", b1, cnt);
          break;
        case 2:
          this.cardsRef.current.SuffleCard("cardTwo", b1, cnt);
          break;
        case 3:
          this.cardsRef.current.SuffleCard("cardThree", b1, cnt);
          break;
        case 4:
          this.cardsRef.current.SuffleCard("cardFour", b1, cnt);
          break;
        case 5:
          this.cardsRef.current.SuffleCard("cardFive", b1, cnt);
          break;
        default:
          break;
      }
    }

    this.clertime6 = setTimeout(() => {
      this.setState({ infoText: res.message });
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        this.showParamBetStatus(drawBuyHideAndShow)
      } else {
        this.showParamBetStatus(drawBuyHideAndShow)
      }
    }, 2000)
  }

  showParamBetStatus = (drawBuyHideAndShow) => {
    const drawbutton = document.getElementById("drawbtnTP");
    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    const drawtextElement = document.getElementById("drawtextTP");

    const betbtntextElement = document.getElementById("betbtntextTP");
    const foldtextElement = document.getElementById("foldtextTP");

    betbtntextElement.textContent = "";
    foldtextElement.textContent = "";

    drawbutton.src = Drawbtnwindows;
    // drawbutton.style.cssText = "";

    betbutton.src = "";
    betbutton.style.cssText = "";


    foldbutton.src = "";
    foldbutton.style.cssText = "";

    drawtextElement.classList.add("drawtextautoAlphaOS");

    this.setState({ drawbuttonhandle: true, disDrawbtn: 1 });

    document.getElementById("bettextOS").style.color = "#ffffff";
    document.getElementById("betactiveOS").src = bnsactiveTP;

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      this.buyCardsequenceArray = [];
      this.setState({ keyboardhandle: true, disBuybtn: 0, keyboardhandle: true, FoldbtnTP: 0 })
      if (drawBuyHideAndShow) {
        drawbutton.src = "";
        document.getElementById("drawtextTP").textContent = "";
        this.setState({ disDrawbtn: 1, disBuybtn: 1 })

      } else {

        document.getElementById("crdscoverOS").classList.remove("crdscoverOS")
        document.getElementById("buttons_coverOS").classList.remove("buttons_coverOS")
        drawbutton.src = Drawbtnwindows;
        document.getElementById("drawtextTP").textContent = this.props.language.Draw;
        Object.assign(drawbutton.style, porttraitejson.Drawbtnwindows);
        this.setState({ keyboardhandle: true, disBuybtn: 0, disBetBtn: 0, keyboardhandle: true, betBtnValue: 1 })

      }

      betbutton.src = Betbtn;
      Object.assign(betbutton.style, porttraitejson.Betbtnwindows);
      document.getElementById("betbtntextTP").textContent = this.props.language.Bet;
      document.getElementById("betbtntextTP").classList.add("betwindowsOS");

      foldbutton.src = Foldbnwindows;
      Object.assign(foldbutton.style, porttraitejson.foldbtnwindows);
      document.getElementById("foldtextTP").textContent = this.props.language.Fold;
      document.getElementById("foldtextTP").classList.add("foldtextwindowsOS");
      document.getElementById("betpannelTropicalcover").style.display = "block";
      document.getElementById("betpannelTropicalcover").classList.add("bet_pannelcoverOS");

    } else {
      drawtextElement.textContent = "";
      const isPortrait = window.innerHeight > window.innerWidth;
      document.getElementById("mobileAntiMaskCoverOS").style.display = "block";
      if (isPortrait) {
        if (drawBuyHideAndShow) {
          drawtextElement.classList.remove("drawtextPortraitOS");
          drawtextElement.textContent = "";
          drawbutton.src = "";
        } else {
          drawbutton.src = Drawbtn;
          drawtextElement.classList.add("drawtextPortraitOS");
          drawtextElement.textContent = this.props.language.Draw;
          Object.assign(drawbutton.style, porttraitejson.Drawbtnportraite);
        }

        betbtntextElement.textContent = this.props.language.Bet;
        // betbtntextElement.classList.add("betportraitOS");
        betbtntextElement.classList.add(this.state.betbtntextcss);
        foldtextElement.textContent = this.props.language.Fold;
        foldtextElement.classList.add("foldtextportraitOS");
        betbutton.src = Betbtn;
        Object.assign(betbutton.style, this.state.betbuttoncss);

        foldbutton.src = Foldbn;
        Object.assign(foldbutton.style, this.state.foldbuttoncss);

      } else {
        if (drawBuyHideAndShow) {
          drawtextElement.classList.remove("drawtextLndspOS");
          drawtextElement.textContent = "";
          drawbutton.src = "";

        } else {
          drawbutton.src = Drawbtn;
          drawtextElement.classList.add("drawtextLndspOS");
          drawtextElement.textContent = this.props.language.Draw;
          Object.assign(drawbutton.style, porttraitejson.Drawbtnlndspe);
        }

        betbtntextElement.textContent = this.props.language.Bet;
        // betbtntextElement.classList.add("betLandscapeOS");
        betbtntextElement.classList.add(this.state.betbtntextcss);
        foldtextElement.textContent = this.props.language.Fold;
        // foldtextElement.classList.add("foldtextLandscapeOS");
        foldtextElement.classList.add(this.state.foldbtntextcss);
        betbutton.src = Betbtn;
        Object.assign(betbutton.style, this.state.betbuttoncss);

        foldbutton.src = Foldbn;
        Object.assign(foldbutton.style, this.state.foldbuttoncss);

      }
    }

  }
  drawCard() {

    this.Howlersounds.current?.playSound("betchipsnd");
    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }
    console.log(this.state.anteBetAmount)
    console.log(this.props.balance)
    console.log(document.getElementById("drawtextTP").textContent)

    // if (Number((this.state.anteBetAmount * 3 + this.state.anteBetAmount).toFixed(2)) > this.props.balance) {
    if (Number((this.state.anteBetAmount * 3).toFixed(2)) > this.props.balance) {
      this.setState({
        betshigh_balnce: true,
        lowBalaceErrorInfo: `Insufficient Funds to place the Draw of ${(this.state.anteBetAmount).toFixed(2)},Please DEPOSIT to continue playing.`
      });
      this.lowBalanceErrorInformationPopupanimation()
    }
    else if ((Number((this.state.anteBetAmount * 4 + this.state.anteBetAmount).toFixed(2)) > this.props.balance) && (document.getElementById("drawtextTP").textContent) == "Re Draw") {
      this.setState({
        betshigh_balnce: true,
        lowBalaceErrorInfo: `Insufficient Funds to place the Draw of ${(this.state.anteBetAmount).toFixed(2)},Please DEPOSIT to continue playing.`
      });
      this.lowBalanceErrorInformationPopupanimation()
    }
    else {
      if (this.state.betshigh_balnce === true) {
        this.hidepopup_betshigh();
      }
      this.setState({ betshigh_balnce: null })

      this.Howlersounds.current?.playSound("pokerchipsnd");
      const drawbutton = document.getElementById("drawbtnTP");
      const buybutton = document.getElementById("buybtnTP");
      const betbutton = document.getElementById("betbtnTP");
      const foldbutton = document.getElementById("FoldbtnTP");

      const drawtextElement = document.getElementById("drawtextTP");

      const betbtntextElement = document.getElementById("betbtntextTP");
      const foldtextElement = document.getElementById("foldtextTP");

      drawbutton.src = "";
      drawbutton.style.cssText = ""

      buybutton.src = "";
      buybutton.style.cssText = ""

      betbutton.src = "";
      betbutton.style.cssText = ""

      foldbutton.src = "";
      foldbutton.style.cssText = ""

      drawtextElement.textContent = "";
      betbtntextElement.textContent = "";
      foldtextElement.textContent = "";

      let betchipsaddtodrawContainerElement = document.getElementById("betchipsaddtodrawContainerTP");
      let betchipsdraw = document.getElementById("betchipsaddtodrawOS");
      let betTextaddtodrawElement = document.getElementById("betchipsaddtodrawTextTP");

      betchipsaddtodrawContainerElement.classList.remove("drawChipDivPortraiteOS");

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        this.setState((prevState) => ({
          totalbet: prevState.totalbet + prevState.anteBetAmount,
          buydrawCheck: !prevState.buydrawCheck,
          betdeductions: prevState.betdeductions + prevState.anteBetAmount
        }));
        this.drawbuybets(this.state.anteBetAmount)

        document.getElementById("crdscoverOS").classList.add("crdscoverOS")

        // document.getElementById("drawtextTP").classList.remove("drawtextwindowsOS");
        let t4 = gsap.timeline();
        t4.to("#betchipsaddtodrawOS", {
          x: -1147, y: -274, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
          onComplete: () => {
            gsap.set("#betchipsaddtodrawOS", { autoAlpha: 1 });
          }

        });

      } else {

        let betTextaddtodrawElementClass = "bet-text-addtoBet20OS";

        betchipsdraw.src = this.ReturnChipBasedAmount(Number((this.state.anteBetAmount).toFixed(2)));

        switch (this.state.count) {
          case 1:
            // betchipsdraw.src = chip_10;
            betTextaddtodrawElementClass = "bet-text-addtoBet10OS";
            break;
          case 2:
            // betchipsdraw.src = chip_25;
            break;
          case 3:
            // betchipsdraw.src = chip_50;
            break;
          case 4:
            // betchipsdraw.src = chip_100;

            break;
          case 5:
            // betchipsdraw.src = chip_500;
            break;
          case 6:
            // betchipsdraw.src = chip_1000;
            break;

          default:
            betTextaddtodrawElementClass = "bet-text-addtoBet20OS";
            break;
        }

        this.buydrawchipactivated = true;

        this.setState((prevState) => ({
          totalbet: prevState.totalbet + (prevState.anteBetAmount),
          buydrawCheck: !prevState.buydrawCheck,
          betdeductions: prevState.betdeductions + (prevState.anteBetAmount),
          infoText: ""
        }));
        betTextaddtodrawElement.textContent = this.topLable_rsp(this.state.anteBetAmount);

        document.getElementById("betpannelTropicalcover").style.display = "block";
        document.getElementById("playerDealerCardContainerTP").style.zIndex = 20;
        if (window.innerHeight > window.innerWidth) {
          drawtextElement.classList.remove("betportraitOS");
          betchipsaddtodrawContainerElement.classList.add("drawChipDivOS");
          betchipsaddtodrawContainerElement.classList.add("drawChipDivPortraiteOS");
          betTextaddtodrawElement.className = "";
          betTextaddtodrawElement.style.cssText = "";
          betTextaddtodrawElement.classList.add(betTextaddtodrawElementClass, 'betTextaddtodrawOS');
          betchipsdraw.classList.add("betchipsaddtodrawOS");
          this.state.drawbtnnewClass = true
          // betchipsdraw.classList.add("betchipsaddtodrawPositionOS")

          gsap.to(this.chipdrawref.current, {
            // x: 360,
            x: 389,
            y: -741,
            duration: 0.3,
            ease: "power2.inOut",
            zIndex: 12,
            autoAlpha: 1,
            autoAlpha: 1
          });

        } else {
          drawtextElement.classList.remove("betLandscapeOS");

          betchipsaddtodrawContainerElement.classList.add("drawChipDivLndspOS");
          betTextaddtodrawElement.className = "";
          betTextaddtodrawElement.style.cssText = "";
          betTextaddtodrawElement.classList.add(betTextaddtodrawElementClass, 'betTextaddwLndspOS');

          betchipsdraw.classList.add("betchipsaddtodrawOS")
          gsap.to(this.chipdrawref.current, {
            x: -406,
            y: 169,
            duration: 0.3,
            ease: "power2.inOut",
            zIndex: 12,
            autoAlpha: 1,
            autoAlpha: 1
          });
        }
      }


      const indexes = this.replaceCards.map(card => this.shuffledPlayerCards.indexOf(card).toString());

      // console.log(indexes)
      // console.log(this.replaceCards)
      // console.log(this.shuffledPlayerCards)

      const body = {
        sessionId: sessionStorage.getItem("sessionId"),
        CN: "POKER_GOLDEN_OASIS_BET",
        object: {
          gameId: this.props.gameId,
          action: "REPLACE_CARDS",
          playerId: Number(this.props.playerId),
          // pcards: this.replaceCards,
          pcards: indexes,
          handId: Number(this.props.gameState.handId)
        },
      };
      this.props.network.sendof(body);

      document.getElementById("buybtnTP").style.opacity = "1"
      this.setState({ disableBuyButton: false })
    }
  }

  revealDealercards(res) {
    this.dealerCardsRandom = [...res.dealerCards];
    this.dealerShuffledCards = [...res.dealerFinalCards];
    // this.setState({ totalwinRussian: res.totalWinAmount });
    // console.log(this.state.totalwinRussian);
    let cnt = this.dealerCardsRandom.length;
    this.Howlersounds.current?.playSound("reavelDealerCards")

    for (let i = 0; i < cnt; i++) {
      let b1 = this.dealerCardsRandom[i];
      switch (i) {
        case 0:
          if (this.randomDealerCards[0] != b1) {
            this.dealerCardsContainer.current.revealDealerCards("cardZero", b1, cnt);
          }
          break;
        case 1:
          if (this.randomDealerCards[1] != b1) {
            this.dealerCardsContainer.current.revealDealerCards("cardOne", b1, cnt);
          }
          break;
        case 2:
          if (this.randomDealerCards[2] != b1) {
            this.dealerCardsContainer.current.revealDealerCards("cardTwo", b1, cnt);
          }
          break;
        case 3:
          if (this.randomDealerCards[3] != b1) {
            this.dealerCardsContainer.current.revealDealerCards("cardThree", b1, cnt);
          }
          break;
        case 4:
          if (this.randomDealerCards[4] != b1) {
            this.dealerCardsContainer.current.revealDealerCards("cardFour", b1, cnt);
          }
          break;
        case 5:
          if (this.randomDealerCards[5] != b1) {
            this.dealerCardsContainer.current.revealDealerCards("cardFive", b1, cnt);
          }
          break;
        default:
          break;
      }
    }

    this.clertime6 = setTimeout(() => {
      // console.log("before", this.randomDealerCards);
      // this.suffleDealerCards(this.randomDealerCards.sort(() => Math.random()-0.5));
      this.suffleDealerCards(this.dealerShuffledCards);
      // console.log("after", this.randomDealerCards);
    }, this.dealerShuffledCards.length * 500);

  }
  updateplayerbalnace = () => {
    this.props.gamstateHandle();
    this.intialEnter = false;
    // this.setState({betdeductions:0,noupdateblnce:true})
    const body2 = {
      CN: "GET_PLAYER_INFO",
      object: {
        gameId: Number(this.props.gameId,),
        playerId: Number(this.props.playerId),

      },
      sessionId: sessionStorage.getItem('sessionId'),
    }
    this.props.network.sendof(body2);
    this.body2 = {};

  }

  highlightPlayerCardsName = (playerHand) => {
    this.setState({
      pokerranking: playerHand
    });
  }

  insurenceactiveornot = (res) => {
    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    this.clertime7 = setTimeout(() => {
      document.getElementById("rankinginfodelerOS").classList.add("windowspokerrankingdelerOS");
      this.setState({ pokerrankingdeler: res.dealerHand, })
    }, 3500);

    document.getElementById("betbtntextTP").textContent = "";
    document.getElementById("foldtextTP").textContent = "";
    this.revealDealercards(res)
    setTimeout(() => {
      this.checkpayerordealerwins(res);
    }, 3500)

  }

  Showinsurenceactiveornot = (res) => {
    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    document.getElementById("betbtntextTP").textContent = "";
    document.getElementById("foldtextTP").textContent = "";

    this.showcheckpayerordealerwins(res);

  }

  showrussianPokerresp = (res) => {
    // console.log(res)
    //// }, dealerCardsLength*300+3000)
    // this.setState({betdeductions:0,noupdateblnce:false})
    // this.state.betdeductions=0;
    //  this.updateplayerbalnace();

    // document.getElementById("rankinginfodelerOS").style.textContent= res.message
    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    const betTextaddtoBetElement = document.getElementById("betTextaddtoBetTP");
    this.setState({ playerhand_status: res.playerHand, disableBuyButton: false })
    document.getElementById("buybtnTP").style.opacity = "1"


    const betbtntextElement = document.getElementById("betbtntextTP");
    const foldtextElement = document.getElementById("foldtextTP");

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      this.Showinsurenceactiveornot(res)
      // this.revealDealercards(res);
    }

    else {
      if (window.innerHeight > window.innerWidth) {
        switch (res.winner) {
          case "Dealer":
          case "Player":
            this.showPlayerorDealerorFold(res)

            // this.ifDealerWinsMobilePortraitAction();
            // break;
            // this.ifPlayerWinsMobilePortraitAction();

            // if(Number(res.anteBetAmount) >0){
            //   let convrAntebt = this.topLable_rsp(res.anteBetAmount);
            //   this.setState((prevState) => ({
            //     storeantebetchips: [
            //       ...prevState.storeantebetchips,
            //       { chip: chip_10, chipvalue: convrAntebt, chipcolor1: "valtextPortrait1OS" },

            //     ],
            //   }));

            // }
            break;

          case "Dealer_no_hand":
            this.dealerShuffledCards = [...res.dealerFinalCards]
            this.showcardsAdBetsParamState(res, res.playerFinalCards, res.dealerFinalCards);
            this.shwnPrvsSteBuyDrawBtchips(res)
            document.getElementById("betactiveOS").src = "";
            document.getElementById("bettextOS").style.color = "";
            document.getElementById("rankinginfodelerOS").classList.add("pokerrankingdelerPortraitOS");
            this.setState({
              betbutton: "YES", buttontext: "NO", Yesbtn: 1, Nobtn: 1, keyboardhandle: true,
              infoText: res.message, pokerrankingdeler: res.dealerHand, pokerranking: res.playerHand
            });
            document.getElementById("betbtntextTP").textContent = this.props.language.Yes;
            betbutton.src = Betbtn;
            Object.assign(betbutton.style, this.state.betbuttoncss);


            foldbutton.src = Foldbn;
            Object.assign(foldbutton.style, this.state.foldbuttoncss);

            // foldbutton.src = Foldbn;
            foldtextElement.textContent = this.props.language.No;
            document.getElementById("betbtntextTP").classList.remove("insurenceOS", "betwindowsOS");
            foldtextElement.classList.remove("noinsurenceOS", "foldtextwindowsOS");
            document.getElementById("betbtntextTP").classList.add(this.state.betbtntextcss);
            foldtextElement.classList.add("foldtextportraitOS");
          default:
            break;
        }

      } else {

        this.prevStatecheckPlayerOrDealerWinMblLndspe(res);
      }

    }

  }

  shwnPrvsSteBuyDrawBtchips = (res) => {

    const rankinginfoElement = document.getElementById("rankinginfoOS");

    if (Number(res.anteBetAmount) > 0) {
      let convrAntebt = this.topLable_rsp(res.anteBetAmount);
      this.setState((prevState) => ({
        anteBetAmount: res.anteBetAmount,
        totalbet: res.totalBetAmount,
        infoText: res.message,
        //  storeantebetchips: [
        //    ...prevState.storeantebetchips,
        //    { chip: chip_10, chipvalue: convrAntebt, chipcolor1: "valtextPortrait1OS" },
        //  ],
      }));

    }

    if (res.playerReplaceCardAmount > 0 || res.playerBuyCardAmount > 0) {
      this.prevstateBuyorDrawChip(res);
    }
    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");

    const drawbutton = document.getElementById("drawbtnTP");
    const buybutton = document.getElementById("buybtnTP");
    let betTextaddtoBetElement = document.getElementById("betTextaddtoBetTP");
    let betchipsaddtobetwindows = document.getElementById("betchipsaddtobetTP");
    let betTextaddtoBetClass = "bet-text-addtoBet20OS";

    let convrBet = this.topLable_rsp(res.betAmount);
    betchipsaddtobetwindows.src = this.ReturnChipBasedAmount(res.betAmount);

    switch (this.state.count) {
      case 1:
        // betchipsaddtobetwindows.src = chip_10;
        // betTextaddtoBetElement.textContent = 10;
        betTextaddtoBetElement.textContent = convrBet;
        betTextaddtoBetClass = "bet-text-addtoBet10OS";
        break;
      case 2:
        // betchipsaddtobetwindows.src = chip_25;
        betTextaddtoBetElement.textContent = convrBet;
        break;
      case 3:
        // betchipsaddtobetwindows.src = chip_50;
        betTextaddtoBetElement.textContent = convrBet;
        break;
      case 4:
        // betchipsaddtobetwindows.src = chip_100;
        betTextaddtoBetElement.textContent = convrBet;
        break;
      case 5:
        // betchipsaddtobetwindows.src = chip_500;
        betTextaddtoBetElement.textContent = convrBet;
        break;
      case 6:
        // betchipsaddtobetwindows.src = chip_1000;
        betTextaddtoBetElement.textContent = convrBet;
        break;

      default:
        betTextaddtoBetClass = "bet-text-addtoBet20OS"
        break;
    }
    this.betchipactivated = true;

    document.getElementById("betpannelTropicalcover").style.display = "block";
    if (window.innerHeight > window.innerWidth) {
      rankinginfoElement.classList.add("pokerrankingPortaitOS");
      betTextaddtoBetElement.className = "";
      // betTextaddtoBetElement.classList.add(betTextaddtoBetClass, "bet-text-addtoBet-portrait");
      betTextaddtoBetElement.style.color = "#ffffff";
      Object.assign(betchipsaddtobetwindows.style, porttraitejson.BetchiptobetPortrait)
      gsap.to(this.chipbetref.current, {
        // x: -10,
        // y: -950,
        x: -27,
        y: -925,
        duration: 0.00001,
        zIndex: 2,
        autoAlpha: 1,
        autoAlpha: 1,
      });

      gsap.to(betTextaddtoBetElement, {
        // x: 12,
        // y: -1739,
        x: -3,
        y: -1710,
        duration: 0.00001,
        zIndex: 2,
        autoAlpha: 1,
        visibility: true,
        onStart: function () {
          betTextaddtoBetElement.style.zIndex = 2;
          betTextaddtoBetElement.style.visibility = 'visible';
        }
      });

    } else {
      rankinginfoElement.classList.add("pokerrankingPlayerLndspOS");
      betTextaddtoBetElement.className = "";
      // betTextaddtoBetElement.classList.add(betTextaddtoBetClass, "bet-text-addtoBet-lndsp");
      betTextaddtoBetElement.style.color = "#ffffff";
      Object.assign(betchipsaddtobetwindows.style, porttraitejson.BetchiptobetLndsp);

      gsap.to(this.chipbetref.current, {
        x: -1060,
        y: 170,
        duration: 0.00001,
        zIndex: 2,
        autoAlpha: 1
      });


      gsap.to(betTextaddtoBetElement, {
        x: -1060,
        y: 170,
        duration: 0.00001,
        zIndex: 2,
        autoAlpha: 1,
        onStart: function () {
          betTextaddtoBetElement.style.zIndex = 2;
          betTextaddtoBetElement.style.visibility = 'visible';
        }
      });

    }
  }
  prevStatecheckPlayerOrDealerWinMblLndspe = (res) => {

    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    const drawtextElement = document.getElementById("drawtextTP");
    const betbtntextElement = document.getElementById("betbtntextTP");
    const foldtextElement = document.getElementById("foldtextTP");

    const betTextaddtoBetElement = document.getElementById("betTextaddtoBetTP");
    this.setState({ infoText: res.message, pokerrankingdeler: res.dealerHand, })
    document.getElementById("rankinginfodelerOS").classList.add("pokerrankingdelerLndSpeOS");
    const confirmbuydealerPopupElement = document.getElementById("confirmbuydealer_popupTP");

    betbutton.className = "";
    betbutton.style.cssText = "";

    foldbutton.className = "";
    foldbutton.style.cssText = "";

    drawtextElement.className = "";
    drawtextElement.style.cssText = "";
    drawtextElement.textContent = "";

    betbtntextElement.className = "";
    betbtntextElement.style.cssText = "";
    betbtntextElement.textContent = "";

    foldtextElement.className = "";
    foldtextElement.style.cssText = "";
    foldtextElement.textContent = "";

    switch (res.winner) {
      case "Dealer":
      case "Player":
        this.showPlayerorDealerorFold(res)

        break;
      // case "Dealer doesn't have a hand. Would you like to replace the dealer's higher card for the cost equivalent of ANTE? Press either NO or YES.":
      case "Dealer_no_hand":
        this.dealerShuffledCards = [...res.dealerFinalCards]

        if (res.action !== "BUY_DEALER_CARD") {
          this.showcardsAdBetsParamState(res, res.playerFinalCards, res.dealerFinalCards);
          this.shwnPrvsSteBuyDrawBtchips(res)
          document.getElementById("betactiveOS").src = "";
          document.getElementById("bettextOS").style.color = "";

          betbtntextElement.className = "";
          foldtextElement.className = "";
          document.getElementById("rankinginfodelerOS").classList.add("pokerrankingdelerLndSpeOS");
          this.setState({
            betbutton: "YES", buttontext: "NO", Yesbtn: 1, Nobtn: 1, keyboardhandle: true,
            infoText: res.message, pokerrankingdeler: res.dealerHand, pokerranking: res.playerHand, disablemultibutton: false
          });

          // betbtntextElement.classList.add("betLandscapeOS");
          betbtntextElement.classList.add(this.state.betbtntextcss);
          betbtntextElement.textContent = this.props.language.Yes;
          betbutton.src = Betbtn;
          Object.assign(betbutton.style, this.state.betbuttoncss);

          // foldtextElement.classList.add("foldtextLandscapeOS");
          foldtextElement.classList.add(this.state.foldbtntextcss);
          foldbutton.src = Foldbn;
          Object.assign(foldbutton.style, this.state.foldbuttoncss);
          foldtextElement.textContent = this.props.language.No;
        }
      default:
        break;
    }
  }

  OasisPokerBetRes = (res) => {
    console.log(res)
    // this.intialEnter = false;
    this.state.drawbtnnewClass = false
    //// }, dealerCardsLength*300+3000)
    // this.setState({betdeductions:0,noupdateblnce:false})
    // this.state.betdeductions=0;
    //  this.updateplayerbalnace();

    // document.getElementById("rankinginfodelerOS").style.textContent= res.message
    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    const betTextaddtoBetElement = document.getElementById("betTextaddtoBetTP");
    this.setState({
      playerhand_status: res.playerHand,
      disableBuyButton: false
    })

    document.getElementById("buybtnTP").style.opacity = "1"
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      this.insurenceactiveornot(res)

    } else {
      if (window.innerHeight > window.innerWidth) {

        this.revealDealercards(res)
        this.clertime7 = setTimeout(() => {


          this.setState({ pokerrankingdeler: res.dealerHand, })
          // document.getElementById("rankinginfodelerOS").classList.add("pokerrankingdelerPortraitOS");
          document.getElementById("rankinginfodelerOS").classList.add(`${this.state.rankinginfodelercss}`);

          switch (res.winner) {
            case "Dealer":
              setTimeout(() => {
                this.ifDealerWinsMobilePortraitAction(res);
              }, 1000)
              break;

            // case `CONGRATULATIONS! You won FUN ${res.totalWinAmount}`:
            case "Player":
              this.ifPlayerWinsMobilePortraitAction(res);
              break;
            // case "Dealer doesn't have a hand. Would you like to replace the dealer's higher card for the cost equivalent of ANTE? Press either NO or YES.":
            case "Dealer_no_hand":
              document.getElementById("betactiveOS").src = "";
              document.getElementById("bettextOS").style.color = "";

              this.setState({ betbutton: "YES", buttontext: "NO", Yesbtn: 1, Nobtn: 1, keyboardhandle: true, infoText: res.message, });
              document.getElementById("betbtntextTP").textContent = this.props.language.Yes;
              betbutton.src = Betbtn;
              // Object.assign(betbutton.style, porttraitejson.Betbtnportraite);
              Object.assign(betbutton.style, this.state.betbuttoncss);


              foldbutton.src = Foldbn;
              // Object.assign(foldbutton.style, porttraitejson.foldbtnportraite);
              Object.assign(foldbutton.style, this.state.foldbuttoncss);

              // foldbutton.src = Foldbn;
              document.getElementById("foldtextTP").textContent = this.props.language.No;
              document.getElementById("betbtntextTP").classList.remove("insurenceOS", "betwindowsOS");
              document.getElementById("foldtextTP").classList.remove("noinsurenceOS", "foldtextwindowsOS");
              document.getElementById("betbtntextTP").classList.add(`${this.state.betbtntextcss}`);
              document.getElementById("foldtextTP").classList.add(`${this.state.foldbtntextcss}`);
            // document.getElementById("betbtntextTP").classList.add("betportraitOS");
            // document.getElementById("foldtextTP").classList.add("foldtextportraitOS");
            default:
              break;
          }
        }, 3500)
        setTimeout(() => {
          if (res.winner == "Player")
            this.setState({
              Winnindanimation: true
            })
        }, 5000)

        setTimeout(() => {
          if (res.winner == "Player")
            this.setState({
              AnteWinCHanimation: true
            })
        }, 3500)
      } else {

        this.revealDealercards(res);
        this.clertime7 = setTimeout(() => {
          this.checkPlayerOrDealerWinMblLndspe(res);
        }, 5000)
        setTimeout(() => {
          if (res.winner == "Player") {
            this.setState({
              Winnindanimation: true
            })
          }
        }, 5000)

        setTimeout(() => {
          if (res.winner == "Player") {
            this.setState({
              AnteWinCHanimation: true
            })
          }
        }, 3500)

      }
      setTimeout(() => {
        this.setState({
          Winnindanimation: false,
          AnteWinCHanimation: false
        })
      }, 11000)
    }
  }

  checkPlayerOrDealerWinMblLndspe = (res) => {

    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    const drawtextElement = document.getElementById("drawtextTP");
    const betbtntextElement = document.getElementById("betbtntextTP");
    const foldtextElement = document.getElementById("foldtextTP");
    const winpopuprspelement = document.getElementById("winpopup_TP");
    const winamtElement = document.getElementById("winamt_TPS");

    const anteText = document.querySelectorAll("#chipcenterpositionTP span");
    const betText = document.querySelector("#betTextaddtoBetTP");

    const betTextaddtoBetElement = document.getElementById("betTextaddtoBetTP");
    this.setState({
      // infoText: res.message, 
      pokerrankingdeler: res.dealerHand,
    })
    // document.getElementById("rankinginfodelerOS").classList.add("pokerrankingdelerLndSpeOS");
    document.getElementById("rankinginfodelerOS").classList.add(`${this.state.rankinginfodelercss}`);
    const confirmbuydealerPopupElement = document.getElementById("confirmbuydealer_popupTP");

    betbutton.className = "";
    betbutton.style.cssText = "";

    foldbutton.className = "";
    foldbutton.style.cssText = "";

    drawtextElement.className = "";
    drawtextElement.style.cssText = "";
    drawtextElement.textContent = "";

    betbtntextElement.className = "";
    betbtntextElement.style.cssText = "";
    betbtntextElement.textContent = "";

    foldtextElement.className = "";
    foldtextElement.style.cssText = "";
    foldtextElement.textContent = "";

    switch (res.winner) {
      case "Dealer":
        //  ------------------------------------- this.intialEnter
        // this.updateplayerbalnace();
        //  ------------------------------------- this.intialEnter
        this.setState((prevState) => ({
          infoText: res.message,
          totalwinRussian: res.totalWinAmount,
          previousAnteBetAmount: res.anteBetAmount,
          totalbet: 0,
          anteBetAmount: 0,
          prevStatestoreantebetchips: [...prevState.storeantebetchips],
          // betdeductions: 0
        }));

        this.clertime48 = setTimeout(() => {
          this.clearActivesWeDid();
        }, 2500)

        document.getElementById("betactiveOS").src = "";
        document.getElementById("bettextOS").style.color = "";
        document.getElementById("betactiveOS").classList.remove("betactiveOS");
        this.setState({ betbutton: "REBET", buttontext: "REBETX2", betchipincrementbtn: false, betdecreamentbtn: false });
        let t1 = gsap.timeline();

        t1.to("#chipcenterpositionTP", {
          y: -700, duration: 0.2, autoAlpha: 1,
          onComplete: () => {
            gsap.set("#chipcenterpositionTP", { autoAlpha: 0 });
          }
        });
        t1.to("#chipcenterpositionTP", {
          y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0,
          onComplete: () => {
            gsap.set("#chipcenterpositionTP", { autoAlpha: 0, });
          }
        });
        t1.play();

        if (window.innerHeight > window.innerWidth) {
          let t2 = gsap.timeline();
          t2.to("#betchipsaddtobetTP", {
            x: -50, y: -2060, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
            onComplete: () => {
              gsap.set("#betchipsaddtobetTP", { autoAlpha: 0 });
            }
          });
          t2.to("#betchipsaddtobetTP", {
            x: 30, y: 185, duration: 0.5, zIndex: -2, autoAlpha: 0,

          });
          t2.play();

          let t3 = gsap.timeline();
          t3.to("#betTextaddtoBetTP", {
            x: 110, y: -2000, duration: 0.5, ease: "power2.inOut", autoAlpha: 0,
            onComplete: () => {
              gsap.set("#betTextaddtoBetTP", { autoAlpha: 0 });
            }
          });
          t3.to("#betTextaddtoBetTP", {
            x: 153, y: 185, duration: 0.5, zIndex: -2, autoAlpha: 0,

          });

          t3.play();

        } else {

          let t2 = gsap.timeline();
          t2.to("#betchipsaddtobetTP", {
            y: -700, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
            onComplete: () => {
              gsap.set("#betchipsaddtobetTP", { autoAlpha: 0 });
            }
          });
          t2.to("#betchipsaddtobetTP", {
            x: 0, y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0,

          });
          t2.play();

          let t3 = gsap.timeline();
          t3.to("#betTextaddtoBetTP", {
            y: -700, duration: 0.5, ease: "power2.inOut", autoAlpha: 0,
            onComplete: () => {
              gsap.set("#betTextaddtoBetTP", { autoAlpha: 0 });
            }
          });
          t3.to("#betTextaddtoBetTP", {
            x: 0, y: 0, duration: 0.5, zIndex: -2, autoAlpha: 0,

          });

          t3.play();
        }

        if (this.wanttobuydelercrd === true) {
          let t1 = gsap.timeline()
          t1.to(this.buyDealerCardDrawn.current, { y: -700, duration: 0.5 });
          t1.to(this.buyDealerCardDrawn.current, { autoAlpha: 0, });
          t1.to(this.buyDealerCardDrawn.current, { autoAlpha: 0, y: 0, zIndex: -5 });
          t1.play();
        }
        betbtntextElement.className = "";
        foldtextElement.className = "";
        betbtntextElement.textContent = "";
        foldtextElement.textContent = "";

        this.clertime49 = setTimeout(() => {
          this.updateplayerbalnace();
          this.setState({ infoText: this.props.language.Place_antebet, totalwinRussian: 0, storeantebetchips: [], });
          gsap.fromTo(winpopuprspelement, { scale: 1, duration: 0.5, rotate: 360 }, {
            autoAlpha: 0, scale: 0, duration: 0.5, onComplete: () => {
              winpopuprspelement.classList.remove("winPopupForMLspOS");
              winamtElement.classList.remove("winamtMpSwOS");
            }
          })
          //  ------------------------------------- this.intialEnter

          // document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
          // betbutton.src = Betbtn;
          // Object.assign(betbutton.style, this.state.betbuttoncss);
          // betbtntextElement.textContent = this.props.language.Rebet;
          // // betbtntextElement.classList.add('betLandscapeOS');
          // betbtntextElement.classList.add(`${this.state.betbtntextcss}`);

          // foldbutton.src = Foldbn;
          // Object.assign(foldbutton.style, this.state.foldbuttoncss);
          // foldtextElement.textContent = this.props.language.RebetX2;
          // // foldtextElement.classList.add("foldtextLandscapeOS");
          // foldtextElement.classList.add(`${this.state.foldbtntextcss}`);
          //  ------------------------------------- this.intialEnter
        }, 3000);
        // this.Howlersounds.current?.playSound("playerLose");


        break;

      case "Player":

        const delaerChipAnimDiv = document.getElementById('delaerchipanimTP')
        const dealerchipElement = document.getElementById('dealerchipTP');


        if (Number(res.anteWinAmount) > Number(res.anteBetAmount)) {
          dealerchipElement.src = this.ReturnChipBasedAmount(Number(res.anteBetAmount));
          // Object.assign(dealerchipElement.style, porttraitejson.dealerchipstoplayerLndsp)
          Object.assign(dealerchipElement.style, this.state.DelarAnteWinProLandAN)

          if (window.innerHeight > window.innerWidth) {
            let t1 = gsap.timeline()
            t1.to("#dealerchipTP", {
              autoAlpha: 1,
              zIndex: 2,
              x: -50,
              y: 1630,
              duration: 0.8,
              ease: "power2.inOut",
              onComplete: () => {
                gsap.set('#dealerchipTP', { autoAlpha: 0, zIndex: -10 })
              },
            });

            t1.to("#dealerchipTP", {
              x: -75,
              y: 20,
              duration: 0.002,
              ease: "power2.inOut",
              autoAlpha: 0,
              zIndex: -10

            })

            setTimeout(() => {
              for (let b = 0; b < anteText.length; b++) {
                anteText[b].textContent = this.topLable_rsp(res.anteWinAmount);
              }
            }, 500);
          } else {

            let t6 = gsap.timeline()
            t6.to("#dealerchipTP", {
              x: 555,
              y: 560,
              duration: 0.5,
              ease: "power2.inOut",
              onStart: () => {
                gsap.set('#dealerchipTP', { autoAlpha: 1, zIndex: 2 })
              },
              onComplete: () => {
                gsap.set('#dealerchipTP', { y: 0, autoAlpha: 0, zIndex: -10 })

                for (let b = 0; b < anteText.length; b++) {
                  // anteText[b].textContent = res.anteWinAmount;
                  anteText[b].textContent = this.topLable_rsp(res.anteWinAmount);
                }

              },
            });
          }
        }

        setTimeout(() => {
          // this.updateplayerbalnace();
          this.clertime53 = setTimeout(() => {
            this.clearActivesWeDid();
          }, 3000);
          this.setState((prevState) => ({
            // infoText: res.message,
            // totalwinRussian: res.totalWinAmount,
            previousAnteBetAmount: res.anteBetAmount,
            anteBetAmount: 0,
            prevStatestoreantebetchips: [...prevState.storeantebetchips],
          }));

          betText.textContent = this.topLable_rsp(res.winAmount);
          this.resetAnimationChips = true;

          setTimeout(() => {

            winpopuprspelement.classList.add("winPopupForMLspOS");
            winamtElement.classList.add("winamtMpSwOS");
            this.setState({
              infoText: res.message,
              totalwinRussian: res.totalWinAmount,
            })
          }, 2000)

          gsap.fromTo(winpopuprspelement,
            {
              autoAlpha: 0, scale: 0, duration: 0.5,
            },
            {
              autoAlpha: 1, scale: 1, duration: 0.5, delay: 2, rotate: 0, onStart: () => {
                setTimeout(() => {
                  // winpopuprspelement.classList.add("winPopupForMLspOS");
                  // winamtElement.classList.add("winamtMpSwOS");
                  // this.setState({
                  //   infoText: res.message,
                  //   totalwinRussian: res.totalWinAmount,
                  // })
                }, 1500)

              }
            },
          )

          document.getElementById("betactiveOS").src = "";
          document.getElementById("bettextOS").style.color = "";
          document.getElementById("betactiveOS").classList.remove("betactiveOS");

          if (window.innerHeight > window.innerWidth) {
            gsap.to("#chipcenterpositionTP", { x: -20, y: -740, duration: 1, });
            gsap.to("#betchipsaddtobetTP", {
              x: -20, y: -1260, duration: 1, delay: 0.5, onComplete: () => {
                betText.textContent = this.topLable_rsp(Number((res.anteWinAmount + res.winAmount).toFixed(2)));
              }
            });
            gsap.to("#betTextaddtoBetTP", { x: 10, y: -1860, duration: 1, delay: 0.5 });

            winpopuprspelement.classList.add("winPopupForMptSwOS");
            winamtElement.classList.add("winamtMpSwOS");

            winpopuprspelement.classList.remove("winPopupForMLspOS");

          } else {

            if (document.getElementById("chipcenterpositionTP")) {
              gsap.to("#chipcenterpositionTP", { x: -630, y: -10, duration: 0.5 });
            }

            if (document.getElementById("betchipsaddtobetTP")) {
              gsap.to("#betchipsaddtobetTP", { x: -1065, y: -10, duration: 0.5, delay: 0.6 });
            }
            if (document.getElementById("betTextaddtoBetTP")) {
              gsap.to("#betTextaddtoBetTP", {
                x: -1065, y: -10, duration: 0.5, delay: 0.6, onComplete: () => {
                  betText.textContent = this.topLable_rsp(Number((res.anteWinAmount + res.winAmount).toFixed(2)));
                }
              });
            }

            setTimeout(() => {
              winpopuprspelement.classList.add("winPopupForMLspOS");
              winamtElement.classList.add("winamtMpSwOS");
            }, 2000)
          }
          this.winPopupContainer.current.showWinAnimationAndMinAmount(res.totalWinAmount);
          this.Howlersounds.current?.playSound("playerWin");
          if (this.wanttobuydelercrd === true) {
            let t1 = gsap.timeline()
            t1.to(this.buyDealerCardDrawn.current, { y: -700, duration: 0.5 });
            t1.to(this.buyDealerCardDrawn.current, { autoAlpha: 0, });
            t1.to(this.buyDealerCardDrawn.current, { autoAlpha: 0, x: 0, y: 0, zIndex: -5 });
            t1.play();
          }

          this.setState({ betbutton: "REBET", buttontext: "REBETX2", disablemultibutton: false, betchipincrementbtn: false, betdecreamentbtn: false })

          betbtntextElement.className = "";
          foldtextElement.className = "";
          this.resetPyrWnCpsAmn = true;

        }, 1000);

        this.clertime54 = setTimeout(() => {

          delaerChipAnimDiv.className = "";
          dealerchipElement.src = "";
          dealerchipElement.className = "";

          //  ------------------------------------- this.intialEnter

          // document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
          // betbutton.src = Betbtn;
          // Object.assign(betbutton.style, this.state.betbuttoncss);
          // betbtntextElement.textContent = this.props.language.Rebet;
          // // betbtntextElement.classList.add('betLandscapeOS');
          // betbtntextElement.classList.add(`${this.state.betbtntextcss}`);

          // foldbutton.src = Foldbnwindows;
          // Object.assign(foldbutton.style, this.state.foldbuttoncss);
          // foldtextElement.textContent = this.props.language.RebetX2;
          // // foldtextElement.classList.add("foldtextLandscapeOS");
          // foldtextElement.classList.add(`${this.state.foldbtntextcss}`);

          //  ------------------------------------- this.intialEnter

          this.updateplayerbalnace();
          gsap.fromTo(winpopuprspelement, { scale: 1, duration: 0.5, rotate: 360 }, {
            autoAlpha: 0, scale: 0, duration: 0.5, onComplete: () => {
              winpopuprspelement.classList.remove("winPopupForMLspOS");
              winamtElement.classList.remove("winamtMpSwOS");
            }
          })
          this.setState({
            totalbet: 0,
            totalwinRussian: 0,
            infoText: this.props.language.Play_Njoy,
            storeantebetchips: [],
          });

          gsap.to("#chipcenterpositionTP", { x: 0, y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0 });
          gsap.to("#betTextaddtoBetTP", { x: 0, y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0 });
          gsap.to("#betchipsaddtobetTP", { x: 0, y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0 });
          gsap.to(this.chipdrawref.current, { x: 0, y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0 });

          if (this.wanttobuydelercrd === true) {
            gsap.to(this.buyDealerCardDrawn.current, { autoAlpha: 0, x: 0, y: 0, zIndex: -2, duration: 0.0001 })

          }
          // gsap.set('#dealerchipTP', { x: 0, y: 0, autoAlpha: 0, zIndex: -10, duration: 0.00001 })
        }, 5000)
        break;
      // case "Dealer doesn't have a hand. Would you like to replace the dealer's higher card for the cost equivalent of ANTE? Press either NO or YES.":
      case "Dealer_no_hand":
        if (res.action !== "BUY_DEALER_CARD") {

          document.getElementById("betactiveOS").src = "";
          document.getElementById("bettextOS").style.color = "";
          betbtntextElement.className = "";
          foldtextElement.className = "";

          this.setState({ betbutton: "YES", buttontext: "NO", Yesbtn: 1, Nobtn: 1, keyboardhandle: true, disablemultibutton: false, infoText: res.message });

          // betbtntextElement.classList.add("betLandscapeOS");
          betbtntextElement.classList.add(`${this.state.betbtntextcss}`);
          betbtntextElement.textContent = this.props.language.Yes;
          betbutton.src = Betbtn;
          Object.assign(betbutton.style, this.state.betbuttoncss);

          foldtextElement.classList.add(`${this.state.foldbtntextcss}`);
          foldbutton.src = Foldbn;
          Object.assign(foldbutton.style, this.state.foldbuttoncss);
          foldtextElement.textContent = this.props.language.No;
        }
      default:
        break;
    }

  }
  ifDealerWinsMobilePortraitAction = (res) => {
    // this.playerLose = new Audio(playerLose);
    // this.playerLose.currentTime = 0;
    const winpopuprspelement = document.getElementById("winpopup_TP");
    const winamtElement = document.getElementById("winamt_TPS");
    this.clertime47 = setTimeout(() => {

      //  ------------------------------------- this.intialEnter
      // this.updateplayerbalnace();
      //  ------------------------------------- this.intialEnter
      this.setState((prevState) => ({
        infoText: res.message,
        totalwinRussian: res.totalWinAmount,
        previousAnteBetAmount: res.anteBetAmount,
        totalbet: 0,
        anteBetAmount: 0,
        prevStatestoreantebetchips: [...prevState.storeantebetchips],
        // betdeductions: 0
      }));


      this.clertime48 = setTimeout(() => {
        this.clearActivesWeDid();
      }, 1000);

      const betbutton = document.getElementById("betbtnTP");
      const foldbutton = document.getElementById("FoldbtnTP");
      const betTextaddtoBetElement = document.getElementById("betTextaddtoBetTP");


      document.getElementById("betactiveOS").src = "";
      document.getElementById("bettextOS").style.color = "";
      document.getElementById("betactiveOS").classList.remove("betactiveOS");
      this.setState({ betbutton: "REBET", buttontext: "REBETX2", betchipincrementbtn: false, betdecreamentbtn: false });
      let t1 = gsap.timeline();

      t1.to("#chipcenterpositionTP", {
        y: -2060, duration: 0.5, autoAlpha: 1,
        onComplete: () => {
          gsap.set("#chipcenterpositionTP", { autoAlpha: 0 });
        }
      });
      t1.to("#chipcenterpositionTP", {
        x: 13, y: 1200, duration: 0.0001, zIndex: -2, autoAlpha: 0,
        onComplete: () => {
          gsap.set("#chipcenterpositionTP", { autoAlpha: 0, });
        }
      });
      t1.play();


      if (window.innerHeight > window.innerWidth) {
        let t2 = gsap.timeline();
        t2.to("#betchipsaddtobetTP", {
          x: -50, y: -2060, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
          onComplete: () => {
            gsap.set("#betchipsaddtobetTP", { autoAlpha: 0 });
          }
        });
        t2.to("#betchipsaddtobetTP", {
          x: 30, y: 185, duration: 0.5, zIndex: -2, autoAlpha: 0,

        });
        t2.play();

        let t3 = gsap.timeline();
        t3.to("#betTextaddtoBetTP", {
          x: 110, y: -2000, duration: 0.5, ease: "power2.inOut", autoAlpha: 0,
          onComplete: () => {
            gsap.set("#betTextaddtoBetTP", { autoAlpha: 0 });
          }
        });
        t3.to("#betTextaddtoBetTP", {
          x: 153, y: 185, duration: 0.5, zIndex: -2, autoAlpha: 0,

        });

        t3.play();

      } else {

        let t2 = gsap.timeline();
        t2.to("#betchipsaddtobetTP", {
          y: -700, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
          onComplete: () => {
            gsap.set("#betchipsaddtobetTP", { autoAlpha: 0 });
          }
        });
        t2.to("#betchipsaddtobetTP", {
          x: 0, y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0,

        });
        t2.play();

        let t3 = gsap.timeline();
        t3.to("#betTextaddtoBetTP", {
          y: -700, duration: 0.5, ease: "power2.inOut", autoAlpha: 0,
          onComplete: () => {
            gsap.set("#betTextaddtoBetTP", { autoAlpha: 0 });
          }
        });
        t3.to("#betTextaddtoBetTP", {
          x: 0, y: 0, duration: 0.5, zIndex: -2, autoAlpha: 0,

        });

        t3.play();
      }
      if (this.wanttobuydelercrd === true) {
        let t1 = gsap.timeline()
        t1.to(this.buyDealerCardDrawn.current, { x: -190, y: -2200, duration: 0.5 });
        t1.to(this.buyDealerCardDrawn.current, { autoAlpha: 0, });
        t1.to(this.buyDealerCardDrawn.current, { autoAlpha: 0, x: 0, y: 0, zIndex: -5 });
        t1.play();
      }

      this.clertime49 = setTimeout(() => {
        this.updateplayerbalnace();
        gsap.fromTo(winpopuprspelement, { scale: 1, duration: 0.5, rotate: 360 }, {
          autoAlpha: 0, scale: 0, duration: 0.5, onComplete: () => {
            winpopuprspelement.classList.remove("winPopupForMptSwOS");
            winamtElement.classList.remove("winamtMpSwOS");
          }
        })
        // ......................................this.intialEnter
        // document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
        // this.setState({ infoText: this.props.language.Place_antebet, totalwinRussian: 0, storeantebetchips: [], });
        // betbutton.src = Betbtn;
        // // Object.assign(betbutton.style, porttraitejson.Betbtnportraite);
        // Object.assign(betbutton.style, this.state.betbuttoncss);

        // foldbutton.src = Foldbn;
        // // Object.assign(foldbutton.style, porttraitejson.foldbtnportraite);
        // Object.assign(foldbutton.style, this.state.foldbuttoncss);
        // document.getElementById("betbtntextTP").textContent = this.props.language.Rebet;

        // document.getElementById("betbtntextTP").classList.add(`${this.state.betbtntextcss}`);
        // document.getElementById("foldtextTP").classList.add(`${this.state.foldbtntextcss}`);
        // // document.getElementById("betbtntextTP").classList.add("betportraitOS");
        // // document.getElementById("foldtextTP").classList.add("rebettextportraitOS");

        // document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;
        // ......................................this.intialEnter
      }, 3000);

      // this.Howlersounds.current?.playSound("playerLose");

    }, 2000);
  }

  suffleDealerCards = (data) => {
    let cnt = data.length;
    for (let i = 0; i < cnt; i++) {
      let b1 = data[i];
      // this.cardsshuffle = new Audio(cardsshuffle);

      switch (i) {
        case 0:
          this.dealerCardsContainer.current.SuffleCard("cardZero", b1, cnt);
          break;
        case 1:
          this.dealerCardsContainer.current.SuffleCard("cardOne", b1, cnt);
          break;
        case 2:
          this.dealerCardsContainer.current.SuffleCard("cardTwo", b1, cnt);
          break;
        case 3:
          this.dealerCardsContainer.current.SuffleCard("cardThree", b1, cnt);
          break;
        case 4:
          this.dealerCardsContainer.current.SuffleCard("cardFour", b1, cnt);
          break;
        case 5:
          this.dealerCardsContainer.current.SuffleCard("cardFive", b1, cnt);
          break;
        default:
          break;
      }
    }
  };

  OSReplaceCards = (res, actionName) => {
    // let handrank = "One Pair , Ace-King".split(" , ");
    // this.setState({ playerrankinghand: handrank })
    this.drawReplaceCards = true;
    // this.intialEnter = false;
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      // this.insurenceactiveornot(res);
      // this.Showbonustouser(res);
      setTimeout(() => {
        let t4 = gsap.timeline();
        t4.to("#betchipsaddtodrawOS", {
          x: -1084, y: -1266, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
          onComplete: () => {
            gsap.set("#betchipsaddtodrawOS", { autoAlpha: 0 });
          }
        });
        t4.to("#betchipsaddtodrawOS", {
          x: 0, y: 0, zIndex: -10, duration: 0.1, autoAlpha: 0, delay: 0.5
          // x: 100, y: -135, zIndex: -10, duration: 0.1, autoAlpha: 0, delay: 0.5
        });
        gsap.to("#betTextaddtodrawOS", { autoAlpha: 0, duration: 0.1, zIndex: -15 })
        gsap.to("#betchipsaddtodrawTextTP", { autoAlpha: 0, zIndex: -2, delay: 1 })
      }, 3000)

    } else {


      setTimeout(() => {
        let t4 = gsap.timeline();
        t4.to(this.chipdrawref.current, {
          x: this.state.drawChipXd, y: this.state.drawChipYd, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
          onComplete: () => {
            gsap.set(this.chipdrawref.current, { autoAlpha: 0 });
          }
        });
        t4.to(this.chipdrawref.current, {
          x: this.state.drawChipRetrunXd, y: this.state.drawChipRetrunYd, zIndex: -10, duration: 0.1, autoAlpha: 0, delay: 0.5

        });
        // gsap.to("#betTextaddtodrawOS", { autoAlpha: 0, duration: 0.1, zIndex: -15, delay: 1})

        gsap.to("#betchipsaddtodrawTextTP", { autoAlpha: 0, zIndex: -2, delay: 1 })
      }, 3000)

    }

    this.unsequenceDrawCards = [];
    this.sequenceDrawCards = [];
    this.replaceCards = []
    // console.log(res);

    this.unsequenceDrawCards = [...res.playerCards];
    this.sequenceDrawCards = [...res.playerFinalCards];
    let cnt = this.unsequenceDrawCards.length;

    let numberOfCardsToDraw = res.playerNewCardsToReplace.length;
    for (let i = 0; i < cnt; i++) {

      var b1 = this.unsequenceDrawCards[i];

      switch (i) {
        case 0:
          if (this.shuffledPlayerCards[0] != b1) {
            this.cardsRef.current.Drawcard("cardZero", b1, cnt);
          }
          break;
        case 1:
          if (this.shuffledPlayerCards[1] != b1) {
            this.cardsRef.current.Drawcard("cardOne", b1, cnt);
          }
          break;
        case 2:
          if (this.shuffledPlayerCards[2] != b1) {
            this.cardsRef.current.Drawcard("cardTwo", b1, cnt);
          }
          break;
        case 3:
          if (this.shuffledPlayerCards[3] != b1) {
            this.cardsRef.current.Drawcard("cardThree", b1, cnt);
          }
          break;
        case 4:
          if (this.shuffledPlayerCards[4] != b1) {
            this.cardsRef.current.Drawcard("cardFour", b1, cnt);
          }
          break;
        case 5:
          if (this.shuffledPlayerCards[5] != b1) {
            this.cardsRef.current.Drawcard("cardFive", b1, cnt);
          }
          break;
        default:
          break;
      }

    }

    this.clertime8 = setTimeout(() => {
      this.highlightPlayerCardsName(res.playerHand);
      if (this.state.isMobilePortraitLndsp === true) {
        document.getElementById("playerDealerCardContainerTP").style.zIndex = 1;
      }
      this.setState({ pokerranking: res.playerHand })
      this.onDrawingCards(this.sequenceDrawCards, true, res, true);
      this.shuffledPlayerCards = [...this.sequenceDrawCards];

      const drawbutton = document.getElementById("drawbtnTP");
      document.getElementById("drawtextTP").textContent = "";

      drawbutton.src = "";
      drawbutton.style.cssText = "";


      // }, numberOfCardsToDraw * 2 * 900);
    }, numberOfCardsToDraw * 2 * 500);

  };

  ShowrpReplaceCards = (res) => {

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

    } else {

      this.setState({ infoText: res.message });
      this.showcardsAdBetsParamState(res, res.playerFinalCards, res.dealerCards)
    }

    this.highlightPlayerCardsName(res.playerHand);
    if (this.state.isMobilePortraitLndsp === true) {
      document.getElementById("playerDealerCardContainerTP").style.zIndex = 1;
    }
    this.setState({ pokerranking: res.playerHand })
    const drawbutton = document.getElementById("drawbtnTP");
    const buybutton = document.getElementById("buybtnTP");
    document.getElementById("drawtextTP").textContent = "";
    drawbutton.src = "";
    drawbutton.style.cssText = "";
    buybutton.src = "";
    buybutton.style.cssText = "";

  };
  ShowBuyplayercardresp(res, actionName) {
    console.log(res)
    const drawbutton = document.getElementById("drawbtnTP");
    const buybutton = document.getElementById("buybtnTP");
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      document.getElementById("crdscoverOS").classList.add("crdscoverOS")

      document.getElementById("rankinginfoOS").classList.add("windowspokerrankingOS");
      this.setState({
        infoText: res.message,
        pokerranking: res.playerHand,
        totalbet: res.totalBetAmount,
        anteBetAmount: res.anteBetAmount,
        buttontext: "fold",
        betbutton: "Bet",
        FoldbtnTP: 0,
        betBtnValue: 1,
        disBetBtn: 0,
        keyboardhandle: true

      });
      this.showcardsAdBetsParamState(res, res.playerFinalCards, res.dealerCards);
      const betbutton = document.getElementById("betbtnTP");
      const foldbutton = document.getElementById("FoldbtnTP");

      betbutton.src = Betbtn;
      Object.assign(betbutton.style, porttraitejson.Betbtnwindows);
      document.getElementById("betbtntextTP").textContent = this.props.language.Bet;
      document.getElementById("betbtntextTP").classList.add("betwindowsOS");


      foldbutton.src = Foldbnwindows;
      Object.assign(foldbutton.style, porttraitejson.foldbtnwindows);
      document.getElementById("foldtextTP").textContent = this.props.language.Fold;
      document.getElementById("foldtextTP").classList.add("foldtextwindowsOS");

      let betexttodraw = document.getElementById("betTextaddtodrawOS");
      gsap.to("#betTextaddtodrawOS", { autoAlpha: 0, zIndex: 15 })
      let betchipsdraw = document.getElementById("betchipsaddtodrawOS");


      Object.assign(betchipsdraw.style, porttraitejson.betchipsdrawwindows)

      let betTextaddtoBetClass = "bet-text-addtodraw20OS";
      // this.setState((prevState) => ({
      //   totalbet: prevState.totalbet + prevState.anteBetAmount

      // }));
      if (res.playerBuyCardAmount > 0) {
        betexttodraw.textContent = this.topLable_rsp(res.playerBuyCardAmount);
      }
      else {
        betexttodraw.textContent = this.topLable_rsp(res.playerReplaceCardAmount);
      }

      switch (this.state.count) {
        case 1:
          betchipsdraw.src = chip_10;
          betTextaddtoBetClass = "bet-text-addtodraw10OS";
          break;
        case 2:
          betchipsdraw.src = chip_25;
          betexttodraw.textContent = this.chipVal[1].label;
          break;
        case 3:
          betchipsdraw.src = chip_50;
          break;
        case 4:
          betchipsdraw.src = chip_100;
          break;
        case 5:
          betchipsdraw.src = chip_500;
          break;
        case 6:
          betchipsdraw.src = chip_1000;
          break;

        default:
          break;
      }
      this.clertime45 = setTimeout(() => {
        betexttodraw.classList.add(betTextaddtoBetClass, "bet-text-addtodrawOS");

      }, 100)

      this.setState({ infoText: res.message });

    } else {
      if (window.innerWidth < window.innerHeight) {
        document.getElementById("betpannelTropicalcover").style.display = "block";
        document.getElementById("betpannelTropicalcover").classList.add("PlayerCardpannelcoverPortraitOS");
      } else {
        document.getElementById("betpannelTropicalcover").style.display = "block";
      }

      this.setState({
        infoText: res.message,
        pokerranking: res.playerHand,
        totalbet: res.totalBetAmount,
        anteBetAmount: res.anteBetAmount,
        buttontext: "fold",
        betbutton: "Bet",
        buydrawCheck: true
      });

      document.getElementById("betbtntextTP").innerHTML = "";
      document.getElementById("betbtntextTP").className = "";
      document.getElementById("foldtextTP").className = "";
      document.getElementById("foldtextTP").textContent = "";
      document.getElementById("drawtextTP").textContent = "";


      this.showcardsAdBetsParamState(res, res.playerFinalCards, res.dealerCards);

      this.showParamBetStatus(false);

      if (res.playerReplaceCardAmount > 0 || res.playerBuyCardAmount > 0) {
        //  if(res.playerBuyCardAmount > 0){
        this.prevstateBuyorDrawChip(res);
      }
      drawbutton.src = "";
      drawbutton.style.position = "";
      drawbutton.style.height = "";
      drawbutton.style.width = "";
      drawbutton.style.transform = "";

      document.getElementById("drawtextTP").textContent = "";

      buybutton.src = "";
      buybutton.style.position = "";
      buybutton.style.width = "";

    }
  }

  prevstateBuyorDrawChip = (res) => {
    let betchipsaddtodrawContainerElement = document.getElementById("betchipsaddtodrawContainerTP");
    let betchipsdraw = document.getElementById("betchipsaddtodrawOS");
    let betTextaddtodrawElement = document.getElementById("betchipsaddtodrawTextTP");
    const rankinginfoElement = document.getElementById("rankinginfoOS");

    let betactiveOS
    if (window.innerWidth > window.innerHeight) {
      betactiveOS = "betactiveLndspOS";
      // betactiveOS = this.state.betactvglwcss;

    } else {
      betactiveOS = "betactivePortraitOS";
      // betactiveOS = this.state.betactvglwcss;

    }
    // console.log(typeof res.betAmount, res.betAmount > 0, Number(res.betAmount) > 0)
    if (res.betAmount > 0) {
      document.getElementById("betactiveOS").src = "";
      document.getElementById("betactiveOS").className = "";
    } else {
      document.getElementById("betactiveOS").src = bnsactiveTP;
      document.getElementById("betactiveOS").classList.add(betactiveOS);

    }


    let convrBuy = this.topLable_rsp(res.anteBetAmount);
    let buyordraw = res.anteBetAmount;
    if (res.playerReplaceCardAmount > 0) {
      convrBuy = this.topLable_rsp(res.playerReplaceCardAmount);
      buyordraw = res.playerReplaceCardAmount;

    }
    this.highlightPlayerCardsName(res.playerHand);
    let betTextaddtodrawElementClass = "bet-text-addtoBet20OS";
    betchipsdraw.src = this.ReturnChipBasedAmount(buyordraw);
    switch (this.state.count) {
      case 1:
        // betchipsdraw.src = chip_10;
        // betTextaddtodrawElement.textContent = 10;
        betTextaddtodrawElement.textContent = convrBuy;
        betTextaddtodrawElementClass = "bet-text-addtoBet10OS";
        break;
      case 2:
        // betchipsdraw.src = chip_25;
        betTextaddtodrawElement.textContent = convrBuy;
        break;
      case 3:
        // betchipsdraw.src = chip_50;
        betTextaddtodrawElement.textContent = convrBuy;
        break;
      case 4:
        // betchipsdraw.src = chip_100;
        betTextaddtodrawElement.textContent = convrBuy;
        break;
      case 5:
        // betchipsdraw.src = chip_500;
        betTextaddtodrawElement.textContent = convrBuy;
        break;
      case 6:
        // betchipsdraw.src = chip_1000;
        betTextaddtodrawElement.textContent = convrBuy;
        break;

      default:
        betTextaddtodrawElementClass = "bet-text-addtoBet20OS";
        break;
    }


    this.buydrawchipactivated = true;
    if (window.innerHeight > window.innerWidth) {
      document.getElementById("playerDealerCardContainerTP").style.zIndex = 1;
      document.getElementById("betpannelTropicalcover").style.display = "block";
      document.getElementById("betpannelTropicalcover").classList.add("pannelcoverTP");
      document.getElementById("betbtntextTP").classList.remove("betportraitOS");
      document.getElementById("foldtextTP").classList.remove("foldtextportraitOS");

      betchipsaddtodrawContainerElement.classList.add("drawChipDivOS");
      betTextaddtodrawElement.className = "";
      betTextaddtodrawElement.style.color = "#ffffff";

      // betTextaddtodrawElement.classList.add('betTextaddtodrawOS', betTextaddtodrawElementClass);

      betchipsdraw.classList.add("betchipsaddtodrawOS")
      rankinginfoElement.classList.add("pokerrankingPortaitOS");
      gsap.to(this.chipdrawref.current, {
        // x: 360,
        x: 389,
        y: -741,
        duration: 0.000001,
        zIndex: 12,
        autoAlpha: 1,
        onStart: () => {
          gsap.set(this.chipdrawref.current, { autoAlpha: 1 });
        }
      });

    } else {

      // document.getElementById("playerDealerCardContainerTP").style.zIndex = 20;
      document.getElementById("betpannelTropicalcover").style.display = "block";
      document.getElementById("betpannelTropicalcover").classList.add("PlayerCardpannelcoverLndspOS");
      document.getElementById("betbtntextTP").classList.remove("betLandscapeOS");
      document.getElementById("foldtextTP").classList.remove("foldtextLandscapeOS");

      betchipsaddtodrawContainerElement.classList.add("drawChipDivLndspOS");
      betTextaddtodrawElement.className = "";
      betTextaddtodrawElement.style.cssText = "";
      betTextaddtodrawElement.style.color = "#ffffff";
      // betTextaddtodrawElement.classList.add(betTextaddtodrawElementClass, 'betTextaddwLndspOS');

      betchipsdraw.classList.add("betchipsaddtodrawOS")
      rankinginfoElement.classList.add("pokerrankingPlayerLndspOS");
      gsap.to(this.chipdrawref.current, {
        x: -1230,
        y: 0,
        duration: 0.00001,
        zIndex: 12,
        autoAlpha: 1,
        onStart: () => {
          gsap.set(this.chipdrawref.current, { autoAlpha: 1 });
        }
      });

    }

    if (rankinginfoElement) {
      if (window.innerHeight > window.innerWidth) {

        if (this.state.isMobilePortraitLndsp) {
          rankinginfoElement.style.left = "35%";
        }
      } else {
        if (this.state.isMobilePortraitLndsp) {
          // rankinginfoElement.style.left = "62.5%";
          rankinginfoElement.style.left = "43.5%";
        }
      }
    };

    if (this.state.isMobilePortraitLndsp) {
      document.getElementById("playerDealerCardContainerTP").style.zIndex = 1;
    }
  }
  FoldCards() {

    if (this.state.PayoutTableToggle) {
      this.setState({ PayoutTableToggle: false });
    }
    this.Howlersounds.current?.playSound("betchipsnd");
    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }
    this.clearallsettimeouts()
    const drawbutton = document.getElementById("drawbtnTP");
    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");


    document.getElementById("drawtextTP").textContent = "";

    betbutton.src = "";
    betbutton.style.cssText = ""

    foldbutton.src = "";
    foldbutton.style.cssText = ""

    drawbutton.src = "";
    drawbutton.style.cssText = ""


    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      this.setState({ FoldbtnTP: 1 })
      // document.getElementById("betTextaddtodrawOS").style.zIndex=-1
      document.getElementById("betbtntextTP").classList.remove("betwindowsOS");
      document.getElementById("foldtextTP").classList.remove("foldtextwindowsOS");
      document.getElementById("drawtextTP").textContent = "";
      document.getElementById("betbtntextTP").textContent = "";

    } else {
      this.setState({ betchipincrementbtn: false, betdecreamentbtn: false });

      document.getElementById("betbtntextTP").classList.remove("betportraitOS");
      document.getElementById("foldtextTP").classList.remove("foldtextportraitOS");
      document.getElementById("betbtntextTP").textContent = "";
      document.getElementById("foldtextTP").textContent = "";

    }

    const body = {
      sessionId: sessionStorage.getItem("sessionId"),

      CN: "POKER_GOLDEN_OASIS_BET",
      object: {
        action: "FOLD",
        gameId: this.props.gameId,
        playerId: Number(this.props.playerId),
        handId: Number(this.props.gameState.handId)
      },
    };
    // console.log(body);
    this.props.network.sendof(body);
  }

  FoldHandresp(res) {
    console.log(res)
    // this.intialEnter = false;
    document.getElementById("bettextOS").style.color = "";
    if (res.message === `Attention! You have a ${res.playerHand}. Are you sure you want to fold?`) {
      this.setState({ cmfrmdealeraction: 2, cmfrmdealeractionNO: 2 })
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        const drawbutton = document.getElementById("drawbtnTP");
        const buybutton = document.getElementById("buybtnTP");
        const betbutton = document.getElementById("betbtnTP");
        const foldbutton = document.getElementById("FoldbtnTP");

        const drawtextElement = document.getElementById("drawtextTP");
        const betbtntextElement = document.getElementById("betbtntextTP");
        const foldtextElement = document.getElementById("foldtextTP");

        betbtntextElement.textContent = "";
        foldtextElement.textContent = "";

        drawbutton.src = "";
        drawbutton.style.cssText = "";

        buybutton.src = "";
        buybutton.style.cssText = "";

        betbutton.src = "";
        betbutton.style.cssText = "";

        foldbutton.src = "";
        foldbutton.style.cssText = "";

        document.getElementById("confirmbuydealer_popupTP").style.display = "block";
        document.getElementById("alertTxtOS").classList.add("alertTxtOS");

        document.getElementById("alertTxtOS").innerHTML = res.message;
        document.getElementById("confirmbuydealer_popupTP").classList.add("popup_cnfrmbuydealrcardOS");
        document.getElementById("yesTP").classList.add("yesbutton_popupOS")
        document.getElementById("noTP").classList.add("nobutton_popupOS")

      }
      else {
        const confirmbuydealerPopupElement = document.getElementById("confirmbuydealer_popupTP");

        setTimeout(() => {
          document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
          document.getElementById("betpannelTropicalcover").style.display = "none";
        }, 500)
        if (window.innerHeight > window.innerWidth) {

          confirmbuydealerPopupElement.className = "";
          confirmbuydealerPopupElement.style.display = "block";
          confirmbuydealerPopupElement.classList.add("popup_cnfrmbuydealrcardPortrait_OS");
          document.getElementById("alertTxtOS").innerHTML = res.message;
          document.getElementById("alertTxtOS").classList.add('alertTxtPortraitOS');
          document.getElementById("yesTP").classList.add("yesbutton_popup_portraitOS")
          document.getElementById("noTP").classList.add("nobutton_popup_portraitOS")
        }
        else {
          confirmbuydealerPopupElement.style.display = "block";
          confirmbuydealerPopupElement.classList.add("popup_cnfrmbuydealrcardLndsp_OS");
          document.getElementById("alertTxtOS").innerHTML = res.message;
          document.getElementById("alertTxtOS").classList.add('alertTxtPortraitOS');
          document.getElementById("yesTP").classList.add("yesbutton_popup_portraitOS")
          document.getElementById("noTP").classList.add("nobutton_popup_portraitOS")

        }
      }
    }
    else {
      // this.Howlersounds.current?.playSound("playerLose");

      //  ------------------------------------- this.intialEnter
      setTimeout(() => {
        this.updateplayerbalnace();
      }, 2000)
      //  ------------------------------------- this.intialEnter
      const betbutton = document.getElementById("betbtnTP");
      const foldbutton = document.getElementById("FoldbtnTP");
      this.clertime10 = setTimeout(() => {
        this.setState({ infoText: this.props.language.Place_antebet });
      }, 1000);

      document.getElementById("betactiveOS").src = "";
      document.getElementById("betactiveOS").classList.remove("betactiveOS");
      // document.getElementById("betpannelTropicalcover").style.display = "block";

      // this.setState({ betbutton: "REBET", buttontext: "REBETX2" })
      // const betbutton = document.getElementById("betbtnTP");
      // const foldbutton = document.getElementById("FoldbtnTP");
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        this.clertime10 = setTimeout(() => {
          this.setState({ infoText: this.props.language.Place_antebet });
        }, 1500);
        gsap.set("#betTextaddtodrawOS ,betchipsaddtconfrmTP", { zIndex: -2, autoAlpha: 0, duration: 0.1 })
        this.setState((prevState) => ({
          previousAnteBetAmount: res.anteBetAmount,
          totalbet: 0,
          totalwinRussian: 0,
          anteBetAmount: 0,
          // betdeductions: 0,
          betbutton: "REBET",
          buttontext: "REBETX2",
          keyboardhandle: true,
          betBtnValue: 2,
          disBetBtn: 0,
          infoText: res.message,
          betchipincrementbtn: false, betdecreamentbtn: false
        }));
        this.cardsRef.current.ReBet();
        this.dealerCardsContainer.current.ReBet();
        document.getElementById("rankinginfodelerOS").classList.remove("windowspokerrankingdelerOS");
        document.getElementById("rankinginfoOS").classList.remove("windowspokerrankingOS");

        document.getElementById("betdecrementTP").classList.remove("drwnodropOS")
        document.getElementById("betincrenetTP").classList.remove("drwnodropOS")


        // this.clertime11=this.setSafeTimeout(() => {
        //  ------------------------------------- this.intialEnter
        // setTimeout(() => {
        //   document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelcoverOS");

        //   document.getElementById("betbtntextTP").textContent = "";
        //   document.getElementById("foldtextTP").textContent = "";
        //   betbutton.src = Betbtn;
        //   Object.assign(betbutton.style, porttraitejson.Betbtnwindows)

        //   document.getElementById("betbtntextTP").innerHTML = this.props.language.Rebet;
        //   document.getElementById("betbtntextTP").classList.add("betwindowsOS");

        //   foldbutton.src = Foldbnwindows;
        //   Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)
        //   document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;
        //   document.getElementById("foldtextTP").classList.add("rebettextwindowsOS");
        // }, 2000)

        //  ------------------------------------- this.intialEnter


        gsap.set("#betTextaddtodrawOS ,betchipsaddtconfrmTP", { zIndex: -2, autoAlpha: 0, duration: 0.1 })
        let t1 = gsap.timeline();
        t1.to("#chipcenterpositionTP", {
          // y: -2060, duration: 20.5, autoAlpha: 1,
          x: 0, y: -662, duration: 0.2, autoAlpha: 1,
          onComplete: () => {
            gsap.set("#chipcenterpositionTP", { autoAlpha: 0 });
          }
        });
        t1.to("#chipcenterpositionTP", {
          x: 955, y: 554, duration: 0.1, zIndex: -12, autoAlpha: 0,
          onComplete: () => {
            gsap.set("#chipcenterpositionTP", { autoAlpha: 0 });
          }

        });

        t1.play();
        // document.getElementById("centerchipsTP").classList.remove("chip10centerpositionGO")

        // gsap.to("#betTextaddtodrawOS,betchipsaddtodrawTextTP", { autoAlpha: 0, duration: 0.1 })


        let t2 = gsap.timeline();
        t2.to("#betchipsaddtodrawOS, betchipsaddtconfrmTP", {
          x: -1082,
          y: -1267, duration: 0.5, autoAlpha: 1,
          onComplete: () => {
            gsap.set("#betchipsaddtodrawOS ,betchipsaddtconfrmTP", { autoAlpha: 0 });
          }
        });
        t2.to("#betchipsaddtodrawOS ,betchipsaddtconfrmTP", {
          x: 45, y: -54, duration: 0.5, zIndex: -2, autoAlpha: 0,

          onComplete: () => {
            gsap.set("#betchipsaddtodrawOS ,betchipsaddtconfrmTP", { autoAlpha: 0, delay: 2 });

          }

        });
        t2.play();


        gsap.to("#betchipsaddtodrawTextTP", { autoAlpha: 0, duration: 0.1, zIndex: -2 })

        let centerbns = gsap.timeline();

        gsap.set(["#betchipsaddtconfrmTP", "#betchipsaddtodrawOS", "#chipcenterpositionTP", "#betchipsaddtobetTP"], { clearProps: "all" });
      }
      else {
        this.clertime10 = setTimeout(() => {
          this.setState({ infoText: this.props.language.Place_antebet });
        }, 1000);
        this.setState((prevState) => ({
          previousAnteBetAmount: prevState.anteBetAmount,
          totalbet: 0,
          totalwinRussian: 0,
          anteBetAmount: 0,
          prevStatestoreantebetchips: [...prevState.storeantebetchips],
          // betdeductions: 0,
          betbutton: "REBET",
          buttontext: "REBETX2",
          infoText: res.message,
        }));
        //  ------------------------------------- this.intialEnter

        // setTimeout(() => {
        //   betbutton.src = Betbtn;
        //   //document.getElementById("betbtntextTP").textContent = "";
        //   document.getElementById("betbtntextTP").innerHTML = this.props.language.Rebet;
        //   document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;
        // }, 1500)

        //  ------------------------------------- this.intialEnter

        const betbtntextElement = document.getElementById("betbtntextTP");
        const foldtextElement = document.getElementById("foldtextTP");
        const betactiveBlinkElement = document.getElementById("betactiveOS");

        const drawbtnElement = document.getElementById("drawbtnTP");
        const buybtnElement = document.getElementById("buybtnTP");
        const drawtextElment = document.getElementById("drawtextTP");

        if (res.action === "CONFIRM_FOLD") {
          if (drawbtnElement && drawtextElment) {
            drawbtnElement.src = "";
            buybtnElement.src = "";
            drawtextElment.textContent = "";
          }

          if (window.innerHeight > window.innerWidth) {
            let t4 = gsap.timeline();
            t4.to(this.chipdrawref.current, {
              // x: 360, y: -2060, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
              x: 340, y: -2060, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
              onComplete: () => {
                gsap.set(this.chipdrawref.current, { autoAlpha: 0 });
              }
            });
            t4.to(this.chipdrawref.current, {
              x: 608, y: -116, duration: 0.5, zIndex: -2, autoAlpha: 0,
              onComplete: () => {
                gsap.set(this.chipdrawref.current, { autoAlpha: 1, delay: 2 });
              }
            });

            t4.play();

          } else {
            let t4 = gsap.timeline();
            t4.to(this.chipdrawref.current, {
              y: -700, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
              onComplete: () => {
                gsap.set(this.chipdrawref.current, { autoAlpha: 0 });
              }
            });
            t4.to(this.chipdrawref.current, {
              x: 0, y: 0, duration: 0.5, zIndex: -2, autoAlpha: 0,
              onComplete: () => {
                gsap.set(this.chipdrawref.current, { autoAlpha: 0, });
              }
            });

            t4.play();
          }

        }

        betactiveBlinkElement.src = "";
        betactiveBlinkElement.classList.remove("betactivePortraitOS");
        let rankinginfoElement = document.getElementById("rankinginfoOS");
        rankinginfoElement.className = "";
        rankinginfoElement.textContent = "";


        setTimeout(() => {

          this.clearActivesWeDid();
        }, 500)

        //  ------------------------------------- this.intialEnter
        // setTimeout(() => {
        //   betbutton.src = Betbtn;
        //   foldbutton.src = Foldbn;
        //   document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
        // }, 1500)
        //  ------------------------------------- this.intialEnter
        if (window.innerHeight > window.innerWidth) {

          //  ------------------------------------- this.intialEnter

          // setTimeout(() => {
          //   Object.assign(betbutton.style, this.state.betbuttoncss)
          //   Object.assign(foldbutton.style, this.state.foldbuttoncss);

          //   betbtntextElement.textContent = this.props.language.Rebet;
          //   foldtextElement.textContent = this.props.language.RebetX2;
          //   // porttraitejson.betportraiteTP
          //   // betbtntextElement.classList.add("betportraitOS");
          //   betbtntextElement.classList.add(this.state.betbtntextcss);
          //   // foldtextElement.classList.add("rebettextportraitOS");
          //   foldtextElement.classList.add(this.state.foldbtntextcss);
          // }, 1500)

          //  ------------------------------------- this.intialEnter

          let t1 = gsap.timeline();
          t1.to("#chipcenterpositionTP", {
            // x:25, y: 1200, duration: 0.2, autoAlpha: 1,
            x: 25, y: -2060, duration: 0.2, autoAlpha: 1,
            onComplete: function () {
              gsap.set("#chipcenterpositionTP", { autoAlpha: 0 });
            }
          });
          t1.to("#chipcenterpositionTP", {
            // x: 13,
            y: -1130, duration: 0.0001, zIndex: -12, autoAlpha: 0,
            onComplete: function () {
              gsap.set("#chipcenterpositionTP", { autoAlpha: 0, });
            }

          });
          t1.play();

          if (this.state.buydrawCheck) {

            let t4 = gsap.timeline();
            t4.to(this.chipdrawref.current, {
              x: 340, y: -2060, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
              // x: 360, y: -2060, duration: 0.5, zIndex: 12, ease: "power2.inOut", autoAlpha: 1,
              onComplete: () => {
                gsap.set(this.chipdrawref.current, { autoAlpha: 0 });
              }
            });
            t4.to(this.chipdrawref.current, {
              x: 608, y: -116, duration: 0.5, zIndex: -2, autoAlpha: 0,
              onComplete: () => {
                gsap.set(this.chipdrawref.current, { autoAlpha: 1, delay: 2 });
              }
            });
            t4.play();
          }

        } else {

          // IF MOBILE LANDSCAPE ;


          //  ------------------------------------- this.intialEnter
          // setTimeout(() => {
          //   Object.assign(betbutton.style, this.state.betbuttoncss)
          //   Object.assign(foldbutton.style, this.state.foldbuttoncss);

          //   betbtntextElement.textContent = this.props.language.Rebet;
          //   foldtextElement.textContent = this.props.language.RebetX2;
          //   // porttraitejson.betportraiteTP
          //   // betbtntextElement.classList.add("betLandscapeOS");
          //   betbtntextElement.classList.add(this.state.betbtntextcss);
          //   // foldtextElement.classList.add("foldtextLandscapeOS");
          //   foldtextElement.classList.add(this.state.foldbtntextcss);
          // }, 1500)

          //  ------------------------------------- this.intialEnter

          let t1 = gsap.timeline();
          t1.to("#chipcenterpositionTP",
            { x: 0, y: -600, duration: 0.5, autoAlpha: 1, ease: "power2.inOut", });
          t1.to("#chipcenterpositionTP",
            { x: 0, y: 0, duration: 0.0001, zIndex: -12, autoAlpha: 0 });
          t1.play();

          if (this.state.buydrawCheck) {
            let t4 = gsap.timeline();
            t4.to(this.chipdrawref.current, { y: -600, duration: 0.3, ease: "power2.inOut", autoAlpha: 1 });
            t4.to(this.chipdrawref.current, { x: 0, y: 0, duration: 0.0001, zIndex: -2, autoAlpha: 0 });
            t4.play();
          }

        }

      }
    }

  }
  Show_FoldHandresp(res) {

    if (res.message === `Attention! You have a ${res.playerHand}. Are you sure you want to fold?`) {
      if (res.playerReplaceCardAmount > 0 || res.playerBuyCardAmount > 0) {
        this.drawReplaceCards = true;
      }
      this.setState({ cmfrmdealeraction: 2, cmfrmdealeractionNO: 2, infoText: res.message })

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        this.showcardsAdBetsParamState(res, res.playerFinalCards, res.dealerCards);
        this.showParamBetStatus(false);
        this.ShowbonusstatusTousr(res);

        document.getElementById("confirmbuydealer_popupTP").style.display = "block";
        document.getElementById("alertTxtOS").classList.add("alertTxtOS");

        document.getElementById("alertTxtOS").innerHTML = res.message;
        document.getElementById("confirmbuydealer_popupTP").classList.add("popup_cnfrmbuydealrcardOS");
        document.getElementById("yesTP").classList.add("yesbutton_popupOS")
        document.getElementById("noTP").classList.add("nobutton_popupOS")

      }

    }
    else {
      this.updateplayerbalnace();
      const betbutton = document.getElementById("betbtnTP");
      const foldbutton = document.getElementById("FoldbtnTP");
      this.clertime10 = setTimeout(() => {
        this.setState({ infoText: this.props.language.Place_antebet });
      }, 700);

      document.getElementById("betactiveOS").src = "";
      document.getElementById("betactiveOS").classList.remove("betactiveOS");
      // document.getElementById("betpannelTropicalcover").style.display = "block";
      document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelcoverOS");

      // this.setState({ betbutton: "REBET", buttontext: "REBETX2" })
      // const betbutton = document.getElementById("betbtnTP");
      // const foldbutton = document.getElementById("FoldbtnTP");
      betbutton.src = Betbtn;
      //document.getElementById("betbtntextTP").textContent = "";
      document.getElementById("betbtntextTP").innerHTML = this.props.language.Rebet;
      document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        this.setState((prevState) => ({
          previousAnteBetAmount: res.anteBetAmount,
          totalbet: 0,
          anteBetAmount: 0,
          betdeductions: 0,
          betbutton: "REBET",
          buttontext: "REBETX2",
          keyboardhandle: true,
          betBtnValue: 2,
          disBetBtn: 0,
          infoText: res.message
        }));

        this.cardsRef.current.ReBet();
        this.dealerCardsContainer.current.ReBet();
        document.getElementById("rankinginfodelerOS").classList.remove("windowspokerrankingdelerOS");
        document.getElementById("rankinginfoOS").classList.remove("windowspokerrankingOS");

        document.getElementById("betbtntextTP").textContent = "";
        document.getElementById("foldtextTP").textContent = "";
        // this.clertime11=setTimeout(() => {

        betbutton.src = Betbtn;
        Object.assign(betbutton.style, porttraitejson.Betbtnwindows)

        document.getElementById("betbtntextTP").innerHTML = this.props.language.Rebet;
        document.getElementById("betbtntextTP").classList.add("betwindowsOS");


        foldbutton.src = Foldbnwindows;
        Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)
        document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;
        document.getElementById("foldtextTP").classList.add("rebettextwindowsOS");
        this.setState({ infoText: this.props.language.Place_antebet, });

        let t1 = gsap.timeline();
        t1.to("#chipcenterpositionTP", {
          // y: -2060, duration: 20.5, autoAlpha: 1,
          x: 0, y: -662, duration: 0.2, autoAlpha: 1,
          onComplete: () => {
            gsap.set("#chipcenterpositionTP", { autoAlpha: 0 });
          }
        });
        t1.to("#chipcenterpositionTP", {
          x: 955, y: 554, duration: 0.1, zIndex: -12, autoAlpha: 0,
          onComplete: () => {
            gsap.set("#chipcenterpositionTP", { autoAlpha: 0 });
          }

        });

        t1.play();
        // document.getElementById("centerchipsTP").classList.remove("chip10centerpositionGO")


        let t2 = gsap.timeline();
        t2.to("#betchipsaddtodrawOS, betchipsaddtconfrmTP", {
          x: -1082,
          y: -1267, duration: 0.5, autoAlpha: 1,
          onComplete: () => {
            gsap.set("#betchipsaddtodrawOS ,betchipsaddtconfrmTP", { autoAlpha: 0 });
          }
        });
        t2.to("#betchipsaddtodrawOS ,betchipsaddtconfrmTP", {
          x: 45, y: -54, duration: 0.5, zIndex: -2, autoAlpha: 0,
          onComplete: () => {
            gsap.set("#betchipsaddtodrawOS ,betchipsaddtconfrmTP", { autoAlpha: 0, delay: 2 });
          }

        });
        t2.play();
      }
    }
  }


  TotalbetamountGreaterthanbalance(betamnt) {
    let balance = this.balnce;

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      if (this.state.totalbet > this.props.balance) {

        document.getElementById("infoTropicalP").classList.add("windowsinfoOS");
        document.getElementById("betbtnTP").classList.remove("addpointerOS")
        document.getElementById("FoldbtnTP").classList.remove("addpointerOS")
        document.getElementById("betbtnTP").classList.add("drwnodropOS")
        document.getElementById("FoldbtnTP").classList.add("drwnodropOS")

        this.setState({
          infoText: this.props.language.Low_Balance,
          disablemultibutton: false,
          multibuttonsebledsble: false


        });
        document.getElementById("betpannelTropicalcover").style.display = "block";
        document.getElementById("betpannelTropicalcover").classList.add("bet_pannelcoverOS");
        document.getElementById("betbtnTP").classList.add("addpointerOS")
        document.getElementById("FoldbtnTP").classList.add("addpointerOS")

      }
      else {
        document.getElementById("betpannelTropicalcover").style.display = "none";
        document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelcoverOS");
        // this.setState({ infoText: this.props.language.deal_tostartNB })
        document.getElementById("betbtnTP").classList.remove("drwnodropOS")
        document.getElementById("FoldbtnTP").classList.remove("drwnodropOS")

      }
    } else {
      const inforussianElement = document.getElementById("infoTropicalP");
      const inforussianlandElement = document.getElementById("infoTroppicalland");
      const betbtnElement = document.getElementById("betbtnTP");
      const FoldbtnElement = document.getElementById("FoldbtnTP");
      const mobileAntiMaskCoverElement = document.getElementById("mobileAntiMaskCoverOS")


      if (window.innerHeight > window.innerWidth) {
        // console.log(this.state.totalbet, this.props.balance)
        if (this.state.totalbet > this.props.balance) {
          inforussianElement.className = "";
          betbtnElement.className = "";
          FoldbtnElement.className = "";
          inforussianElement.classList.add('portraitinfoOS');
          mobileAntiMaskCoverElement.style.display = 'block';
          mobileAntiMaskCoverElement.classList.add('mobileAntiMaskCoverOS');
          this.setState({
            infoText: this.props.language.Low_Balance,
            disablemultibutton: false,
            multibuttonsebledsble: false
          });

        }

      } else {
        if (this.state.totalbet > this.props.balance) {
          inforussianlandElement.className = "";
          betbtnElement.className = "";
          FoldbtnElement.className = "";
          inforussianlandElement.classList.add('lndspinfoOS');
          mobileAntiMaskCoverElement.style.display = 'none';
          mobileAntiMaskCoverElement.classList.remove('mobileLndspAntiMaskCoverOS');
          this.setState({ infoText: this.props.language.deal_tostartNB });
          betbtnElement.classList.remove("drwnodropOS");
          FoldbtnElement.classList.remove("drwnodropOS");
        }

      }
    }
  }

  previousantebonousamount(bettextOS) {
    let rebetamount = 0;
    let rebetorrebetX2 = 1;
    if (bettextOS == "REBET") {
      rebetorrebetX2 = 1;
      // console.log(bettextOS)
      rebetamount = this.state.previousAnteBetAmount
      // this.setState({ totalbet: rebetamount }, () => {
      //   this.balnce = this.topLable_rsp(Math.floor(this.props.balance - rebetamount));
      // })

      this.setState({
        totalbet: rebetamount,
        anteBetAmount: this.state.previousAnteBetAmount,
        betdeductions: this.state.previousAnteBetAmount,
        betBtnValue: 0, disBetBtn: 0
      })
      console.log(this.state.previousAnteBetAmount)
      console.log(this.state.betdeductions)
    }
    else if (bettextOS == "REBETX2") {
      rebetorrebetX2 = 2;
      let rebetdouble = (this.state.previousAnteBetAmount) * 2;
      rebetamount = rebetdouble;
      this.setState((prevState) => ({
        totalbet: rebetamount,
        anteBetAmount: prevState.previousAnteBetAmount * 2,
        betdeductions: (this.state.previousAnteBetAmount) * 2,
        betBtnValue: 0, disBetBtn: 0

      }));

    }
  }


  ReturnChipBasedAmount = (amt) => {
    const amount = Number(amt)
    let chipImage = chip_10;
    if (Number(this.chipVal[0].val) <= amount && Number(this.chipVal[1].val) > amount) {
      chipImage = chip_10
    } else if (Number(this.chipVal[1].val) <= amount && Number(this.chipVal[2].val) > amount) {
      chipImage = chip_25
    }
    else if (Number(this.chipVal[2].val) <= amount && Number(this.chipVal[3].val) > amount) {
      chipImage = chip_50
    }
    else if (Number(this.chipVal[3].val) <= amount && Number(this.chipVal[4].val) > amount) {
      chipImage = chip_100

    } else if (Number(this.chipVal[4].val) <= amount && Number(this.chipVal[5].val) > amount) {
      chipImage = chip_500

    } else {
      chipImage = chip_1000
    }
    return chipImage
  }

  // removeChipSound = () => {

  // }

  // playPokerChipSound = (chipSound) => {
  //   const { isPlayingChip, mutesounds } = this.state;
  //   let currentSound = chipSound;
  //   if (!mutesounds) {

  //     if (isPlayingChip) {
  //       chipSound.stop();
  //     }
  //     if (!chipSound) {
  //       currentSound = this.initializeChipSound();
  //     }

  //     currentSound.play();
  //     this.setState({
  //       isPlayingChip: true
  //     })
  //   }

  // };

  // initializeChipSound = () => {
  //   let chipSound = new Howl({
  //     src: [pokerchipsnd],
  //     html5: true, // Enable HTML5 Audio for mobile compatibility
  //   });
  //   this.setState({
  //     chipSound,
  //     isPlayingChip: false
  //   })
  //   return chipSound
  // }

  // playPokerBetSound = (chipSound) => {
  //   const { isPlayingBet, mutesounds } = this.state;
  //   let currentSound = chipSound;

  //   if (!mutesounds) {
  //     if (isPlayingBet && chipSound && typeof chipSound.stop === "function") {
  //       chipSound.stop();
  //     }


  //     if (!chipSound || typeof chipSound.play !== "function") {
  //       currentSound = this.initializeBetSound();
  //     }


  //     if (currentSound && typeof currentSound.play === "function") {

  //       currentSound.play();
  //       this.setState({
  //         isPlayingBet: true,
  //       });
  //     } else {
  //       console.error("Invalid sound object. Unable to play sound.");
  //     }
  //   }
  // };
  // initializeBetSound = () => {
  //   try {
  //     const betSound = new Howl({
  //       src: [betchipsnd],
  //       html5: true, // Enable HTML5 Audio for mobile compatibility
  //     });
  //     this.setState({
  //       betSound,
  //       isPlayingBet: false,
  //     });
  //     return betSound;
  //   } catch (error) {
  //     console.error("Error initializing bet sound:", error);
  //     return null;
  //   }
  // };
  // initializePlayerWinSound = () => {

  //   let winSound = new Howl({
  //     src: [playerWin],
  //     html5: true,
  //   });

  //   return winSound
  // }
  // initializePlayerLoseSound = () => {
  //   let winSound = new Howl({
  //     src: [playerLose],
  //     html5: true,
  //   });

  //   return winSound

  // }
  // playRemainingSounds = (chipSound) => {
  //   const { isPlayingBet, mutesounds } = this.state;
  //   let currentSound = chipSound;
  //   if (!mutesounds) {
  //     // if (currentSound) {
  //     //   chipSound.stop();
  //     // }
  //     // if (!chipSound) {
  //     //   currentSound = this.initializeBetSound();
  //     // }

  //     currentSound.play();
  //     // this.setState({
  //     //   isPlayingBet: true
  //     // })
  //   }
  // }

  anteclick(bettextOS) {
    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }

    // const betbutton = document.getElementById("betbtnTP");  
    // const foldbutton = document.getElementById("FoldbtnTP");
    // this.pokerchipsnd = new Audio(pokerchipsnd);
    // this.pokerchipsnd.currentTime = 0;

    const chipsstoredcontainerElement = document.getElementById('chipsstoredcontainerTP');
    const betchipstoantebet = document.getElementById(`betchipsaddtoanteTP${this.state.idincrement}`);

    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    const betbtntextElement = document.getElementById("betbtntextTP");
    const foldtextElement = document.getElementById("foldtextTP");
    const winpopuprspelement = document.getElementById("winpopup_TP");
    const winamtElement = document.getElementById("winamt_TPS");
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

    } else {

      if (bettextOS == "REBETX2" || bettextOS == "REBET") {
        betbutton.src = "";
        foldbutton.src = "";
        betbutton.style.cssText = "";
        foldbutton.style.cssText = "";
        betbtntextElement.className = "";
        foldtextElement.className = "";
        betbtntextElement.textContent = "";
        foldtextElement.textContent = "";
      }

    }

    document.getElementById("betbtnTP").classList.remove("bnspoinerOS")

    gsap.to(`#betchipsaddtoanteTP${this.state.idincrement}`, {
      autoAlpha: 1
    });

    this.setState((prevState) => ({
      idincrement: prevState.idincrement + 1,
      // betbutton: "DEAL",
      // buttontext: "clear",
      pokerranking: "",
      pokerrankingdeler: "",
      // totalwinRussian: 0,
      disClearBtn: 0,
      betBtnValue: 0,
      disBetBtn: 0,
      keyboardhandle: true
      //  totalbet:prevState.totalbet + 1,
    }));

    // this.cardsRef.current.ReBet();
    // this.dealerCardsContainer.current.ReBet();
    this.randomPlayerCards = [];
    this.shuffledPlayerCards = [];
    this.randomDealerCards = [];
    this.replaceCards = [];
    this.unsequenceDrawCards = [];
    this.sequenceDrawCards = [];
    this.buyCardUnsequenceArray = [];
    this.buyCardsequenceArray = [];
    this.dealerCardsRandom = [];
    this.dealerShuffledCards = [];
    this.dealerUnsequenceDrawCards = [];
    this.dealerSequenceDrawFinalCards = [];
    this.drawReplaceCards = false;

    document.getElementById('rankinginfodelerOS').className = "";
    document.getElementById('rankinginfoOS').className = "";
    let rebetamount = 0;
    let rebetorrebetX2 = 1;
    // this.setState({ infoText: this.props.language.deal_tostartNB, betchipincrementbtn: false, betdecreamentbtn: false })
    if (this.state.previousAnteBetAmount * rebetorrebetX2 <= this.props.maxBetAmt) {


      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        if (this.state.previousAnteBetAmount > 0) {
          if (bettextOS == "REBET") {
            rebetorrebetX2 = 1;
            rebetamount = this.state.previousAnteBetAmount
            this.setState({
              totalbet: rebetamount,
              anteBetAmount: this.state.previousAnteBetAmount,
              betBtnValue: 0, disBetBtn: 0
            })

          }
          else if (bettextOS == "REBETX2") {
            rebetorrebetX2 = 2;
            let rebetdouble = (this.state.previousAnteBetAmount) * 2;

            rebetamount = rebetdouble;
            this.setState((prevState) => ({
              totalbet: rebetamount,
              anteBetAmount: prevState.previousAnteBetAmount * 2,
              betBtnValue: 0, disBetBtn: 0
            }));
          }
        }
        // }
        else {

        }

        this.setState({ betchipincrementbtn: false, betdecreamentbtn: false })


        this.setState({ betbutton: "DEAL", buttontext: "clear", })
        const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_greaterthanbalnceTP");
        const textbetsHighElement = document.getElementById("textbets_highTP");
        const attentionElement = document.getElementById("attentionTP");
        const betbtnElement = document.getElementById("betbtnTP");

        let rebetstatus = 1;
        if (bettextOS == "REBETX2" || bettextOS == "REBET") {

          // if (this.state.anteBetAmount >= this.props.maxBetAmt) {
          //   this.setState({
          //     betdeductions: (this.state.previousAnteBetAmount) * 2,
          //     betdeductions: this.state.previousAnteBetAmount,
          //   })
          // }
          // else {
          //   this.setState({
          //     betdeductions: 0,
          //     betdeductions: 0
          //   })
          // }

          console.log(this.state.betdeductions)


          // document.getElementById("crdscoverOS").classList.add("crdscoverOS")
          document.getElementById("playerDealerCardContainerTP").classList.add("addpointerOS")

          let totalBetAmountForLimitsCheck;
          let totalAnteBetAmount;

          for (let k = 1; k <= this.chipVal.length; k++) {
            if (this.state.count === k) {
              totalBetAmountForLimitsCheck = this.state.totalbet + Number(this.chipVal[k - 1].val);

              if (bettextOS == "REBETX2") {
                let doubleante = (this.state.previousAnteBetAmount) * 2

                totalAnteBetAmount = this.topLable_rsp(doubleante);
                rebetstatus = 2;
                // document.querySelector('antebetChipPortrait10').innerHTML = totalAnteBetAmount
              } else {
                totalAnteBetAmount = this.topLable_rsp(this.state.previousAnteBetAmount);

                rebetstatus = 1;

                // totalAnteBetAmount = this.state.anteBetAmount + Number(this.chipVal[k - 1].val);
              }
            }
          }

          if (Number(this.state.previousAnteBetAmount * rebetstatus) > Number(this.props.balance) ||
            Number(this.state.previousAnteBetAmount * 3 * rebetstatus) > this.props.balance) {

            this.setState({
              anteBetAmount: 0,
              totalbet: 0,
            })
            // this.setState({ betshigh_balnce: true, multibuttonsebledsble: true });
            const betbutton = document.getElementById("betbtnTP");
            const foldbutton = document.getElementById("FoldbtnTP");
            const betbtntextElement = document.getElementById("betbtntextTP");
            const foldtextElement = document.getElementById("foldtextTP");

            betbutton.src = "";
            foldbutton.src = "";
            betbtntextElement.className = "";
            foldtextElement.className = "";
            //  if(this.props.balance!=0){
            if (this.state.isplayerinfoupdate) {
              if (Number(this.state.previousAnteBetAmount * rebetstatus) > Number(this.props.balance)) {

                this.setState({
                  betshigh_balnce: true,
                  lowBalaceErrorInfo: `Insufficient Funds to place the ANTE of ${(this.state.previousAnteBetAmount * rebetstatus).toFixed(2)},Please DEPOSIT to continue playing.`
                })

                // this.setState({ betshigh_balnce: true, multibuttonsebledsble: true, disablemultibutton: true })
              } else if (Number(this.state.previousAnteBetAmount * 3 * rebetstatus) > this.props.balance) {

                this.setState({
                  betshigh_balnce: false,
                  lowBalaceErrorInfo: `Insufficient Funds to follow up your ANTE of ${(this.state.previousAnteBetAmount * rebetstatus).toFixed(2)},with bet ${(this.state.previousAnteBetAmount * rebetstatus * 2).toFixed(2)} Please DEPOSIT to continue playing.`
                })
                // this.setState({ betshigh_balnce: false, multibuttonsebledsble: true, disablemultibutton: true })
              }

            }
            document.getElementById("betbtnTP").classList.remove("addpointerOS")
            document.getElementById("betbtnTP").classList.add("drwnodropOS")
            popupbetGreaterthanBalnceElement.className = "";
            gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, autoAlpha: 0 },
              { scale: 1, duration: 1, rotate: 720, autoAlpha: 1, ease: "power2.out" });

            if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

              popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsOS");
              textbetsHighElement.classList.add("poptext_betshighOS");
              attentionElement.classList.add("attention_textOS");
            }
          }
          else if (this.state.previousAnteBetAmount * rebetstatus > this.props.maxBetAmt) {
            document.getElementById("betbtntextTP").textContent = this.props.language.Deal;
            document.getElementById("betbtntextTP").classList.add("betwindowsOS");
            document.getElementById("foldtextTP").classList.remove("rebettextwindowsOS");
            document.getElementById("foldtextTP").textContent = this.props.language.RP_Clear;
            document.getElementById("foldtextTP").classList.add("foldtextwindowsOS");
            this.setState({ betbutton: "DEAL", buttontext: "clear", })

            this.setState({
              infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl,
              multibuttonsebledsble: true,
              anteBetAmount: 0,
              totalbet: 0,
            })
          } else {
            this.previousantebonousamount(bettextOS)
            this.setState({ multibuttonsebledsble: false, });
            this.setState({ infoText: this.props.language.deal_tostartNB, betchipincrementbtn: false, betdecreamentbtn: false })
            gsap.to("#chipcenterpositionTP", { autoAlpha: 0 });
            const betbutton = document.getElementById("betbtnTP");
            const foldbutton = document.getElementById("FoldbtnTP");

            document.getElementById("betbtntextTP").textContent = "";
            document.getElementById("foldtextTP").textContent = "";

            betbutton.src = "";
            betbutton.style.position = "";
            betbutton.style.width = "";
            betbutton.style.transform = "";

            foldbutton.src = "";
            foldbutton.style.position = "";
            foldbutton.style.width = "";
            foldbutton.style.transform = "";

            betbutton.src = Betbtn;
            Object.assign(betbutton.style, porttraitejson.Betbtnwindows)
            document.getElementById("betbtntextTP").textContent = this.props.language.Deal;

            document.getElementById("betbtntextTP").classList.add("betwindowsOS");

            foldbutton.src = Foldbnwindows;
            Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)
            document.getElementById("foldtextTP").classList.remove("rebettextwindowsOS");
            document.getElementById("foldtextTP").textContent = this.props.language.RP_Clear;
            document.getElementById("foldtextTP").classList.add("foldtextwindowsOS");

            // Object.assign(betchipstoantebet.style,porttraitejson.Betchiptoantewindows)
            this.clertime25 = setTimeout(() => {

              Object.assign(betchipstoantebet.style, porttraitejson.Betchiptoantewindows)
            }, 1500)

            // var tl = gsap.timeline();
            // tl.to(this.chipref.current, {
            //   x: -1051,
            //   y: -251,
            //   duration: 0.2,
            //   ease: "power2.inOut",
            //   zIndex: 12,
            // });
            // tl.to(this.chipref.current, {
            //   autoAlpha: 0,
            //   x: -54,
            //   y: -17,
            //   duration: 0.00001,
            //   zIndex: -2,
            // });
            // tl.to(this.chipref.current, { autoAlpha: 1, zIndex: -2 });
            // tl.play();
            // const betchipstoantebet = document.getElementById("betchipsaddtoantecclickTP");

            const betchipstoantebet = document.getElementById(`betchipsaddtoanteTP${this.state.idincrement}`);

            // let totalBetAmountForLimitsCheck = 0;
            // for (let k = 1; k <= this.chipVal.length; k++) {
            //   if (this.state.count === k) {
            //     totalBetAmountForLimitsCheck = this.state.anteBetAmount + Number(this.chipVal[k - 1].val);
            //   }
            // }

            Object.assign(betchipstoantebet.style, porttraitejson.Betchiptoantewindows)
            console.log(this.state.previousAnteBetAmount)

            switch (this.state.count) {
              case 1:
                betchipstoantebet.src = chip_10;
                this.clertime13 = setTimeout(() => {
                  this.setState((prevState) => ({
                    storebetchips: [
                      ...prevState.storebetchips,
                      <div id="chipcenterpositionTP">
                        <img id="centerchipsTP" className="chip10centerpositionGO"
                          src={this.ReturnChipBasedAmount(Number(this.state.previousAnteBetAmount) * rebetorrebetX2)}
                          alt="Chip 10"
                        />
                        <span id="antebet_windowsTP" className="antebet_textval10OS">{totalAnteBetAmount}</span>
                      </div>

                    ],
                  }));
                }, 150);

                break;
              case 2:
                betchipstoantebet.src = chip_25;
                //  document.getElementById("antebetval_10TP").textContent = "";

                this.clertime14 = setTimeout(() => {
                  this.setState((prevState) => ({
                    storebetchips: [
                      ...prevState.storebetchips,
                      <div id="chipcenterpositionTP">

                        <img
                          id="centerchipsTP"
                          className="chip20centerpositionOS"
                          src={this.ReturnChipBasedAmount(Number(this.state.previousAnteBetAmount) * rebetorrebetX2)}
                          alt="Chip 10"
                        />
                        <span id="antebet_windowsTP" className="antebet_text20OS">{totalAnteBetAmount}</span>
                      </div>
                    ],
                  }));
                }, 150);

                break;
              case 3:

                betchipstoantebet.src = chip_50;

                // document.getElementById("antebetval_20").textContent = "";
                this.clertime15 = setTimeout(() => {
                  this.setState((prevState) => ({
                    storebetchips: [
                      ...prevState.storebetchips,
                      <div id="chipcenterpositionTP">

                        <img
                          id="centerchipsTP"
                          className="chip50centerpositionOS"
                          src={this.ReturnChipBasedAmount(Number(this.state.previousAnteBetAmount) * rebetorrebetX2)}
                          alt="Chip 10"
                        />
                        <span id="antebet_windowsTP" className="antebet_text50OS">{totalAnteBetAmount}</span>
                      </div>
                    ],
                  }));
                }, 150);

                break;
              case 4:

                betchipstoantebet.src = chip_100;

                // document.getElementById("antebetval_20").textContent = "";
                this.clertime15 = setTimeout(() => {
                  this.setState((prevState) => ({
                    storebetchips: [
                      ...prevState.storebetchips,
                      <div id="chipcenterpositionTP">

                        <img
                          id="centerchipsTP"
                          className="chip100centerpositionOS"
                          src={this.ReturnChipBasedAmount(Number(this.state.previousAnteBetAmount) * rebetorrebetX2)}
                          alt="Chip 10"
                        />
                        <span id="antebet_windowsTP" className="antebet_text100OS">{totalAnteBetAmount}</span>
                      </div>
                    ],
                  }));
                }, 150);


                break;
              case 5:
                betchipstoantebet.src = chip_500;

                this.clertime17 = setTimeout(() => {

                  this.setState((prevState) => ({
                    storebetchips: [
                      ...prevState.storebetchips,
                      <div id="chipcenterpositionTP">

                        <img
                          id="centerchipsTP"
                          className="chip500centerpositionOS"

                          src={this.ReturnChipBasedAmount(Number(this.state.previousAnteBetAmount) * rebetorrebetX2)}
                          alt="Chip 10"
                        />
                        <span id="antebet_windowsTP" className="antebet_text50OS">{totalAnteBetAmount}</span>
                      </div>
                    ],
                  }));
                }, 150);
                break;
              case 6:
                betchipstoantebet.src = chip_1000;

                this.clertime17 = setTimeout(() => {


                  this.setState((prevState) => ({
                    storebetchips: [
                      ...prevState.storebetchips,
                      <div id="chipcenterpositionTP">

                        <img
                          id="centerchipsTP"
                          className="chip500centerpositionOS"

                          src={this.ReturnChipBasedAmount(Number(this.state.previousAnteBetAmount) * rebetorrebetX2)}
                          alt="Chip 10"
                        />
                        <span id="antebet_windowsTP" className="antebet_text50OS">{totalAnteBetAmount}</span>
                      </div>
                    ],
                  }));
                }, 150);
                break;

              default:
                break;
            }
          }

          document.getElementById("rankinginfodelerOS").classList.remove("windowspokerrankingdelerOS");
          document.getElementById("rankinginfoOS").classList.remove("windowspokerrankingOS");
          this.cardsRef.current.ReBet();
          this.dealerCardsContainer.current.ReBet();
          this.randomPlayerCards = [];
          this.shuffledPlayerCards = [];
          // document.getElementById("betpannelTropicalcover").style.display = "none";
          // document.getElementById("betpannelTropicalcover").classList.add("bet_pannelcoverOS");
          this.setState({ betchipincrementbtn: false, betdecreamentbtn: false })
          document.getElementById("betincrenetTP").classList.remove("drwnodropOS")
          document.getElementById("betdecrementTP").classList.remove("drwnodropOS")

          this.Howlersounds.current?.playSound("pokerchipsnd");

          // this.setState({infoText:"Press Deal to start the Game!"})
          // const betbutton = document.getElementById("betbtnTP");
          // const foldbutton = document.getElementById("FoldbtnTP");
          const betbutton = document.getElementById("betbtnTP");
          const foldbutton = document.getElementById("FoldbtnTP");

          this.setState((prevState) => ({
            idincrement: prevState.idincrement + 1,
            //  totalbet:prevState.totalbet + 1,
          }));
          this.clertime18 = setTimeout(() => {
            gsap.to(`#chipcenterpositionTP`, { zIndex: -15 })
          }, 550);
          // const betchipstoantebet = document.getElementById(
          //   `betchipsaddtoanteTP${this.state.idincrement}`
          // );
          // console.log(document.getElementById('chipcenterpositionTP'))
          const betchipstoantebet = document.getElementById("betchipsaddtoantecclickTP");

          var tl = gsap.timeline();
          tl.to(this.chipref.current, {
            x: -1016,
            y: -251,
            duration: 0.2,
            ease: "power2.inOut",
            zIndex: 12,
          });
          tl.to(this.chipref.current, {
            autoAlpha: 0,
            x: -54,
            y: -17,
            duration: 0.00001,
            zIndex: -2,
          });
          tl.reverse();
          tl.to(this.chipref.current, { autoAlpha: 1, zIndex: -2 });
          tl.play();

        }
        else {
          let totalBetAmountForLimitsCheck = 0;
          let totalAnteBetAmount = 0;
          for (let k = 1; k <= this.chipVal.length; k++) {
            if (this.state.count === k) {
              // console.log(this.state.anteBetAmount)
              // console.log(Number(this.chipVal[k - 1].val))
              totalBetAmountForLimitsCheck = this.state.anteBetAmount + Number(this.chipVal[k - 1].val);
              totalAnteBetAmount = this.state.anteBetAmount + Number(this.chipVal[k - 1].val);
            }
          }

          if (totalAnteBetAmount > Number(this.props.maxBetAmt)) {
            //  document.getElementById("TPbetcircle").classList.add("nonpointerOS")

            this.Howlersounds.current?.playSound("pokerchipsnd");

            this.setState({
              infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl
            }, () => {
              // console.log(this.state.infoText)
            })
            //  },100)
            document.getElementById("TPbetcircle").classList.remove("addpointerOS")
            document.getElementById("TPbetcircle").classList.add("insurencenodropOS")

          } else {

            // document.getElementById("TPbetcircle").classList.remove("nonpointerOS")
            console.log(totalAnteBetAmount)

            if (Number(totalAnteBetAmount) > this.props.balance ||
              Number(totalAnteBetAmount * 3) > this.props.balance) {
              // if (totalBetAmountForLimitsCheck > 50) {
              // this.setState({ betshigh_balnce: true, multibuttonsebledsble: true,disBetBtn:1 })


              let amount = 0
              for (let k = 1; k <= this.chipVal.length; k++) {
                if (this.state.count === k) {
                  amount = Number(this.chipVal[k - 1].val);
                }
              }
              if (totalAnteBetAmount > this.props.balance) {
                console.log(this.state.anteBetAmount)
                this.setState({
                  betshigh_balnce: true,
                  multibuttonsebledsble: false,
                  lowBalaceErrorInfo: `Insufficient Funds to place the ANTE of ${(this.state.anteBetAmount + amount).toFixed(2)},Please DEPOSIT to continue playing.`
                })

                betbutton.src = Betbtn;
                Object.assign(betbutton.style, porttraitejson.Betbtnwindows)
                document.getElementById("betbtntextTP").classList.remove("betwindowsmlylmTP");
                document.getElementById("betbtntextTP").textContent = this.props.language.Deal;
                document.getElementById("betbtntextTP").classList.add("betwindowsOS");

                foldbutton.src = Foldbnwindows;
                Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)
                document.getElementById("foldtextTP").classList.remove("rebettextwindowsOS");
                document.getElementById("foldtextTP").textContent = this.props.language.RP_Clear;
                document.getElementById("foldtextTP").classList.add("foldtextwindowsOS");

                if (this.state.totalbet == 0) {
                  betbutton.src = "";
                  foldbutton.src = "";
                  betbtntextElement.className = "";
                  foldtextElement.className = "";
                }
                // betbutton.src = "";
                // foldbutton.src = "";
                // betbtntextElement.className = "";
                // foldtextElement.className = "";
              } else if (totalAnteBetAmount * 3 > this.props.balance) {
                document.getElementById("betbtntextTP").textContent = this.props.language.Deal;
                document.getElementById("foldtextTP").textContent = this.props.language.RP_Clear;
                betbutton.src = Betbtn;
                Object.assign(betbutton.style, porttraitejson.Betbtnwindows)
                document.getElementById("betbtntextTP").classList.remove("betwindowsmlylmTP");
                document.getElementById("betbtntextTP").textContent = this.props.language.Deal;
                document.getElementById("betbtntextTP").classList.add("betwindowsOS");

                foldbutton.src = Foldbnwindows;
                Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)
                document.getElementById("foldtextTP").classList.remove("rebettextwindowsOS");
                document.getElementById("foldtextTP").textContent = this.props.language.RP_Clear;
                document.getElementById("foldtextTP").classList.add("foldtextwindowsOS");
                this.setState({
                  betshigh_balnce: true,
                  betbutton: "DEAL", buttontext: "clear",
                  // betshigh_balnce: false,
                  lowBalaceErrorInfo: `Insufficient Funds to follow up your ANTE of ${(this.state.anteBetAmount + amount).toFixed(2)},with bet ${((this.state.anteBetAmount + amount) * 2).toFixed(2)} Please DEPOSIT to continue playing.`
                }) // multibuttonsebledsble: true
                console.log(this.state.anteBetAmount)
                console.log(amount)
                if (this.state.totalbet == 0) {
                  betbutton.src = "";
                  foldbutton.src = "";
                  betbtntextElement.className = "";
                  foldtextElement.className = "";
                }

              }
              betbtnElement.classList.remove("addpointerOS")
              betbtnElement.classList.add("drwnodropOS");
              popupbetGreaterthanBalnceElement.className = "";

              gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, autoAlpha: 0, duration: 0.5 },
                { scale: 1, duration: 0.5, rotate: 720, autoAlpha: 1, ease: "power2.out" });

              if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
                popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsOS");
                textbetsHighElement.classList.add("poptextBetshighwindowsOS");
                attentionElement.classList.add("attentionTextwindowsTP");

              }
            }
            //  else if(this.state.anteBetAmount < this.props.minBetAmt || 
            //           this.state.anteBetAmount > this.props.maxBetAmt) {


            else {
              this.Howlersounds.current?.playSound("pokerchipsnd");
              for (let k = 1; k <= this.chipVal.length; k++) {
                if (this.state.count === k) {

                  if (this.state.anteBetAmount + Number(this.chipVal[k - 1].val) < Number(this.props.balance)) {

                    this.setState({ multibuttonsebledsble: false, });
                    this.setState({ infoText: this.props.language.deal_tostartNB, betchipincrementbtn: false, betdecreamentbtn: false })
                    this.setState({ betbutton: "DEAL", buttontext: "clear", });


                    if (this.chipref) {
                      var tl = gsap.timeline();
                      tl.to(this.chipref.current, {
                        x: -1016,
                        y: -250,
                        duration: 0.2,
                        ease: "power2.inOut",
                        zIndex: 12,
                      });
                      tl.to(this.chipref.current, {
                        autoAlpha: 0,
                        x: 0,
                        y: 0,
                        zIndex: -2,
                        duration: 0.00001,
                      });
                      // tl.reverse();
                      tl.to(this.chipref.current, { autoAlpha: 1, zIndex: -2 });
                      tl.play();
                    }
                    console.log(this.state.count)
                    switch (this.state.count) {
                      case 1:
                        this.setState((prevState) => ({
                          totalbet: prevState.totalbet + Number(this.chipVal[0].val),
                          betdeductions: prevState.totalbet + Number(this.chipVal[0].val),
                          anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[0].val),
                        }));
                        betchipstoantebet.src = chip_10;
                        this.clertime19 = setTimeout(() => {
                          this.setState((prevState) => ({
                            storebetchips: [
                              ...prevState.storebetchips,
                              <div id="chipcenterpositionTP">
                                <img id="centerchipsTP" className="chip10centerpositionGO"
                                  src={this.ReturnChipBasedAmount(totalAnteBetAmount)}
                                  alt="Chip 10"
                                />
                                <span id="antebet_windowsTP" className="antebet_textval10OS">{totalAnteBetAmount}</span>
                              </div>

                            ],
                          }));
                        }, 150);

                        break;
                      case 2:
                        betchipstoantebet.src = chip_25;
                        //  document.getElementById("antebetval_10TP").textContent = "";
                        this.setState((prevState) => ({
                          totalbet: prevState.totalbet + Number(this.chipVal[1].val),
                          betdeductions: prevState.totalbet + Number(this.chipVal[1].val),
                          anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[1].val),
                        }));
                        this.clertime20 = setTimeout(() => {
                          this.setState((prevState) => ({
                            storebetchips: [
                              ...prevState.storebetchips,
                              <div id="chipcenterpositionTP">

                                <img
                                  id="centerchipsTP"
                                  className="chip20centerpositionOS"
                                  src={this.ReturnChipBasedAmount(totalAnteBetAmount)}
                                  alt="Chip 10"
                                />
                                <span id="antebet_windowsTP" className="antebet_text20OS">{totalAnteBetAmount}</span>
                              </div>
                            ],
                          }));
                        }, 150);

                        break;
                      case 3:

                        betchipstoantebet.src = chip_50;
                        // document.getElementById("antebetval_20").textContent = "";
                        this.clertime21 = setTimeout(() => {
                          this.setState((prevState) => ({
                            storebetchips: [
                              ...prevState.storebetchips,
                              <div id="chipcenterpositionTP">

                                <img
                                  id="centerchipsTP"
                                  className="chip50centerpositionOS"

                                  src={this.ReturnChipBasedAmount(totalAnteBetAmount)}
                                  alt="Chip 10"
                                />

                                <span id="antebet_windowsTP" className="antebet_text50OS">{totalAnteBetAmount}</span>
                              </div>
                            ],
                          }));
                        }, 150);
                        this.setState((prevState) => ({
                          totalbet: prevState.totalbet + Number(this.chipVal[2].val),
                          betdeductions: prevState.totalbet + Number(this.chipVal[2].val),
                          anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[2].val),
                        }));
                        break;
                      case 4:
                        betchipstoantebet.src = chip_100;

                        // document.getElementById("antebetval_50").textContent = "";
                        this.setState((prevState) => ({
                          totalbet: prevState.totalbet + Number(this.chipVal[3].val),
                          anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[3].val),
                          betdeductions: prevState.totalbet + Number(this.chipVal[3].val),
                        }));
                        this.clertime22 = setTimeout(() => {
                          this.setState((prevState) => ({
                            storebetchips: [
                              ...prevState.storebetchips,
                              <div id="chipcenterpositionTP">

                                <img
                                  id="centerchipsTP"
                                  className="chip100centerpositionOS"

                                  src={this.ReturnChipBasedAmount(totalAnteBetAmount)}
                                  alt="Chip 10"
                                />
                                <span id="antebet_windowsTP" className="antebet_text100OS">{totalAnteBetAmount}</span>
                              </div>
                            ],

                          }));
                        }, 150);
                        break;
                      case 5:
                        betchipstoantebet.src = chip_500;
                        this.setState((prevState) => ({
                          totalbet: prevState.totalbet + Number(this.chipVal[4].val),
                          betdeductions: prevState.totalbet + Number(this.chipVal[4].val),
                          anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[4].val),
                        }));
                        this.clertime23 = setTimeout(() => {

                          this.setState((prevState) => ({
                            storebetchips: [
                              ...prevState.storebetchips,
                              <div id="chipcenterpositionTP">

                                <img
                                  id="centerchipsTP"
                                  className="chip500centerpositionOS"

                                  src={this.ReturnChipBasedAmount(totalAnteBetAmount)}
                                  alt="Chip 10"
                                />
                                <span id="antebet_windowsTP" className="antebet_text50OS">{totalAnteBetAmount}</span>
                              </div>
                            ],
                          }));
                        }, 150);
                        break;
                      case 6:
                        betchipstoantebet.src = chip_1000;
                        this.setState((prevState) => ({
                          totalbet: prevState.totalbet + Number(this.chipVal[5].val),
                          betdeductions: prevState.totalbet + Number(this.chipVal[5].val),
                          anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[5].val),
                        }));
                        this.clertime23 = setTimeout(() => {

                          this.setState((prevState) => ({
                            storebetchips: [
                              ...prevState.storebetchips,
                              <div id="chipcenterpositionTP">

                                <img
                                  id="centerchipsTP"
                                  className="chip500centerpositionOS"

                                  src={this.ReturnChipBasedAmount(totalAnteBetAmount)}
                                  alt="Chip 10"
                                />
                                <span id="antebet_windowsTP" className="antebet_text50OS">{totalAnteBetAmount}</span>
                              </div>
                            ],
                          }));
                        }, 150);
                        break;

                      default:
                        break;

                    }
                    betbutton.src = Betbtn;
                    Object.assign(betbutton.style, porttraitejson.Betbtnwindows)
                    document.getElementById("betbtntextTP").classList.remove("betwindowsmlylmTP");
                    document.getElementById("betbtntextTP").textContent = this.props.language.Deal;
                    document.getElementById("betbtntextTP").classList.add("betwindowsOS");

                    foldbutton.src = Foldbnwindows;
                    Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)
                    document.getElementById("foldtextTP").classList.remove("rebettextwindowsOS");
                    document.getElementById("foldtextTP").textContent = this.props.language.RP_Clear;
                    document.getElementById("foldtextTP").classList.add("foldtextwindowsOS");

                    Object.assign(betchipstoantebet.style, porttraitejson.Betchiptoantewindows)

                  }
                  else {

                    let doubleantebetamount = this.state.anteBetAmount * 2;
                    let amount = 0
                    for (let k = 1; k <= this.chipVal.length; k++) {
                      if (this.state.count === k) {
                        amount = Number(this.chipVal[k - 1].val);

                      }
                    }
                    this.setState({
                      betshigh_balnce: true,
                      // betshigh_balnce: false,
                      lowBalaceErrorInfo: `Insufficient Funds to follow up your ANTE of ${(this.state.anteBetAmount + amount).toFixed(2)},with bet ${(doubleantebetamount + amount).toFixed(2)} Please DEPOSIT to continue playing.`
                    }) // multibuttonsebledsble: true

                    betbtnElement.classList.remove("addpointerOS")
                    betbtnElement.classList.add("drwnodropOS");
                    popupbetGreaterthanBalnceElement.className = "";

                    gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, autoAlpha: 0, duration: 0.5 },
                      { scale: 1, duration: 0.5, rotate: 720, autoAlpha: 1, ease: "power2.out" });

                    if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
                      popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsOS");
                      textbetsHighElement.classList.add("poptextBetshighwindowsOS");
                      attentionElement.classList.add("attentionTextwindowsTP");

                    }

                  }

                }
              }
            }
            totalAnteBetAmount = this.topLable_rsp(totalBetAmountForLimitsCheck)
          }

        }

        if (this.state.count > 0) {
          this.TotalbetamountGreaterthanbalance(this.state.totalbet);

        }
      }

      else {
        this.betchipactivated = false;
        this.buydrawchipactivated = false;
        this.ConfirmbuydealercardactivePopup = false;
        this.resetPyrWnCpsAmn = false;


        document.getElementById("betpannelTropicalcover").style.display = "block";
        if (document.getElementById("rankinginfodelerOS")) {
          document.getElementById("rankinginfodelerOS").style.cssText = "";
          document.getElementById("rankinginfoOS").style.cssText = "";
        };
        const betbtnElement = document.getElementById("betbtnTP");
        const betbtntextElement = document.getElementById("betbtntextTP");
        const foldtextElement = document.getElementById("foldtextTP");
        const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_greaterthanbalnceTP");
        const textbetsHighElement = document.getElementById("textbets_highTP");
        const attentionElement = document.getElementById("attentionTP");

        betbtntextElement.className = "";
        foldtextElement.className = "";
        betbtntextElement.textContent = this.props.language.Deal;
        foldtextElement.textContent = this.props.language.RP_Clear;
        betbutton.src = Betbtn;
        foldbutton.src = Foldbn;


        this.setState({
          multibuttonsebledsble: false,
          betbutton: "DEAL",
          buttontext: "clear",
        })

        const isPortrait = window.innerHeight > window.innerWidth;

        const rankinginfoElement = document.getElementById("rankinginfoOS");
        if (isPortrait) {
          document.getElementById("betpannelTropicalcover").classList.add("PlayerCardpannelcoverPortraitOS");
          if (rankinginfoElement) {
            if (this.state.isMobilePortraitLndsp) {
              rankinginfoElement.style.left = "35%";
            }
          }

          if (this.resetAnimationChips) {
            if (document.getElementById("chipcenterpositionTP")) {
              gsap.to("#chipcenterpositionTP", { x: 107, y: 1086, duration: 0.00001, zIndex: -2, autoAlpha: 0 });
            }

            if (document.getElementById("betchipsaddtobetTP")) {
              gsap.to("#betchipsaddtobetTP", { x: 1, y: 76, duration: 0.00001, zIndex: -2, autoAlpha: 0 });
              gsap.to("#betTextaddtoBetTP", { x: 153, y: 185, duration: 0.5, zIndex: -2, autoAlpha: 0 });
            }

            // gsap.to(this.chipdrawref.current, { x: 548, y: 140, duration: 0.5, delay: 1, zIndex: -5, autoAlpha: 1 });
            gsap.to(this.chipdrawref.current, { x: 608, y: -116, duration: 0.00001, zIndex: -5, autoAlpha: 0 });

            if (this.wanttobuydelercrd === true) {
              gsap.to(this.buyDealerCardDrawn.current, { x: 0, y: 0, duration: 0.00001, zIndex: -2, autoAlpha: 0 });
            }
          }

          this.resetAnimationChips = false;

          Object.assign(betbutton.style, this.state.betbuttoncss);
          // betbtntextElement.classList.add('betportraitOS');
          betbtntextElement.classList.add(this.state.betbtntextcss);
          Object.assign(foldbutton.style, this.state.foldbuttoncss);
          foldtextElement.classList.add('foldtextportraitOS');

          let rebetstatus = 1;
          if (bettextOS === "REBETX2") {
            rebetstatus = 2;
          }
          let totalBetAmountForLimitsCheck = 0;
          let totalAnteBetAmount = 0;
          if (bettextOS == "REBETX2" || bettextOS == "REBET") {


            if (Number(this.state.previousAnteBetAmount * rebetstatus) > Number(this.props.balance) ||
              Number(this.state.previousAnteBetAmount * 3 * rebetstatus) > this.props.balance) {
              this.setState({
                anteBetAmount: 0,
                totalbet: 0,
              })

              // betbutton.src ="" ;
              // foldbutton.src ="" ;
              // betbtntextElement.className ="";
              // foldtextElement.className ="";
              if (Number(this.state.previousAnteBetAmount * rebetstatus) > Number(this.props.balance)) {


                // betbutton.src = "";
                // foldbutton.src = "";
                // betbutton.style.cssText = "";
                // foldbutton.style.cssText = "";
                // betbtntextElement.className = "";
                // foldtextElement.className = "";
                // betbtntextElement.textContent = "";
                // foldtextElement.textContent = "";


                this.setState({
                  betshigh_balnce: true,
                  lowBalaceErrorInfo: `Insufficient Funds to place the ANTE of ${(this.state.previousAnteBetAmount * rebetstatus).toFixed(2)},Please DEPOSIT to continue playing.`
                })
                // this.setState({ betshigh_balnce: true, multibuttonsebledsble: true, disablemultibutton: true })
                if (this.state.totalbet == 0) {
                  betbutton.src = "";
                  foldbutton.src = "";
                  betbutton.style.cssText = "";
                  foldbutton.style.cssText = "";
                  betbtntextElement.className = "";
                  foldtextElement.className = "";
                  betbtntextElement.textContent = "";
                  foldtextElement.textContent = "";
                }
              } else if (Number(this.state.previousAnteBetAmount * 3 * rebetstatus) > this.props.balance) {
                this.setState({
                  betshigh_balnce: true,
                  // betshigh_balnce: false,
                  lowBalaceErrorInfo: `Insufficient Funds to follow up your ANTE of ${(this.state.previousAnteBetAmount * rebetstatus).toFixed(2)},with bet ${(this.state.previousAnteBetAmount * rebetstatus * 2).toFixed(2)} Please DEPOSIT to continue playing.`
                })
                // this.setState({ betshigh_balnce: false, multibuttonsebledsble: true, disablemultibutton: true })
                if (this.state.totalbet == 0) {
                  betbutton.src = "";
                  foldbutton.src = "";
                  betbutton.style.cssText = "";
                  foldbutton.style.cssText = "";
                  betbtntextElement.className = "";
                  foldtextElement.className = "";
                  betbtntextElement.textContent = "";
                  foldtextElement.textContent = "";
                }
              }


              betbtnElement.classList.remove("addpointerOS")
              betbtnElement.classList.add("drwnodropOS");
              popupbetGreaterthanBalnceElement.className = "";
              gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, autoAlpha: 0 },
                { scale: 1, duration: 1, rotate: 720, autoAlpha: 1, ease: "power2.out" });

              if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

                popupbetGreaterthanBalnceElement.classList.add("popupbetshighPortraitOS");
                textbetsHighElement.classList.add("poptextBetshighPortraitOS");
                attentionElement.classList.add("attentionTextPortraitOS");

              }

            }
            // else if(this.state.anteBetAmount < this.props.minBetAmt || 
            //           this.state.anteBetAmount > this.props.maxBetAmt) {
            else if (this.state.previousAnteBetAmount * rebetstatus > this.props.maxBetAmt) {
              this.setState({
                infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl,
                anteBetAmount: 0,
                totalbet: 0,
                // multibuttonsebledsble: true,
                disablemultibutton: false,
              })

            } else {
              // this.setState({ multibuttonsebledsble: false });
              this.previousantebonousamount(bettextOS);
              console.log(this.state.anteBetAmount)
              betbtntextElement.textContent = this.props.language.Deal;
              foldtextElement.textContent = this.props.language.RP_Clear;

              // console.log(betbtntextElement.textContent, foldtextElement.textContent, this.props.language.Deal, this.props.language.RP_Clear)
              // let convrAntebt = this.topLable_rsp(totalAnteBetAmount);

              this.Howlersounds.current?.playSound("pokerchipsnd");
              this.setState({
                disablemultibutton: false,
                infoText: this.props.language.deal_tostartNB,
                betchipincrementbtn: false,
                betdecreamentbtn: false,
                betbutton: "DEAL",
                buttontext: "clear",
                // storeantebetchips: [...this.state.prevStatestoreantebetchips],
                storeantebetchips: [
                  {
                    chip: this.ReturnChipBasedAmount(Number(this.state.previousAnteBetAmount * rebetstatus)),
                    chipvalue: this.topLable_rsp(Number(this.state.previousAnteBetAmount * rebetstatus)),
                    chipcolor1: "valtextPortrait1OS"
                  },

                ],

              }, () => {

                if (document.getElementById('chipcenterpositionTP')) {
                  gsap.to("#chipcenterpositionTP", {
                    x: 107, y: 1107, duration: 0.0001, zIndex: 0, autoAlpha: 1, onStart: () => {
                      gsap.set("#chipcenterpositionTP", { autoAlpha: 0 });
                    }
                  });
                  gsap.to("#chipcenterpositionTP", { x: 0, y: 0, duration: 0.2, autoAlpha: 1, zIndex: 1, });
                  const chipcenterpositionElement = document.querySelectorAll("#chipcenterpositionTP");
                  for (let q = 0; q < chipcenterpositionElement.length; q++) {

                    chipcenterpositionElement[q].style.position = 'relative';
                  }

                }

              });

            }
          } else {

            let totalBetAmountForLimitsCheck = 0;
            let totalAnteBetAmount = 0;
            // console.log(this.chipVal)

            for (let k = 1; k <= this.chipVal.length; k++) {
              if (this.state.count === k) {
                totalBetAmountForLimitsCheck = this.state.totalbet + Number(this.chipVal[k - 1].val);
                totalAnteBetAmount = this.state.anteBetAmount + Number(this.chipVal[k - 1].val);

              }
            }


            if (Number(totalAnteBetAmount) > Number(this.props.balance) ||
              Number(totalAnteBetAmount * 3) > Number(this.props.balance)) {
              let amount = 0
              for (let k = 1; k <= this.chipVal.length; k++) {
                if (this.state.count === k) {
                  amount = Number(this.chipVal[k - 1].val);

                }
              }

              if (totalAnteBetAmount > this.props.balance) {
                this.setState({
                  betshigh_balnce: true,
                  multibuttonsebledsble: false,
                  // multibuttonsebledsble: true,
                  lowBalaceErrorInfo: `Insufficient Funds to place the ANTE of ${(this.state.anteBetAmount + amount).toFixed(2)},Please DEPOSIT to continue playing.`
                })
                if (this.state.totalbet == 0) {
                  betbutton.src = "";
                  foldbutton.src = "";
                  betbutton.style.cssText = "";
                  foldbutton.style.cssText = "";
                  betbtntextElement.className = "";
                  foldtextElement.className = "";
                  betbtntextElement.textContent = "";
                  foldtextElement.textContent = "";
                }


              } else if (totalAnteBetAmount * 3 > this.props.balance) {
                this.setState({
                  betshigh_balnce: true,
                  // betshigh_balnce: false,
                  lowBalaceErrorInfo: `Insufficient Funds to follow up your ANTE of ${(this.state.anteBetAmount + amount).toFixed(2)},with bet ${((this.state.anteBetAmount + amount) * 2).toFixed(2)} Please DEPOSIT to continue playing.`
                }) // multibuttonsebledsble: true
                if (this.state.totalbet == 0) {
                  betbutton.src = "";
                  foldbutton.src = "";
                  betbutton.style.cssText = "";
                  foldbutton.style.cssText = "";
                  betbtntextElement.className = "";
                  foldtextElement.className = "";
                  betbtntextElement.textContent = "";
                  foldtextElement.textContent = "";
                }
              }

              betbtnElement.classList.remove("addpointerOS")
              betbtnElement.classList.add("drwnodropOS");
              popupbetGreaterthanBalnceElement.className = "";

              gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, autoAlpha: 0, duration: 0.5 },
                { scale: 1, duration: 0.5, rotate: 720, autoAlpha: 1, ease: "power2.out" });

              if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
                popupbetGreaterthanBalnceElement.classList.add("popupbetshighPortraitOS");
                textbetsHighElement.classList.add("poptextBetshighPortraitOS");
                attentionElement.classList.add("attentionTextPortraitOS");

              }

            }
            //  else if(this.state.anteBetAmount < this.props.minBetAmt || 
            //           this.state.anteBetAmount > this.props.maxBetAmt) {
            else if (totalAnteBetAmount > Number(this.props.maxBetAmt)) {
              this.setState({
                infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl,
                // multibuttonsebledsble: true,
              }, () => {
                // console.log(this.state.infoText)
              });

            } else {
              betbtntextElement.textContent = this.props.language.Deal;
              foldtextElement.textContent = this.props.language.RP_Clear;

              // console.log(betbtntextElement.textContent, foldtextElement.textContent, this.props.language.Deal, this.props.language.RP_Clear)
              this.setState({
                multibuttonsebledsble: false,
                betbutton: "DEAL",
                buttontext: "clear",
                infoText: this.props.language.deal_tostartNB,
                betchipincrementbtn: false,
                betdecreamentbtn: false,
                previousAnteBetAmount: 0,
              });
              let convrAntebt = this.topLable_rsp(totalAnteBetAmount);

              // antebetpdvcss:"chip-center-position",
              // antechpimgcss:"chip20centerpositionPortraitOS",
              // antespntxtcss:"antebetChipPortrait20OS",

              this.Howlersounds.current?.playSound("pokerchipsnd");
              switch (this.state.count) {
                case 1:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[0].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[0].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[0].val),
                  }))
                  betchipstoantebet.src = chip_10;
                  this.clertime13 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: "valtextPortrait1OS" },

                      ],
                    }));
                  }, 150);
                  break;
                case 2:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[1].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[1].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[1].val),
                  }))
                  betchipstoantebet.src = chip_25;
                  this.clertime14 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: null },

                      ],
                    }));
                  }, 150);
                  break;
                case 3:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[2].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[2].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[2].val),
                  }))
                  betchipstoantebet.src = chip_50;
                  this.clertime15 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: null },

                      ],
                    }));
                  }, 150);
                  break;
                case 4:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[3].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[3].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[3].val),
                  }))
                  betchipstoantebet.src = chip_100;
                  this.clertime16 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: null },

                      ],
                    }));
                  }, 150);
                  break;
                case 5:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[4].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[4].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[4].val),
                  }))
                  betchipstoantebet.src = chip_500;
                  this.clertime17 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: null },
                      ],
                    }));
                  }, 150);
                  break;
                case 6:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[5].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[5].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[5].val),
                  }))
                  betchipstoantebet.src = chip_1000;
                  this.clertime17 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: null },
                      ],
                    }));
                  }, 150);
                  break;
                default:
                  break;
              }


              Object.assign(betchipstoantebet.style, porttraitejson.Betchiptoanteprotrait);
              var tl = gsap.timeline();
              tl.to(this.chipref.current, {
                x: 0,
                y: -523,
                duration: 0.2,
                // duration: 0.2,
                ease: "power2.inOut",
                zIndex: 12,
                autoAlpha: 1
              });


              tl.to(this.chipref.current, {
                x: 0,
                y: 0,
                duration: 0.0001,
                autoAlpha: 0,
                zIndex: -3,
              });
              tl.play();
            }

          }

        } else {

          if (chipsstoredcontainerElement && chipsstoredcontainerElement !== null) {
            chipsstoredcontainerElement.classList.add("chipsstoredcontainerLndspOS");
          }

          if (rankinginfoElement) {
            if (this.state.isMobilePortraitLndsp) {
              // rankinginfoElement.style.left = "62.5%";
              rankinginfoElement.style.left = "43.5%";
            }
          }


          betbutton.style.cssText = "";
          foldbutton.style.cssText = "";
          betbtntextElement.className = "";
          foldtextElement.className = "";

          betbutton.src = Betbtn;
          Object.assign(betbutton.style, this.state.betbuttoncss);
          // betbtntextElement.classList.add('betLandscapeOS');
          betbtntextElement.classList.add(this.state.betbtntextcss);

          foldbutton.src = Foldbn;
          Object.assign(foldbutton.style, this.state.foldbuttoncss);
          // foldtextElement.classList.add('foldtextLandscapeOS');
          foldtextElement.classList.add(this.state.foldbtntextcss);

          let rebetstatus = 1;
          let totalBetAmountForLimitsCheck;
          let totalAnteBetAmount;
          // console.log(this.state.previousAnteBetAmount)
          if (bettextOS === "REBETX2") {
            rebetstatus = 2;
          }
          if (bettextOS === "REBETX2" || bettextOS === "REBET") {

            if (Number(this.state.previousAnteBetAmount * rebetstatus) > Number(this.props.balance) ||
              Number(this.state.previousAnteBetAmount * 3 * rebetstatus) > this.props.balance) {
              this.setState({
                anteBetAmount: 0,
                totalbet: 0,
              })

              // betbutton.src ="" ;
              // foldbutton.src ="" ;
              // betbtntextElement.className ="";
              // foldtextElement.className ="";
              if (Number(this.state.previousAnteBetAmount * rebetstatus) > Number(this.props.balance)) {

                // betbutton.src = "";
                // foldbutton.src = "";
                // betbutton.style.cssText = "";
                // foldbutton.style.cssText = "";
                // betbtntextElement.className = "";
                // foldtextElement.className = "";
                // betbtntextElement.textContent = "";
                // foldtextElement.textContent = "";

                if (this.state.totalbet == 0) {
                  betbutton.src = "";
                  foldbutton.src = "";
                  betbutton.style.cssText = "";
                  foldbutton.style.cssText = "";
                  betbtntextElement.className = "";
                  foldtextElement.className = "";
                  betbtntextElement.textContent = "";
                  foldtextElement.textContent = "";
                }

                this.setState({
                  betshigh_balnce: true,
                  lowBalaceErrorInfo: `Insufficient Funds to place the ANTE of ${(this.state.previousAnteBetAmount * rebetstatus).toFixed(2)},Please DEPOSIT to continue playing.`
                })
                // this.setState({ betshigh_balnce: true, multibuttonsebledsble: true, disablemultibutton: true })



              } else if (Number(this.state.previousAnteBetAmount * 3 * rebetstatus) > this.props.balance) {
                this.setState({
                  betshigh_balnce: true,
                  lowBalaceErrorInfo: `Insufficient Funds to follow up your ANTE of ${(this.state.previousAnteBetAmount * rebetstatus).toFixed(2)},with bet ${(this.state.previousAnteBetAmount * rebetstatus * 2).toFixed(2)} Please DEPOSIT to continue playing.`
                })
                // this.setState({ betshigh_balnce: false, multibuttonsebledsble: true, disablemultibutton: true })

                if (this.state.totalbet == 0) {
                  betbutton.src = "";
                  foldbutton.src = "";
                  betbutton.style.cssText = "";
                  foldbutton.style.cssText = "";
                  betbtntextElement.className = "";
                  foldtextElement.className = "";
                  betbtntextElement.textContent = "";
                  foldtextElement.textContent = "";
                }
              }

              betbtnElement.classList.remove("addpointerOS")
              betbtnElement.classList.add("drwnodropOS");
              popupbetGreaterthanBalnceElement.className = "";
              gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, autoAlpha: 0 },
                { scale: 1, duration: 1, rotate: 720, autoAlpha: 1, ease: "power2.out" });

              if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

                popupbetGreaterthanBalnceElement.classList.add("popupbetshighLndspOS");
                textbetsHighElement.classList.add("poptextBetshighPortraitOS");
                attentionElement.classList.add("attentionTextPortraitOS");

              }

            }
            // else if(this.state.anteBetAmount < this.props.minBetAmt || 
            //           this.state.anteBetAmount > this.props.maxBetAmt) {
            else if (this.state.previousAnteBetAmount * rebetstatus > this.props.maxBetAmt) {
              this.setState({
                infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl,
                anteBetAmount: 0,
                totalbet: 0,
                // multibuttonsebledsble: true,
                disablemultibutton: false,
              })

            } else {
              this.previousantebonousamount(bettextOS);

              Object.assign(betbutton.style, this.state.betbuttoncss);
              // betbtntextElement.classList.add('betLandscapeOS');
              betbtntextElement.classList.add(this.state.betbtntextcss);
              betbutton.src = Betbtn;

              foldbutton.src = Foldbn;
              Object.assign(foldbutton.style, this.state.foldbuttoncss);
              // foldtextElement.classList.add('foldtextLandscapeOS');
              foldtextElement.classList.add(this.state.foldbtntextcss);

              this.Howlersounds.current?.playSound("pokerchipsnd");
              this.setState({
                disablemultibutton: false,
                betbutton: "DEAL",
                buttontext: "clear",
                infoText: this.props.language.deal_tostartNB,
                betchipincrementbtn: false,
                betdecreamentbtn: false,
                // storeantebetchips: [...this.state.prevStatestoreantebetchips],
                storeantebetchips: [
                  {
                    chip: this.ReturnChipBasedAmount(Number(this.state.previousAnteBetAmount * rebetstatus)),
                    chipvalue: this.topLable_rsp(Number(this.state.previousAnteBetAmount * rebetstatus)),
                    chipcolor1: "valtextPortrait1OS"
                  },

                ],

              }, () => {



                if (document.getElementById('chipcenterpositionTP')) {
                  gsap.fromTo("#chipcenterpositionTP",
                    { x: 1200, y: 0, autoAlpha: 0, duration: 0.00001 },
                    { x: 0, y: 0, autoAlpha: 1, duration: 0.2, zIndex: 1, ease: "power2.out" },
                  )
                  const chipcenterpositionElement = document.querySelectorAll("#chipcenterpositionTP");
                  // console.log(chipcenterpositionElement)
                  for (let q = 0; q < chipcenterpositionElement.length; q++) {

                    chipcenterpositionElement[q].style.position = 'relative';
                  }

                }

              });


            }
          } else {


            let totalBetAmountForLimitsCheck = 0;
            let totalAnteBetAmount = 0;
            // console.log(this.chipVal)

            for (let k = 1; k <= this.chipVal.length; k++) {
              if (this.state.count === k) {
                totalBetAmountForLimitsCheck = this.state.totalbet + Number(this.chipVal[k - 1].val);
                totalAnteBetAmount = this.state.anteBetAmount + Number(this.chipVal[k - 1].val);

              }
            }


            if (Number(totalAnteBetAmount) > Number(this.props.balance) ||
              Number(totalAnteBetAmount * 3) > Number(this.props.balance)) {

              // if (totalAnteBetAmount > 50 || totalAnteBetAmount*3 >50) {
              let amount = 0
              for (let k = 1; k <= this.chipVal.length; k++) {
                if (this.state.count === k) {
                  amount = Number(this.chipVal[k - 1].val);

                }
              }
              if (totalAnteBetAmount > this.props.balance) {
                this.setState({
                  betshigh_balnce: true,
                  multibuttonsebledsble: false,
                  // multibuttonsebledsble: true,
                  lowBalaceErrorInfo: `Insufficient Funds to place the ANTE of ${(this.state.anteBetAmount + amount).toFixed(2)},Please DEPOSIT to continue playing.`
                })

                // betbutton.src = "";
                // foldbutton.src = "";
                // betbutton.style.cssText = "";
                // foldbutton.style.cssText = "";
                // betbtntextElement.className = "";
                // foldtextElement.className = "";
                // betbtntextElement.textContent = "";
                // foldtextElement.textContent = "";
                if (this.state.totalbet == 0) {
                  betbutton.src = "";
                  foldbutton.src = "";
                  betbutton.style.cssText = "";
                  foldbutton.style.cssText = "";
                  betbtntextElement.className = "";
                  foldtextElement.className = "";
                  betbtntextElement.textContent = "";
                  foldtextElement.textContent = "";
                }

              } else if (totalAnteBetAmount * 3 > this.props.balance) {
                this.setState({
                  betshigh_balnce: true,
                  lowBalaceErrorInfo: `Insufficient Funds to follow up your ANTE of ${(this.state.anteBetAmount + amount).toFixed(2)},with bet ${((this.state.anteBetAmount + amount) * 2).toFixed(2)} Please DEPOSIT to continue playing.`
                }) // multibuttonsebledsble: true
                if (this.state.totalbet == 0) {
                  betbutton.src = "";
                  foldbutton.src = "";
                  betbutton.style.cssText = "";
                  foldbutton.style.cssText = "";
                  betbtntextElement.className = "";
                  foldtextElement.className = "";
                  betbtntextElement.textContent = "";
                  foldtextElement.textContent = "";
                }
              }

              betbtnElement.classList.remove("addpointerOS")
              betbtnElement.classList.add("drwnodropOS");
              popupbetGreaterthanBalnceElement.className = "";

              gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, autoAlpha: 0, duration: 0.5 },
                { scale: 1, duration: 0.5, rotate: 720, autoAlpha: 1, ease: "power2.out" });

              if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
                popupbetGreaterthanBalnceElement.classList.add("popupbetshighLndspOS");
                textbetsHighElement.classList.add("poptextBetshighPortraitOS");
                attentionElement.classList.add("attentionTextPortraitOS");

              }

            }
            //  else if(this.state.anteBetAmount < this.props.minBetAmt || 
            //           this.state.anteBetAmount > this.props.maxBetAmt) {
            else if (totalAnteBetAmount > Number(this.props.maxBetAmt)) {
              this.setState({
                infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl,
                // multibuttonsebledsble: true,
              }, () => {
                // console.log(this.state.infoText)
              });

            } else {
              betbutton.src = Betbtn;
              Object.assign(betbutton.style, this.state.betbuttoncss);
              // betbtntextElement.classList.add('betLandscapeOS');
              betbtntextElement.classList.add(this.state.betbtntextcss);

              foldbutton.src = Foldbn;
              Object.assign(foldbutton.style, this.state.foldbuttoncss);
              // foldtextElement.classList.add('foldtextLandscapeOS');
              foldtextElement.classList.add(this.state.foldbtntextcss);

              this.setState({
                multibuttonsebledsble: false,
                betbutton: "DEAL",
                buttontext: "clear",
                infoText: this.props.language.deal_tostartNB,
                betchipincrementbtn: false,
                betdecreamentbtn: false,
                previousAnteBetAmount: 0,
              });
              let convrAntebt = this.topLable_rsp(totalAnteBetAmount);

              Object.assign(betchipstoantebet.style, porttraitejson.betchiplndspe);
              var tl = gsap.timeline();
              tl.to(this.chipref.current, {
                x: -433,
                y: 3,
                duration: 0.2,
                ease: "power2.inOut",
                zIndex: 12,
                autoAlpha: 1,
              });

              tl.to(this.chipref.current, {
                autoAlpha: 0,
                x: 0,
                y: 0,
                duration: 0.00001,
                zIndex: -3,
              });
              tl.play();

              this.Howlersounds.current?.playSound("pokerchipsnd");

              switch (this.state.count) {
                case 1:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[0].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[0].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[0].val),
                  }))
                  betchipstoantebet.src = chip_10;
                  this.clertime13 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: "valtextPortrait1OS" },

                      ],
                    }));
                  }, 150);
                  break;
                case 2:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[1].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[1].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[1].val),
                  }))
                  betchipstoantebet.src = chip_25;
                  this.clertime14 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: null },

                      ],
                    }));
                  }, 150);
                  break;
                case 3:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[2].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[2].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[2].val),
                  }))
                  betchipstoantebet.src = chip_50;
                  this.clertime15 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: null },

                      ],
                    }));
                  }, 150);
                  break;
                case 4:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[3].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[3].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[3].val),
                  }))
                  betchipstoantebet.src = chip_100;
                  this.clertime16 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: null },

                      ],
                    }));
                  }, 150);
                  break;
                case 5:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[4].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[4].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[4].val),
                  }))
                  betchipstoantebet.src = chip_500;
                  this.clertime17 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: null },

                      ],
                    }));
                  }, 150);
                  break;
                case 6:
                  this.setState((prevState) => ({
                    totalbet: prevState.totalbet + Number(this.chipVal[5].val),
                    anteBetAmount: prevState.anteBetAmount + Number(this.chipVal[5].val),
                    betdeductions: prevState.betdeductions + Number(this.chipVal[5].val),
                  }))
                  betchipstoantebet.src = chip_1000;
                  this.clertime17 = setTimeout(() => {
                    this.setState((prevState) => ({
                      storeantebetchips: [
                        ...prevState.storeantebetchips,
                        { chip: this.ReturnChipBasedAmount(Number(prevState.anteBetAmount.toFixed(2))), chipvalue: convrAntebt, chipcolor1: null },

                      ],
                    }));
                  }, 150);
                  break;
                default:
                  break;
              }

            }
          }
        }
      }


    }
    else {
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        this.cardsRef.current.ReBet();
        this.dealerCardsContainer.current.ReBet();
        document.getElementById("betbtntextTP").textContent = "";
        document.getElementById("foldtextTP").textContent = "";
        document.getElementById("betbtnTP").classList.remove("addpointerOS")
        document.getElementById("betbtnTP").classList.add("bnspoinerOS")
        document.getElementById("betbtntextTP").textContent = this.props.language.Deal;
        document.getElementById("foldtextTP").textContent = this.props.language.RP_Clear;
        this.setState({
          muteunmutesounds: true
        })
      } else {
        this.setState({
          // disablemultibutton: true,
        })

      }
      this.setState({
        totalbet: 0,
        infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl
      })

    }
  }

  // getClickSound = () => {

  //   this.selectCard.currentTime = 0;
  //   if (this.state.mutesounds) {
  //     this.selectCard.pause();
  //   } else {
  //     this.selectCard.play();
  //   }
  // }
  Showoptionsmenu() {
    this.hidepopup_betshigh()
    this.Howlersounds.current?.playSound("selectCard");
    this.setState((prevState) => {
      const isMenuOpen = !prevState.isoptionmenu;
      return {
        isoptionmenu: isMenuOpen,
        isactiveoptionsmenu: true,
        ShowLimits: isMenuOpen ? prevState.ShowLimits : false,
        ShowHistory: isMenuOpen ? prevState.ShowHistory : false,
        ShowGamerules: isMenuOpen ? prevState.ShowGamerules : false,
      };
    }, () => {
      var tl = gsap.timeline();
      if (document.getElementById("optionsmenubuttonTP")) {

        tl.to("#optionsmenubuttonTP", {
          x: 513,
          y: 75,
          duration: 0.5,
          ease: "power2.inOut",
          zIndex: 12,
          autoAlpha: 1,
          // autoAlpha: 1,

        });
      }
      if (document.getElementById("optiontopmenuTP")) {

        tl.to("#optiontopmenuTP", {
          x: 316,
          y: 0,
          duration: 0.5,
          ease: "power2.inOut",
          zIndex: 12,
          autoAlpha: 1,
          // autoAlpha: 1,

        });
      }


      if (document.getElementById("limits")) {

        tl.to("#limits", {
          x: 294,
          y: -5,
          duration: 0.2,
          ease: "power2.inOut",
          zIndex: 12,
          autoAlpha: 1,
          // autoAlpha: 1,
          stagger: 2,

        });
      }

      if (document.getElementById("help")) {
        tl.to("#help", {
          x: 294,
          y: -5,
          duration: 0.2,
          ease: "power2.inOut",
          zIndex: 12,
          autoAlpha: 1,
          // autoAlpha: 0.5,
          stagger: 3,

        });
      }
      if (document.getElementById("history")) {
        tl.to("#history", {
          x: 294,
          y: -5,
          duration: 0.2,
          ease: "power2.inOut",
          zIndex: 12,
          autoAlpha: 1,
          // autoAlpha: 1,
          stagger: 4,

        });
      }
      if (document.getElementById("exitmenuTP")) {
        tl.to("#exitmenuTP", {
          x: 313,
          y: -2,
          duration: 0.2,
          ease: "power2.inOut",
          zIndex: 12,
          autoAlpha: 1,
          // autoAlpha: 1,
          stagger: 5,

        });
      }
      tl.play()

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        if (document.getElementById("optionsmenubuttonTP")) {
          document.getElementById("optionsmenubuttonTP").classList.remove("optionsmenu_lndspeOS");
        }

        if (document.getElementById("optionsmenubuttonTP")) {
          document.getElementById("optionsmenubuttonTP").classList.remove("optionsmenu_portraiteOS");
        }



        if (document.getElementById("optionsmenubuttonTP")) {
          document.getElementById("optionsmenubuttonTP").classList.add("optionsmenuOS");
        }
        if (document.getElementById("optiontopmenuTP")) {
          document.getElementById("optiontopmenuTP").classList.add("topmenuOS");
        }
        if (document.getElementById("optiontextTP")) {
          document.getElementById("optiontextTP").classList.add("optionheadingOS");
        }
        if (document.getElementById("limits")) {
          document.getElementById("limits").classList.add("limitstextOS");
        }
        if (document.getElementById("help")) {
          document.getElementById("help").classList.add("helptextOS");
        }
        if (document.getElementById("history")) {
          document.getElementById("history").classList.add("historytextOS");
        }
        if (document.getElementById("arraowTP")) {
          document.getElementById("arraowTP").classList.add("arraowtextOS");
        }
        if (document.getElementById("exitmenuTP")) {
          document.getElementById("exitmenuTP").classList.add("exitoptionmenuOS");
        }


      }
      else {
        if (window.innerHeight > window.innerWidth) {
          if (document.getElementById("optionsmenubuttonTP")) {
            document.getElementById("optionsmenubuttonTP").classList.remove("optionsmenu_lndspeOS");
          }


          if (document.getElementById("optionsmenubuttonTP")) {
            document.getElementById("optionsmenubuttonTP").classList.add("optionsmenu_portraiteOS");
          }
          if (document.getElementById("optiontopmenuTP")) {
            document.getElementById("optiontopmenuTP").classList.add("topmenuOS");
          }
          if (document.getElementById("optiontextTP")) {
            document.getElementById("optiontextTP").classList.add("optionheadingOS");
          }
          if (document.getElementById("limits")) {
            document.getElementById("limits").classList.add("limitstextOS");
          }
          if (document.getElementById("help")) {
            document.getElementById("help").classList.add("helptextOS");
          }
          if (document.getElementById("history")) {
            document.getElementById("history").classList.add("historytextOS");
          }
          if (document.getElementById("arraowTP")) {
            document.getElementById("arraowTP").classList.add("arraowtextOS");
          }
          if (document.getElementById("exitmenuTP")) {
            document.getElementById("exitmenuTP").classList.add("exitoptionmenuOS");
          }


        }
        else {

          if (document.getElementById("optionsmenubuttonTP")) {
            document.getElementById("optionsmenubuttonTP").classList.remove("optionsmenu_portraiteOS");
          }

          if (document.getElementById("optionsmenubuttonTP")) {
            document.getElementById("optionsmenubuttonTP").classList.add("optionsmenu_lndspeOS");
          }
          if (document.getElementById("optiontopmenuTP")) {
            document.getElementById("optiontopmenuTP").classList.add("topmenuOS");
          }
          if (document.getElementById("optiontextTP")) {
            document.getElementById("optiontextTP").classList.add("optionheadingOS");
          }
          if (document.getElementById("limits")) {
            document.getElementById("limits").classList.add("limitstextOS");
          }
          if (document.getElementById("help")) {
            document.getElementById("help").classList.add("helptextOS");
          }
          if (document.getElementById("history")) {
            document.getElementById("history").classList.add("historytextOS");
          }
          if (document.getElementById("arraowTP")) {
            document.getElementById("arraowTP").classList.add("arraowtextOS");
          }
          if (document.getElementById("exitmenuTP")) {
            document.getElementById("exitmenuTP").classList.add("exitoptionmenuOS");
          }


        }

      }
    });

  }

  lowBalanceErrorInformationPopupanimation = () => {
    const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_greaterthanbalnceTP");
    const textbetsHighElement = document.getElementById("textbets_highTP");
    const attentionElement = document.getElementById("attentionTP");


    popupbetGreaterthanBalnceElement.className = "";

    gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, autoAlpha: 0, },
      { scale: 1, duration: 0.5, rotate: 720, autoAlpha: 1, ease: "power2.out" });


    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
        popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsOS");
        textbetsHighElement.classList.add("poptextBetshighwindowsOS");
        attentionElement.classList.add("attentionTextwindowsTP");

      }

    } else {
      if (window.innerHeight > window.innerWidth) {
        // Portrait

        if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
          popupbetGreaterthanBalnceElement.classList.add("popupbetshighPortraitOS");
          textbetsHighElement.classList.add("poptextBetshighPortraitOS");
          attentionElement.classList.add("attentionTextPortraitOS");

        }
      } else {
        // Landscape

        if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

          popupbetGreaterthanBalnceElement.classList.add("popupbetshighLndspOS");
          textbetsHighElement.classList.add("poptextBetshighPortraitOS");
          attentionElement.classList.add("attentionTextPortraitOS");

        }
      }
    }
  }
  TropicalpokerBet() {

    if (this.state.PayoutTableToggle) {
      this.setState({ PayoutTableToggle: false });
    }

    if (this.replaceCards.length > 0) {
      this.cardsRef.current.unselectPokerCards();
    }

    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }

    let doubleamt = this.state.anteBetAmount * 2
    // console.log(this.state.anteBetAmount, this.props.balance)
    console.log(this.state.anteBetAmount)
    console.log(this.props.balance)
    console.log(this.state.betdeductions)
    console.log(doubleamt)

    if (Number((this.state.betdeductions + doubleamt).toFixed(2)) <= this.props.balance) {
      if (this.state.betshigh_balnce === true) {
        this.hidepopup_betshigh();
      }
      this.setState((prevState) => ({
        betdeductions: prevState.betdeductions + doubleamt,
        totalbet: prevState.totalbet + doubleamt,
        disBetBtn: 1,
        keyboardhandle: false,
        infoText: ""
      }));


      this.Howlersounds.current?.playSound("betchipsnd");

      const drawbutton = document.getElementById("drawbtnTP");
      const buybutton = document.getElementById("buybtnTP");
      const betbutton = document.getElementById("betbtnTP");
      const foldbutton = document.getElementById("FoldbtnTP");
      let betTextaddtoBetElement = document.getElementById("betTextaddtoBetTP");
      let betchipsaddtobetwindows = document.getElementById("betchipsaddtobetTP");
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        gsap.set(["#betTextaddtoBetTP"], { clearProps: "all" })
        this.setState({ disBuybtn: 1, disClearBtn: 1, disDrawbtn: 1, FoldbtnTP: 1, disBetBtn: 1 })
        document.getElementById("crdscoverOS").classList.add("crdscoverOS")
        document.getElementById("betpannelTropicalcover").style.display = "block";
        document.getElementById("betpannelTropicalcover").classList.add("bet_pannelcoverOS");
        document.getElementById("betactiveOS").src = ""
        document.getElementById("betactiveOS").classList.remove("betactiveOS");
        document.getElementById("betbtntextTP").innerHTML = "";
        document.getElementById("drawtextTP").textContent = "";
        document.getElementById("foldtextTP").textContent = "";

        document.getElementById("betbtntextTP").classList.remove("betwindowsOS");
        betbutton.src = "";
        betbutton.style.cssText = ""


        foldbutton.src = "";
        foldbutton.style.cssText = ""
        document.getElementById("foldtextTP").classList.remove("foldtextwindowsOS");


        drawbutton.src = "";
        drawbutton.style.cssText = ""


        buybutton.src = "";
        buybutton.style.cssText = ""


        let betTextaddtoBetClass = "";

        if (
          (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
          (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
        ) {
          // gsap.to("#betTextaddtoBetTP", { autoAlpha: 1, duration: 0.1 })
          let russianbet_amount
          console.log(this.state.count)
          switch (this.state.count) {

            case 1:
              betTextaddtoBetClass = "";
              betchipsaddtobetwindows.src = this.ReturnChipBasedAmount(this.state.anteBetAmount * 2);
              russianbet_amount = this.topLable_rsp(this.state.anteBetAmount * 2)
              betTextaddtoBetElement.textContent = russianbet_amount
              betTextaddtoBetClass = "bet-text-addtoBet10OS";

              break;
            case 2:
              betTextaddtoBetClass = "";
              betchipsaddtobetwindows.src = this.ReturnChipBasedAmount(this.state.anteBetAmount * 2);
              russianbet_amount = this.topLable_rsp(this.state.anteBetAmount * 2)
              betTextaddtoBetElement.textContent = russianbet_amount
              betTextaddtoBetClass = "bet-text-addtoBet20OS";

              break;
            case 3:
              betTextaddtoBetClass = "";
              betchipsaddtobetwindows.src = this.ReturnChipBasedAmount(this.state.anteBetAmount * 2);
              russianbet_amount = this.topLable_rsp(this.state.anteBetAmount * 2)
              betTextaddtoBetElement.textContent = russianbet_amount
              betTextaddtoBetClass = "bet-text-addtoBet20OS";

              break;
            case 4:
              betTextaddtoBetClass = "";
              betchipsaddtobetwindows.src = this.ReturnChipBasedAmount(this.state.anteBetAmount * 2);
              russianbet_amount = this.topLable_rsp(this.state.anteBetAmount * 2)
              betTextaddtoBetElement.textContent = russianbet_amount
              betTextaddtoBetClass = "bet-text-addtoBet20OS";

              break;
            case 5:
              betTextaddtoBetClass = "";
              betchipsaddtobetwindows.src = this.ReturnChipBasedAmount(this.state.anteBetAmount * 2);
              russianbet_amount = this.topLable_rsp(this.state.anteBetAmount * 2)
              betTextaddtoBetElement.textContent = russianbet_amount
              betTextaddtoBetClass = "bet-text-addtoBet20OS";
              break;
            case 6:
              betTextaddtoBetClass = "";
              betchipsaddtobetwindows.src = this.ReturnChipBasedAmount(this.state.anteBetAmount * 2);
              russianbet_amount = this.topLable_rsp(this.state.anteBetAmount * 2)
              betTextaddtoBetElement.textContent = russianbet_amount
              betTextaddtoBetClass = "bet-text-addtoBet20OS";
              break;

            default:
              break;
          }
          Object.assign(betchipsaddtobetwindows.style, porttraitejson.Betchiptobetwindows)
          betTextaddtoBetElement.classList.add(betTextaddtoBetClass, "bet-text-addtoBet-OS");
          gsap.to(this.chipbetref.current, {
            x: -772,
            y: -276,
            duration: 0.2,
            ease: "power2.inOut",
            zIndex: 2,
            autoAlpha: 1,
            onComplete: () => {
              // Object.assign(betchipsaddtobetwindows.style, porttraitejson.Betchiptobetwindows)
              // betTextaddtoBetElement.classList.add(betTextaddtoBetClass, "bet-text-addtoBet-OS");

            }
          });


        }

      } else {

        let betTextaddtoBetElement = document.getElementById("betTextaddtoBetTP");
        let betchipsaddtobetwindows = document.getElementById("betchipsaddtobetTP");
        let betTextaddtoBetClass = "bet-text-addtoBet20OS";
        document.getElementById("drawtextTP").textContent = "";
        document.getElementById("foldtextTP").textContent = "";
        betbutton.src = "";
        betbutton.style.cssText = "";
        document.getElementById("betbtntextTP").classList.remove("betwindowsOS");
        document.getElementById("betbtntextTP").textContent = "";
        betbutton.style.position = "";
        betbutton.style.width = "";
        betbutton.style.transform = "";

        foldbutton.src = "";
        foldbutton.style.cssText = "";
        document.getElementById("foldtextTP").classList.remove("foldtextwindowsOS");
        foldbutton.style.position = "";
        foldbutton.style.width = "";
        foldbutton.style.transform = "";

        drawbutton.src = "";
        drawbutton.style.cssText = "";
        drawbutton.style.position = "";
        drawbutton.style.height = "";
        drawbutton.style.width = "";
        drawbutton.style.transform = "";

        buybutton.src = "";
        buybutton.style.cssText = "";
        buybutton.style.position = "";
        buybutton.style.width = "";
        buybutton.style.transform = "";


        document.getElementById("betactiveOS").src = "";
        document.getElementById("betactiveOS").className = "";
        document.getElementById("mobileAntiMaskCoverOS").style.display = "block";
        // let doubleamt = this.state.totalbet * 2;
        let convrBet = this.topLable_rsp(this.state.anteBetAmount * 2);

        betchipsaddtobetwindows.src = this.ReturnChipBasedAmount(Number((this.state.anteBetAmount * 2).toFixed(2)));
        switch (this.state.count) {
          case 1:
            // betchipsaddtobetwindows.src = chip_10;
            // betTextaddtoBetElement.textContent = 10;
            betTextaddtoBetElement.textContent = convrBet;
            betTextaddtoBetClass = "bet-text-addtoBet10OS";
            break;
          case 2:
            // betchipsaddtobetwindows.src = chip_25;
            betTextaddtoBetElement.textContent = convrBet;
            break;
          case 3:
            // betchipsaddtobetwindows.src = chip_50;
            betTextaddtoBetElement.textContent = convrBet;
            break;
          case 4:
            // betchipsaddtobetwindows.src = chip_100;
            betTextaddtoBetElement.textContent = convrBet;
            break;
          case 5:
            // betchipsaddtobetwindows.src = chip_500;
            betTextaddtoBetElement.textContent = convrBet;
            break;
          case 6:
            // betchipsaddtobetwindows.src = chip_1000;
            betTextaddtoBetElement.textContent = convrBet;
            break;

          default:
            betTextaddtoBetClass = "bet-text-addtoBet20OS"
            break;
        }
        this.betchipactivated = true;

        if (window.innerHeight > window.innerWidth) {
          document.getElementById("betpannelTropicalcover").style.display = "block";
          betTextaddtoBetElement.className = "";
          betTextaddtoBetElement.style.cssText = "";
          betTextaddtoBetElement.classList.add(betTextaddtoBetClass, "bet-text-addtoBet-portrait-OS");
          Object.assign(betchipsaddtobetwindows.style, porttraitejson.BetchiptobetPortrait);

          gsap.to(this.chipbetref.current, {
            // x: -10,
            // y: -950,
            x: 213,
            y: -625,
            duration: 0.3,
            ease: "power2.inOut",
            zIndex: 2,
            autoAlpha: 1,
            autoAlpha: 1,
          });
          gsap.to(betTextaddtoBetElement, {
            // x: 12,
            // y: -1739,
            x: 244,
            y: -1230,
            duration: 0.3,
            ease: "power2.inOut",
            zIndex: 2,
            autoAlpha: 1,
            visibility: true,
            onStart: function () {
              betTextaddtoBetElement.style.zIndex = 2;
              betTextaddtoBetElement.style.visibility = 'visible';
            }
          });

        } else {
          document.getElementById("betpannelTropicalcover").style.display = "block";
          betTextaddtoBetElement.className = "";
          betTextaddtoBetElement.style.cssText = "";
          betTextaddtoBetElement.classList.add(betTextaddtoBetClass, "bet-text-addtoBet-lndsp-OS");
          Object.assign(betchipsaddtobetwindows.style, porttraitejson.BetchiptobetLndsp);

          gsap.to(this.chipbetref.current, {
            x: -527,
            y: -200,
            duration: 0.3,
            ease: "power2.inOut",
            zIndex: 2,
            autoAlpha: 1
          });
          gsap.to(betTextaddtoBetElement, {
            x: -526,
            y: -202,
            duration: 0.3,
            ease: "power2.inOut",
            zIndex: 2,
            autoAlpha: 1,
            onStart: function () {
              betTextaddtoBetElement.style.zIndex = 2;
              betTextaddtoBetElement.style.visibility = 'visible';
            }
          });


        }

      }


      const body = {
        sessionId: sessionStorage.getItem("sessionId"),
        CN: "POKER_GOLDEN_OASIS_BET",
        object: {
          action: "BET",
          gameId: this.props.gameId,
          playerId: Number(this.props.playerId),
          handId: Number(this.props.gameState.handId)
        },
      };
      // console.log(body);
      this.props.network.sendof(body);

      // const body2 = {
      //   CN: "GET_PLAYER_INFO",
      //   object: {
      //     gameId: Number(this.props.gameId,),
      //     playerId: Number(this.props.playerId),

      //   },
      //   sessionId: sessionStorage.getItem('sessionId'),
      // }
      // this.props.network.sendof(body2);
      // this.body2 = {};
    } else {
      const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_greaterthanbalnceTP");
      const textbetsHighElement = document.getElementById("textbets_highTP");
      const attentionElement = document.getElementById("attentionTP");

      popupbetGreaterthanBalnceElement.className = "";
      textbetsHighElement.className = "";
      attentionElement.className = "";
      this.setState({
        betshigh_balnce: true,
        lowBalaceErrorInfo: `Insufficient Funds to place the BET of ${doubleamt.toFixed(2)},Please DEPOSIT to continue playing.`
      })
      gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, autoAlpha: 0, duration: 0.5 },
        { scale: 1, duration: 0.5, rotate: 720, autoAlpha: 1, ease: "power2.out" });

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
          popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsOS");
          textbetsHighElement.classList.add("poptextBetshighwindowsOS");
          attentionElement.classList.add("attentionTextwindowsTP");

        }
      } else {
        if (window.innerHeight > window.innerWidth) {
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

            popupbetGreaterthanBalnceElement.classList.add("popupbetshighPortraitOS");
            textbetsHighElement.classList.add("poptextBetshighPortraitOS");
            attentionElement.classList.add("attentionTextPortraitOS");

          }
        } else {
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

            popupbetGreaterthanBalnceElement.classList.add("popupbetshighLndspOS");
            textbetsHighElement.classList.add("poptextBetshighPortraitOS");
            attentionElement.classList.add("attentionTextPortraitOS");

          }
        }
      }
    }
  }


  Exitoptionmenu() {
    this.setState({ isoptionmenu: false });
    var tl = gsap.timeline();
    tl.to("#optionsmenubuttonTP", {
      x: 458,
      y: 75,
      duration: 0.5,
      ease: "power2.inOut",
      zIndex: 12,
      autoAlpha: 1
    });
    tl.play();

  }
  topLable_rsp(value) {

    const labelValue = Math.abs(Number(value));
    return labelValue >= 1.0e+9

      ? Number((labelValue / 1.0e+9).toFixed(2)) + "B"
      // Six Zeroes for Millions 
      : labelValue >= 1.0e+6

        ? Number((labelValue / 1.0e+6).toFixed(2)) + "M"
        // Three Zeroes for Thousands
        : labelValue >= 1.0e+3

          ? Number((labelValue / 1.0e+3).toFixed(2)) + "K"

          : Number(labelValue.toFixed(2));
  }
  // disabledrwbutton(){

  //    this.setState({drawbuttonhandle:false})
  //     document.getElementById("drawtextTP").classList.remove("drawtextautoAlphaOS");
  // }
  numberOfCardsToBeDraw = (drawCardArray) => {
    console.log("drawCardArray", drawCardArray);
    console.log("shuffledPlayerCards", this.shuffledPlayerCards);

    // this.cardsRef.current.unselectPokerCards12(this.shuffledPlayerCards, drawCardArray);

    this.replaceCards = [...drawCardArray];
    console.log(this.replaceCards.length);
    if (this.replaceCards.length > 0) {
      this.setState({ drawbuttonhandle: false, disDrawbtn: 0 });
      document.getElementById("drawtextTP").classList.remove("drawtextautoAlphaOS");
      document.getElementById("drawbtnTP").classList.remove("drwnodropOS");
      document.getElementById("buybtnTP").style.opacity = "0.5";
      this.setState({ disableBuyButton: true })
    } else {
      this.setState({ drawbuttonhandle: true, disDrawbtn: 1 });
      document.getElementById("drawtextTP").classList.add("drawtextautoAlphaOS");
      document.getElementById("drawbtnTP").classList.add("drwnodropOS");

      document.getElementById("buybtnTP").style.opacity = "1"
      this.setState({ disableBuyButton: false })
    }

  };


  checkpayerordealerwins(res) {

    document.getElementById("bettextOS").style.color = "";
    this.clearallsettimeouts()
    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    this.setState({
      previousAnteBetAmount: res.anteBetAmount,
      isplayerinfoupdate: false
    })


    switch (res.winner) {
      case "Dealer":
        this.setState({ infoText: res.message })
        document.getElementById("betpannelinsurececoverTP").style.display = "none";
        document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelinsurenceOS");

        //  ------------------------------------- this.intialEnter
        // this.updateplayerbalnace();
        //  ------------------------------------- this.intialEnter
        document.getElementById("foldtextTP").classList.remove("insurenceOS");
        document.getElementById("betdecrementTP").classList.remove("drwnodropOS")
        document.getElementById("betincrenetTP").classList.remove("drwnodropOS")

        this.setState({ betchipincrementbtn: false, betdecreamentbtn: false })

        this.Howlersounds.current?.playSound("pokerchipsnd");

        document.getElementById("betactiveOS").src = "";
        document.getElementById("bettextOS").style.color = "";
        document.getElementById("betactiveOS").classList.remove("betactiveOS");
        this.setState({ betbutton: "REBET", buttontext: "REBETX2", betBtnValue: 2, keyboardhandle: true });


        let t1 = gsap.timeline();
        t1.to("#chipcenterpositionTP", {
          x: 2,
          y: -662,
          duration: 0.5,
          zIndex: 12,
          ease: "power2.inOut",
          autoAlpha: 1,
          onComplete: () => {
            gsap.set("#chipcenterpositionTP", { autoAlpha: 0 });
          }
        });

        let t2 = gsap.timeline();
        t2.to("#betchipsaddtobetTP", {
          x: -700,
          y: -1000,
          duration: 0.5,
          zIndex: 12,
          ease: "power2.inOut",
          autoAlpha: 1,
          // delay: 0.5,
          onComplete: () => {
            gsap.set("#betchipsaddtobetTP", { autoAlpha: 0 });
          }
        });

        t2.to("#betchipsaddtobetTP", {
          x: -2,
          y: 72,
          zIndex: -10,
          duration: 0.1,
          autoAlpha: 0,
          delay: 0.5,
        });

        gsap.to("#betTextaddtoBetTP", { duration: 0.1, zIndex: -2 })

        let centerchipsTP = gsap.timeline();
        centerchipsTP.to("#centerchipsTP", {
          zIndex: -2,
          autoAlpha: 0,
          onComplete: () => {
            document.getElementById("centerchipsTP").removeAttribute("src");
            document.getElementById("centerchipsTP").classList.remove("chip10centerpositionGO");
          }
        });
        centerchipsTP.pause();

        let t6 = gsap.timeline();
        t6.to("#betchipsaddtconfrmTP", {
          x: -1084,
          y: -1266, duration: 0.5, autoAlpha: 1,
          onComplete: () => {
            gsap.set("#betchipsaddtconfrmTP", { autoAlpha: 0 });
          }
        });
        t6.to("#betchipsaddtconfrmTP", {
          x: 0, y: 0, zIndex: -10, duration: 0.3, autoAlpha: 0, delay: 1.5
          // x: 100, y: -135, zIndex: -10, duration: 0.3, autoAlpha: 0, delay: 1.5
        });
        // t6.play();

        // gsap.from("#betTextaddtodrawOS", { autoAlpha: 0, zIndex: -3 })
        gsap.from("#betTextaddtoinsurenceTP", { zIndex: -2 })
        gsap.to("#betchipsaddtodrawTextTP", { autoAlpha: 0, zIndex: -2 })

        gsap.set(["#chipcenterpositionTP", "#betchipsaddtobetTP"], { clearProps: "all" });

        setTimeout(() => {
          // this.Howlersounds.current?.playSound("playerLose");
          this.updateplayerbalnace();


          //  ------------------------------------- this.intialEnter
          // document.getElementById("buttons_coverOS").classList.remove("buttons_coverOS")
          // document.getElementById("betpannelTropicalcover").style.display = "none";
          // document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelcoverOS");
          // betbutton.src = Betbtn;
          // Object.assign(betbutton.style, porttraitejson.Betbtnwindows)

          // foldbutton.src = Foldbnwindows;
          // Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)

          // document.getElementById("foldtextTP").textContent = "";

          // document.getElementById("betbtntextTP").textContent = this.props.language.Rebet;
          // document.getElementById("betbtntextTP").classList.add("betwindowsOS");
          // document.getElementById("foldtextTP").classList.add("rebettextwindowsOS");


          // document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;


          //  ------------------------------------- this.intialEnter


          this.setState({
            infoText: this.props.language.Place_antebet, disBetBtn: 0, totalwinRussian: 0,
            totalbet: 0,
            anteBetAmount: 0,
            updateBet: 0,
            disablemultibutton: false

          });
          document.getElementById("TPbetcircle").classList.remove("nonpointerOS")

          document.getElementById("rankinginfodelerOS").classList.remove("windowspokerrankingdelerOS");
          document.getElementById("rankinginfoOS").className = "";
          document.getElementById("rankinginfodelerOS").textContent = "";
          document.getElementById("rankinginfoOS").textContent = "";
          this.cardsRef.current.ReBet();
          this.dealerCardsContainer.current.ReBet();
          document.getElementById("crdscoverOS").classList.remove("crdscoverOS")

        }, 3500);


        // gsap.to("#betchipsaddtconfrmTP", { zIndex: -2 })
        // gsap.to("#betchipsaddtodrawOS", { zIndex: -2 })
        gsap.to("#betTextaddtodrawOS", { zIndex: -2 })

        gsap.to("#betchipsaddtobetTP", { zIndex: -2 })

        break;
      case "Player":

        document.getElementById("betpannelinsurececoverTP").style.display = "none";
        document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelinsurenceOS");
        gsap.to("#betTextaddtoinsurenceTP", { zIndex: -2 })
        gsap.to("#betTextaddtodrawOS", { autoAlpha: 0, zIndex: -20 })

        this.Dealerbetstoplayer(res)
        var tl = gsap.timeline();

        document.getElementById("betdecrementTP").classList.remove("drwnodropOS")
        document.getElementById("betincrenetTP").classList.remove("drwnodropOS")
        document.getElementById("foldtextTP").innerHTML = "";
        document.getElementById("foldtextTP").classList.remove("insurenceOS");
        document.getElementById("foldtextTP").classList.add("rebettextwindowsOS");

        this.setState(prevState => ({
          previousAnteBetAmount: prevState.anteBetAmount,
        }))

        gsap.from("#betTextaddtoinsurenceTP", { zIndex: -2 })

        let finalwinamount = this.topLable_rsp(res.totalWinAmount)

        this.setState({
          betbutton: "REBET", buttontext: "REBETX2",
          keyboardhandle: true,
          // totalwinRussian: res.totalWinAmount,
          betchipincrementbtn: false, betdecreamentbtn: false,
          betBtnValue: 2
        })
        document.getElementById("betactiveOS").src = "";
        document.getElementById("bettextOS").style.color = "";
        document.getElementById("betactiveOS").classList.remove("betactiveOS");


        let ttop = gsap.timeline();
        ttop.to("#chipcenterpositionTP", {
          x: 480,
          y: -245,
          duration: 0.5,
          zIndex: 12,
          ease: "power2.inOut",
          autoAlpha: 1,
          delay: 1,
          onComplete: () => {
            gsap.set("#chipcenterpositionTP", { delay: 3, autoAlpha: 0 });
          }
        });

        const antetextTP = document.querySelectorAll("#chipcenterpositionTP span");

        setTimeout(() => {
          //  antetextTP.forEach(el => el.textContent = res.anteWinAmount || "");
          antetextTP.forEach(el => el.textContent = this.topLable_rsp(res.anteWinAmount) || "");
        }, 900)

        setTimeout(() => {



          if (document.getElementById("winpopup_TP")) {
            document.getElementById("winpopup_TP").classList.add("winpopup_Oasis")
            document.getElementById("winamt_TPS").classList.add("winamt_Oasis")
          }
          this.setState({ infoText: res.message, totalwinRussian: res.totalWinAmount, })
          this.winPopupContainer.current.showWinAnimationAndMinAmount(res.totalWinAmount);
          this.Howlersounds.current?.playSound("playerWin");
          // this.updateplayerbalnace();
        }, 3000)

        let t8 = gsap.timeline();
        t8.to("#betchipsaddtconfrmTP", {
          x: -1083,
          y: -1265, duration: 0.5, autoAlpha: 1,
          onComplete: () => {
            gsap.set("#betchipsaddtconfrmTP", { autoAlpha: 0 });
          }
        });
        t8.to("#betchipsaddtconfrmTP", {
          x: 47, y: -52, duration: 0.5, zIndex: -2, autoAlpha: 0,
          onComplete: () => {
            gsap.set("#betchipsaddtconfrmTP", { autoAlpha: 1, delay: 2 });
          }

        });
        t8.play();
        let t9 = gsap.timeline();
        t9.to("#betchipsaddtobetTP", {
          x: -477,
          y: -481, duration: 0.5, autoAlpha: 1, delay: 1.5,
          onComplete: () => {
            gsap.set("#betchipsaddtobetTP", { autoAlpha: 0 });
          }
        });
        t9.to("#betchipsaddtobetTP", {
          x: 26, y: -66, duration: 0.1,
          onComplete: () => {
            gsap.set("#betchipsaddtobetTP", { autoAlpha: 0 });

          }

        });
        t9.play()

        let bettextOS = gsap.timeline();

        bettextOS.to("#betTextaddtoBetTP", {
          x: 300,
          y: -220, duration: 0.5, delay: 1.5, autoAlpha: 1,
          onComplete: () => {
            gsap.set("#betTextaddtoBetTP", { autoAlpha: 0 });
            const antetextTP = document.querySelectorAll("#chipcenterpositionTP span");
            // antetextTP.forEach(el => el.textContent = Number((res.anteWinAmount + res.winAmount).toFixed(2)));
            antetextTP.forEach(el => el.textContent = this.topLable_rsp(Number((res.anteWinAmount + res.winAmount).toFixed(2))));
          }

        });
        gsap.to("#betchipsaddtodrawTextTP", { autoAlpha: 0, zIndex: -2 })

        setTimeout(() => {
          const bettext_windows = document.querySelectorAll("#betTextaddtoBetTP");
          console.log(bettext_windows);

          bettext_windows.forEach(ele => {
            // ele.textContent = res.winAmount || "";
            ele.textContent = this.topLable_rsp(res.winAmount) || "";
            console.log(ele.textContent);
          });

        }, 500)

        setTimeout(() => {

          this.updateplayerbalnace();
          //  ------------------------------------- this.intialEnter

          // document.getElementById("buttons_coverOS").classList.remove("buttons_coverOS")

          // document.getElementById("betpannelTropicalcover").style.display = "none";
          // document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelcoverOS");

          // betbutton.src = Betbtn;
          // Object.assign(betbutton.style, porttraitejson.Betbtnwindows)
          // document.getElementById("betbtntextTP").textContent = this.props.language.Rebet;

          // document.getElementById("betbtntextTP").classList.add("betwindowsOS");

          // foldbutton.src = Foldbnwindows;
          // Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)

          // document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;
          // document.getElementById("foldtextTP").classList.add("rebettextwindowsOS");

          //  ------------------------------------- this.intialEnter
          gsap.to("#betTextaddtoBetTP", { zIndex: -20 })


          this.setState({
            infoText: this.props.language.Place_antebet,
            totalbet: 0,
            anteBetAmount: 0,
            disablemultibutton: false,
            disBetBtn: 0, totalwinRussian: 0, updateBet: 0,
          });

          // gsap.to("#chipcenterpositionTP", {
          //    x: 955, y: 290, duration: 0.1, autoAlpha: 0,

          // });
          document.getElementById("rankinginfodelerOS").classList.remove("windowspokerrankingdelerOS");


          document.getElementById("TPbetcircle").classList.remove("nonpointerOS")

          // gsap.to("#betchipsaddtobetTP", { zIndex: -2 })
          // gsap.to("#betchipsaddtconfrmTP", { zIndex: -2 })
          // gsap.to("#betchipsaddtodrawOS", { zIndex: -2 })
          // gsap.to("#chipcenterpositionTP", { zIndex: -2 })

          gsap.to("#betchipsaddtodrawTextTP", { zIndex: -2, duration: 0.1 })

          document.getElementById("rankinginfoOS").className = "";
          document.getElementById("rankinginfodelerOS").textContent = "";
          document.getElementById("rankinginfoOS").textContent = "";
          this.cardsRef.current.ReBet();
          this.dealerCardsContainer.current.ReBet();

          document.getElementById("crdscoverOS").classList.remove("crdscoverOS")
          if (document.getElementById("winpopup_TP")) {
            document.getElementById("winpopup_TP").classList.remove("winpopup_Oasis")
            document.getElementById("winamt_TPS").classList.remove("winamt_Oasis")
          }
        }, 5000);

        gsap.set(["#chipcenterpositionTP"], { clearProps: "all" });
        break;

      case "Dealer_no_hand":

        // gsap.from("#betchipsaddtobetTP", { zIndex: -2 })
        //gsap.from("#betTextaddtodrawOS",{zIndex:-2})
        gsap.from("# ", { zIndex: -2 })
        document.getElementById("betbtntextTP").classList.remove("noinsurenceOS");
        document.getElementById("betactiveOS").src = "";
        document.getElementById("bettextOS").style.color = "";
        this.clertime55 = setTimeout(() => {
          this.setState({
            betbutton: "YES", infoText: res.message, buttontext: "NO", Yesbtn: 0, Nobtn: 0, keyboardhandle: true,
            disablemultibutton: false, disClearBtn: 1, disBuybtn: 1, disDrawbtn: 1, FoldbtnTP: 1


          });
          betbutton.src = Betbtn;
          Object.assign(betbutton.style, porttraitejson.Betbtnwindows)
          document.getElementById("betbtntextTP").textContent = this.props.language.Yes;

          foldbutton.src = Foldbnwindows;
          Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)
          document.getElementById("foldtextTP").textContent = this.props.language.No;

          document.getElementById("betbtntextTP").classList.remove("insurenceOS");
          document.getElementById("foldtextTP").classList.remove("noinsurenceOS");
          document.getElementById("betbtntextTP").classList.add("betwindowsOS");
          document.getElementById("foldtextTP").classList.add("foldtextwindowsOS");

        }, 500);

      default:
        break;
    }

  }
  Showebetchipsgamestatehandle = (res) => {

    let betTextaddtoBetElement = document.getElementById("betTextaddtoBetTP");
    let betchipsaddtobetwindows = document.getElementById("betchipsaddtobetTP");
    betchipsaddtobetwindows.src = chip_10;
    betTextaddtoBetElement.textContent = this.topLable_rsp(res.betAmount);
    betTextaddtoBetElement.classList.add("bet-text-addtoBet-OS")
    gsap.to(this.chipbetref.current, {
      x: -965,
      y: -484,
      duration: 0.1,
      ease: "power2.inOut",
      zIndex: 2,
      autoAlpha: 1
    });
    // document.getElementById("rankinginfodelerOS").classList.add("windowspokerrankingdelerOS");
    // document.getElementById("rankinginfoOS").classList.add("windowspokerrankingOS");
    Object.assign(betchipsaddtobetwindows.style, porttraitejson.Betchiptobetwindows)

    this.setState({ infoText: res.message, pokerrankingdeler: res.dealerHand, pokerranking: res.playerHand })
  }
  showcheckpayerordealerwins(res) {
    this.clearallsettimeouts()
    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");


    // this.clertime37=setTimeout(() => {
    this.setState((prevState) => ({
      previousAnteBetAmount: prevState.anteBetAmount,
      totalbet: 0,
      // anteBetAmount: 0,
      // betdeductions: 0
    }));

    switch (res.winner) {
      case "Dealer":

        this.updateplayerbalnace();

        document.getElementById("foldtextTP").classList.remove("insurenceOS");
        document.getElementById("betdecrementTP").classList.remove("drwnodropOS")
        document.getElementById("betincrenetTP").classList.remove("drwnodropOS")
        document.getElementById("betpannelTropicalcover").style.display = "none";
        document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelcoverOS");

        this.setState({ betchipincrementbtn: false, betdecreamentbtn: false })
        this.Howlersounds.current?.playSound("pokerchipsnd");

        document.getElementById("betactiveOS").src = "";
        document.getElementById("bettextOS").style.color = "";
        document.getElementById("betactiveOS").classList.remove("betactiveOS");
        this.setState({
          betbutton: "REBET", previousAnteBetAmount: res.anteBetAmount,
          anteBetAmount: 0,
          buttontext: "REBETX2", disBetBtn: 0, betBtnValue: 2, keyboardhandle: true, totalWinAmount: 0
        });

        gsap.from("#betTextaddtoinsurenceTP", { zIndex: -2 })

        // setTimeout(() => {
        betbutton.src = Betbtn;
        Object.assign(betbutton.style, porttraitejson.Betbtnwindows)
        document.getElementById("betbtntextTP").textContent = this.props.language.Rebet;
        document.getElementById("betbtntextTP").classList.add("betwindows_rebetOS");

        foldbutton.src = Foldbnwindows;
        Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)
        document.getElementById("foldtextTP").textContent = "";
        document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;
        document.getElementById("foldtextTP").classList.add("rebettextwindowsOS");
        // }, 2000);
        this.setState({ infoText: this.props.language.Place_antebet, disBetBtn: 0, totalwinRussian: 0, updateBet: 0, });

        document.getElementById("rankinginfodelerOS").classList.remove("windowspokerrankingdelerOS");
        document.getElementById("rankinginfoOS").className = "";
        document.getElementById("rankinginfodelerOS").textContent = "";
        document.getElementById("rankinginfoOS").textContent = "";
        this.cardsRef.current.ReBet();
        this.dealerCardsContainer.current.ReBet();

        gsap.to("#betchipsaddtodrawTextTP", { autoAlpha: 0, zIndex: -2 })
        gsap.to("#betchipsaddtconfrmTP", { zIndex: -2 })
        gsap.to("#betchipsaddtodrawOS", { zIndex: -2 })
        gsap.to("#betTextaddtodrawOS", { zIndex: -2 })

        gsap.to("#betchipsaddtobetTP", { zIndex: -2 })

        // this.showcardsAdBetsParamState(res)

        break;

      case "Player":

        this.setState({
          infoText: this.props.language.Place_antebet,
          anteBetAmount: 0,
          disBetBtn: 0,
          totalwinRussian: 0,
          updateBet: 0,
        });

        gsap.to("#betTextaddtoinsurenceTP", { zIndex: -2 })
        gsap.to("#betTextaddtodrawOS", { autoAlpha: 0, zIndex: -20 })
        gsap.to("#betTextaddtoBetTP", { zIndex: -20 })


        this.updateplayerbalnace();
        // this.Dealerbetstoplayer()

        document.getElementById("foldtextTP").textContent = "";

        document.getElementById("betdecrementTP").classList.remove("drwnodropOS")
        document.getElementById("betincrenetTP").classList.remove("drwnodropOS")

        document.getElementById("foldtextTP").classList.remove("insurenceOS");
        document.getElementById("foldtextTP").classList.add("rebettextwindowsOS");

        document.getElementById("betpannelTropicalcover").style.display = "none";
        document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelcoverOS");


        this.setState(prevState => ({
          previousAnteBetAmount: prevState.anteBetAmount,

        }))

        gsap.from("#betTextaddtoinsurenceTP", { zIndex: -2 })
        // gsap.from("#betchipsaddtodrawOS",{x:-949,y:-337})
        // gsap.from("#betchipsaddtodrawOS",{x:44,y:-48,delay:4,autoAlpha:0})
        // gsap.from("#betchipsaddtobetTP",{zIndex:-2})
        // gsap.from("#betTextaddtodrawOS", { autoAlpha: 0, zIndex: -2 })
        gsap.to("#betTextaddtoBetTP", { zIndex: -20 })
        this.setState({
          betbutton: "REBET", buttontext: "REBETX2",
          keyboardhandle: true,
          betchipincrementbtn: false, betdecreamentbtn: false,
          previousAnteBetAmount: res.anteBetAmount,

          betBtnValue: 2
        })
        document.getElementById("betactiveOS").src = "";
        document.getElementById("bettextOS").style.color = "";
        document.getElementById("betactiveOS").classList.remove("betactiveOS");

        if (document.getElementById("winpopup_TP")) {
          document.getElementById("winpopup_TP").classList.add("winpopup_Oasis")
          document.getElementById("winamt_TPS").classList.add("winamt_Oasis")

        }

        //  setTimeout(() => {
        betbutton.src = Betbtn;
        Object.assign(betbutton.style, porttraitejson.Betbtnwindows)
        document.getElementById("betbtntextTP").textContent = this.props.language.Rebet;
        document.getElementById("betbtntextTP").classList.add("betwindows_rebetOS");

        foldbutton.src = Foldbnwindows;
        Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)

        document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;

        document.getElementById("foldtextTP").classList.add("rebettextwindowsOS");
        // }, 2000);

        // gsap.to("#betchipsaddtobetTP", { x: 27, y: 0, duration: 0 });
        if (document.getElementById("winpopup_TP")) {
          document.getElementById("winpopup_TP").classList.remove("winpopup_Oasis")
          document.getElementById("winamt_TPS").classList.remove("winamt_Oasis")
        }

        gsap.to("#betchipsaddtobetTP", { zIndex: -2 })
        gsap.to("#betchipsaddtodrawTextTP", { autoAlpha: 0, zIndex: -2 })
        gsap.to("#betchipsaddtconfrmTP", { zIndex: -2 })
        gsap.to("#betchipsaddtodrawOS", { zIndex: -2 })
        gsap.to("#chipcenterpositionTP", { zIndex: -2, autoAlpha: 0 })
        document.getElementById("rankinginfodelerOS").classList.remove("windowspokerrankingdelerOS");
        document.getElementById("rankinginfoOS").className = "";
        document.getElementById("rankinginfodelerOS").textContent = "";
        document.getElementById("rankinginfoOS").textContent = "";
        this.cardsRef.current.ReBet();
        this.dealerCardsContainer.current.ReBet();

        document.getElementById("rankinginfodelerOS").classList.remove("windowspokerrankingdelerOS");

        // this.showcardsAdBetsParamState(res)

        break;
      // case "Dealer doesn't have a hand. Would you like to replace the dealer's higher card for the cost equivalent of ANTE? Press either NO or YES.":

      case "Dealer_no_hand":
        // this.revealDealercards(res)
        this.dealerShuffledCards = [...res.dealerFinalCards]
        this.setState({
          anteBetAmount: res.anteBetAmount,
          totalbet: res.totalBetAmount,
          infoText: res.message,
          pokerranking: res.playerHand,
          pokerrankingdeler: res.dealerHand

        })
        document.getElementById("rankinginfodelerOS").classList.add("windowspokerrankingdelerOS");
        document.getElementById("rankinginfoOS").classList.add("windowspokerrankingOS");
        this.showcardsAdBetsParamState(res, res.playerFinalCards, res.dealerFinalCards);

        if (res.betAmount > 0) {

          this.Showebetchipsgamestatehandle(res)
          //  let betTextaddtoBetClass = "bet-text-addtoBet10OS";
          // Object.assign(betchipsaddtobetwindows.style,porttraitejson.Betchiptobetwindows)
        }
        // gsap.from("#betchipsaddtobetTP", { zIndex: -2 })
        //gsap.from("#betTextaddtodrawOS",{zIndex:-2})
        gsap.from("#betTextaddtoinsurenceTP", { zIndex: -2 })
        document.getElementById("betbtntextTP").classList.remove("noinsurenceOS");
        document.getElementById("betactiveOS").src = "";
        document.getElementById("betactiveOS").classList.remove("betactiveOS");
        document.getElementById("bettextOS").style.color = "";
        // this.clertime55=setTimeout(() => {
        this.setState({
          betbutton: "YES", buttontext: "NO", Yesbtn: 0, Nobtn: 0, keyboardhandle: true,

          disablemultibutton: false
        });
        betbutton.src = Betbtn;
        Object.assign(betbutton.style, porttraitejson.Betbtnwindows)
        document.getElementById("betbtntextTP").textContent = this.props.language.Yes;

        foldbutton.src = Foldbnwindows;
        Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)
        document.getElementById("foldtextTP").textContent = this.props.language.No;

        document.getElementById("betbtntextTP").classList.remove("insurenceOS");
        document.getElementById("foldtextTP").classList.remove("noinsurenceOS");
        document.getElementById("betbtntextTP").classList.add("betwindowsOS");
        document.getElementById("foldtextTP").classList.add("foldtextwindowsOS");

      // }, 500);

      default:
        break;
    }
    // }, 3500) 
  }

  removeconfirmdealercard_popup = () => {
    document.getElementById("confirmbuydealer_popupTP").style.display = "none";
    document.getElementById("confirmbuydealer_popupTP").classList.remove("popup_cnfrmbuydealrcardOS");
    document.getElementById("alertTxtOS").classList.remove("alertTxtOS");
    document.getElementById("alertTxtOS").innerHTML = "";
    document.getElementById("yesTP").classList.remove("yesbutton_popupOS")
    document.getElementById("noTP").classList.remove("nobutton_popupOS")
  }
  ShowbuydealercardResponse(res) {
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      // document.getElementById("rankinginfoOS").classList.add("windowspokerrankingOS");
      document.getElementById("rankinginfodelerOS").classList.add("windowspokerrankingdelerOS");
      this.setState({

        pokerrankingdeler: res.dealerHand,
        // pokerranking:res.playerHand,
        totalwinRussian: res.totalWinAmount
      })

      // this.showcardsAdBetsParamState(res,res.dealerCards,res.playerFinalCards)
      this.showcheckpayerordealerwins(res);

      if (res.message == `Attention! You have a ${res.playerHand}. Are you sure you want to buy a dealer card?`) {
        //   document.getElementById("Tropicalgamecover").style.display = "block";
        //  document.getElementById("Tropicalgamecover").classList.add("gamecover_enbledisableOS")

        this.setState({ multibuttonsebledsble: true, disablemultibutton: true, Yesbtn: 1, Nobtn: 1 })

        document.getElementById("betbtnTP").classList.remove("addpointerOS")
        document.getElementById("FoldbtnTP").classList.remove("addpointerOS")
        document.getElementById("betbtnTP").classList.add("drwnodropOS")
        document.getElementById("FoldbtnTP").classList.add("drwnodropOS")
        // document.getElementById("crdscoverOS").style.display="block"
        document.getElementById("crdscoverOS").classList.add("crdscoverOS")
        document.getElementById("playerDealerCardContainerTP").classList.remove("addpointerOS")

        document.getElementById("confirmbuydealer_popupTP").style.display = "block";
        document.getElementById("confirmbuydealer_popupTP").classList.add("popup_cnfrmbuydealrcardOS");
        document.getElementById("alertTxtOS").classList.add("alertTxtOS");

        document.getElementById("alertTxtOS").innerHTML = res.message;
        document.getElementById("yesTP").classList.add("yesbutton_popupOS")
        document.getElementById("noTP").classList.add("nobutton_popupOS")
        this.setState({
          //  infoText: res.message
          infoText: ""
        })

      }
      else {
        const betbutton = document.getElementById("betbtnTP");
        const foldbutton = document.getElementById("FoldbtnTP");
        if (
          (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
          (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
        ) {
          this.removeconfirmdealercard_popup();

          this.setState({ betbutton: "REBET", buttontext: "REBETX2", disBetBtn: 0, betBtnValue: 2, keyboardhandle: true })
          document.getElementById("drawtextTP").textContent = "";
          betbutton.src = "";
          betbutton.style.cssText = ""
          document.getElementById("betbtntextTP").classList.remove("betwindowsOS");

          foldbutton.src = "";
          foldbutton.style.cssText = ""
          document.getElementById("foldtextTP").classList.remove("foldtextwindowsOS");

          // this.setState({ infoText: res.message })

          betbutton.src = Betbtn;
          Object.assign(betbutton.style, porttraitejson.Betbtnwindows)
          document.getElementById("betbtntextTP").textContent = this.props.language.Rebet;

          foldbutton.src = Foldbnwindows;
          Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)
          document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;

        }

      }
    } else {

      const confirmbuydealerPopupElement = document.getElementById("confirmbuydealer_popupTP");
      document.getElementById("playerDealerCardContainerTP").style.zIndex = 1;
      const betbutton = document.getElementById("betbtnTP");
      const foldbutton = document.getElementById("FoldbtnTP");
      if (window.innerHeight > window.innerWidth) {
        switch (res.winner) {
          case "Dealer":
          case "Player":
            this.showPlayerorDealerorFold(res);

            break;
          case "Dealer_no_hand":
            // case "Dealer doesn't have a hand. Would you like to replace the dealer's higher card for the cost equivalent of ANTE? Press either NO or YES.":
            ;
          default:
            break;
        }

        if (res.message == `Attention! You have a ${res.playerHand}. Are you sure you want to buy a dealer card?`) {
          // console.log("Attention! You have a Three of a Kind. Are you sure you want to buy a dealer card?")
          this.showcardsAdBetsParamState(res, res.playerFinalCards, res.dealerFinalCards);
          this.shwnPrvsSteBuyDrawBtchips(res);
          this.ConfirmbuydealercardactivePopup = true
          // this.randomDealerCards = [...res.dealerFinalCards];
          this.dealerShuffledCards = [...res.dealerFinalCards]

          this.setState({
            multibuttonsebledsble: true,
            disablemultibutton: true,
            // infoText: res.message,
            infoText: "",
            pokerranking: res.playerHand,
            pokerrankingdeler: res.dealerHand

          })

          confirmbuydealerPopupElement.className = "";
          confirmbuydealerPopupElement.style.display = "block";
          confirmbuydealerPopupElement.classList.add("popup_cnfrmbuydealrcardPortrait_OS");
          document.getElementById("alertTxtOS").innerHTML = res.message;
          document.getElementById("alertTxtOS").classList.add('alertTxtPortraitOS');
          document.getElementById("yesTP").classList.add("yesbutton_popup_portraitOS")
          document.getElementById("noTP").classList.add("nobutton_popup_portraitOS")
          document.getElementById("rankinginfodelerOS").classList.add("pokerrankingdelerPortraitOS")
          document.getElementById("rankinginfoOS").classList.add("pokerrankingPortaitOS")

        }
        else {


          this.setState({ betbutton: "REBET", buttontext: "REBETX2" })
          document.getElementById("drawtextTP").textContent = "";
          betbutton.src = "";
          betbutton.style.cssText = ""
          document.getElementById("betbtntextTP").classList.remove("betportraitOS");

          foldbutton.src = "";
          foldbutton.style.cssText = ""
          document.getElementById("foldtextTP").classList.remove("foldtextportraitOS");
          document.getElementById("confirmbuydealer_popupTP").style.display = "none";
          confirmbuydealerPopupElement.classList.remove("popup_cnfrmbuydealrcardPortrait_OS");
          confirmbuydealerPopupElement.style.display = "none";
          document.getElementById("yesTP").classList.remove("yesbutton_popup_portraitOS")
          document.getElementById("noTP").classList.remove("nobutton_popup_portraitOS")
          // this.setState({ infoText: res.message })

          betbutton.src = Betbtn;
          document.getElementById("betbtntextTP").textContent = this.props.language.Rebet;
          Object.assign(betbutton.style, this.state.betbuttoncss);


          foldbutton.src = Foldbn;
          document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;
          Object.assign(foldbutton.style, this.state.foldbuttoncss);
        }

      } else {

        const drawtextElement = document.getElementById("drawtextTP")
        const foldtextElement = document.getElementById("foldtextTP")
        const betbtntextElement = document.getElementById("betbtntextTP")
        this.prevStatecheckPlayerOrDealerWinMblLndspe(res);


        if (res.message == `Attention! You have a ${res.playerHand}. Are you sure you want to buy a dealer card?`) {

          //   document.getElementById("Tropicalgamecover").style.display = "block";
          //  document.getElementById("Tropicalgamecover").classList.add("gamecover_enbledisableOS")

          this.showcardsAdBetsParamState(res, res.playerFinalCards, res.dealerFinalCards);
          this.shwnPrvsSteBuyDrawBtchips(res);
          this.ConfirmbuydealercardactivePopup = true;
          this.dealerShuffledCards = [...res.dealerFinalCards];

          this.setState({
            multibuttonsebledsble: true,
            disablemultibutton: true,
            // infoText: res.message,
            infoText: "",
            pokerranking: res.playerHand,
            pokerrankingdeler: res.dealerHand
          })
          confirmbuydealerPopupElement.className = "";
          confirmbuydealerPopupElement.style.display = "block";
          confirmbuydealerPopupElement.classList.add("popup_cnfrmbuydealrcardLndsp_OS");
          document.getElementById("alertTxtOS").innerHTML = res.message;
          document.getElementById("alertTxtOS").classList.add('alertTxtPortraitOS');
          document.getElementById("yesTP").classList.add("yesbutton_popup_portraitOS")
          document.getElementById("noTP").classList.add("nobutton_popup_portraitOS")
          document.getElementById("rankinginfodelerOS").classList.add("pokerrankingdelerLndSpeOS")
          document.getElementById("rankinginfoOS").classList.add("pokerrankingPlayerLndspOS")

        }
        else {

          this.setState({ betbutton: "REBET", buttontext: "REBETX2" })
          drawtextElement.textContent = "";

          betbutton.style.cssText = ""
          betbtntextElement.className = "";

          foldbutton.src = "";
          foldbutton.style.cssText = ""
          foldtextElement.className = "";

          confirmbuydealerPopupElement.classList.remove("popup_cnfrmbuydealrcardLndsp_OS");
          confirmbuydealerPopupElement.style.display = "none";
          document.getElementById("yesTP").classList.remove("yesbutton_popup_portraitOS")
          document.getElementById("noTP").classList.remove("nobutton_popup_portraitOS")
          // this.setState({ infoText: res.message })

          betbutton.src = Betbtn;
          Object.assign(betbutton.style, this.state.betbuttoncss);
          betbtntextElement.textContent = this.props.language.Rebet;
          // betbtntextElement.classList.add('betLandscapeOS');
          betbtntextElement.classList.add(this.state.betbtntextcss);


          foldbutton.src = Foldbn;
          Object.assign(foldbutton.style, this.state.foldbuttoncss);
          foldtextElement.textContent = this.props.language.RebetX2;
          // foldtextElement.classList.add("foldtextLandscapeOS");
          foldtextElement.classList.add(this.state.foldbtntextcss);
        }
      }
    }
  };

  drawbuybets(anteAmount) {
    console.log(anteAmount)
    this.Howlersounds.current?.playSound("pokerchipsnd");
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      this.setState({ infoText: "" })
      let betexttodraw = document.getElementById("betTextaddtodrawOS");
      gsap.to("#betTextaddtodrawOS", { autoAlpha: 2, zIndex: 15 })
      let betchipsdraw = document.getElementById("betchipsaddtodrawOS");

      let betTextaddtoBetClass = "";
      // this.setState((prevState) => ({
      //   totalbet: prevState.totalbet + prevState.anteBetAmount

      // }));
      let drwbetamnt
      // betexttodraw.textContent = this.topLable_rsp(this.state.anteBetAmount)
      // drwbetamnt = (this.state.anteBetAmount)

      betexttodraw.textContent = this.topLable_rsp(anteAmount)
      drwbetamnt = (anteAmount)

      // }
      switch (this.state.count) {
        case 1:
          betTextaddtoBetClass = "";
          betchipsdraw.src = this.ReturnChipBasedAmount(Number(drwbetamnt));
          betTextaddtoBetClass = "bet-text-addtodraw10OS";
          break;
        case 2:
          betTextaddtoBetClass = "";
          betchipsdraw.src = this.ReturnChipBasedAmount(Number(drwbetamnt));
          betTextaddtoBetClass = "bet-text-addtodraw20OS";

          break;
        case 3:
          betTextaddtoBetClass = "";
          betchipsdraw.src = this.ReturnChipBasedAmount(Number(drwbetamnt));
          betTextaddtoBetClass = "bet-text-addtodraw20OS";
          break;
        case 4:
          betTextaddtoBetClass = "";
          betchipsdraw.src = this.ReturnChipBasedAmount(Number(drwbetamnt));
          betTextaddtoBetClass = "bet-text-addtodraw20OS";
          break;
        case 5:
          betTextaddtoBetClass = "";
          betchipsdraw.src = this.ReturnChipBasedAmount(Number(drwbetamnt));
          betTextaddtoBetClass = "bet-text-addtodraw20OS";
          break;
        case 6:
          betTextaddtoBetClass = "";
          betchipsdraw.src = this.ReturnChipBasedAmount(Number(drwbetamnt));
          betTextaddtoBetClass = "bet-text-addtodraw20OS";
          break;

        default:
          break;
      }
      // this.clertime45 = setTimeout(() => {
      //   betexttodraw.classList.add(betTextaddtoBetClass, "bet-text-addtodrawOS");
      //   Object.assign(betchipsdraw.style, porttraitejson.betchipsdrawwindows)

      // }, 100)
      let t1 = gsap.timeline();
      // t1.to("#betchipsaddtodrawOS,betchipsaddtconfrmTP", {
      t1.to("#betchipsaddtodrawOS", {
        x: -1084,
        y: -598, duration: 0.2, autoAlpha: 1,
        onComplete: () => {
          // betexttodraw.classList.add(betTextaddtoBetClass, "bet-text-addtodrawOS");
          betexttodraw.classList.add(betTextaddtoBetClass, "bet-text-addtodrawOS");
          Object.assign(betchipsdraw.style, porttraitejson.betchipsdrawwindows)

        }
      });

      t1.play();
    }
  }

  ifPlayerWinsMobilePortraitAction = (res) => {
    // this.playerWin = new Audio(playerWin);
    // this.playerWin.currentTime = 0;

    const winpopuprspelement = document.getElementById("winpopup_TP");
    const winamtElement = document.getElementById("winamt_TPS");

    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    const betbtntextElement = document.getElementById("betbtntextTP");
    const foldtextElement = document.getElementById("foldtextTP");

    const anteText = document.querySelectorAll("#chipcenterpositionTP span");
    const betText = document.querySelector("#betTextaddtoBetTP");

    const delaerChipAnimDiv = document.getElementById('delaerchipanimTP')
    const dealerchipElement = document.getElementById('dealerchipTP');


    if (Number(res.anteWinAmount) > Number(res.anteBetAmount)) {
      dealerchipElement.src = this.ReturnChipBasedAmount(Number(res.anteBetAmount));
      // Object.assign(dealerchipElement.style, porttraitejson.dealerchipstoplayerPortrait)
      Object.assign(dealerchipElement.style, this.state.DelarAnteWinProLandAN)

      if (window.innerHeight > window.innerWidth) {
        let t1 = gsap.timeline()
        t1.to("#dealerchipTP", {
          autoAlpha: 1,
          zIndex: 2,
          x: -50,
          y: 1630,
          duration: 0.8,
          ease: "power2.inOut",
          onComplete: () => {
            gsap.set('#dealerchipTP', { autoAlpha: 0, zIndex: -10 })
          },
        });

        t1.to("#dealerchipTP", {
          x: -75,
          y: 20,
          duration: 0.002,
          ease: "power2.inOut",
          autoAlpha: 0,
          zIndex: -10

        })

        setTimeout(() => {
          for (let b = 0; b < anteText.length; b++) {
            anteText[b].textContent = this.topLable_rsp(res.anteWinAmount);
          }
        }, 500);
      } else {

        let t6 = gsap.timeline()
        t6.to("#dealerchipTP", {
          x: 555,
          y: 560,
          duration: 0.5,
          ease: "power2.inOut",
          onStart: () => {
            gsap.set('#dealerchipTP', { autoAlpha: 1, zIndex: 2 })
          },
          onComplete: () => {
            gsap.set('#dealerchipTP', { y: 0, autoAlpha: 0, zIndex: -10 })

            for (let b = 0; b < anteText.length; b++) {
              // anteText[b].textContent = res.anteWinAmount;
              anteText[b].textContent = this.topLable_rsp(res.anteWinAmount);
            }

          },
        });
      }


    }

    betText.textContent = this.topLable_rsp(res.winAmount);

    this.clertime52 = setTimeout(() => {
      // this.updateplayerbalnace();

      this.clertime53 = setTimeout(() => {
        this.clearActivesWeDid();
        // }, 1000);
      }, 3000);

      this.setState((prevState) => ({
        // infoText: res.message,
        // totalwinRussian: res.totalWinAmount,
        previousAnteBetAmount: res.anteBetAmount,
        anteBetAmount: 0,
        prevStatestoreantebetchips: [...prevState.storeantebetchips],
      }));

      delaerChipAnimDiv.className = "";
      dealerchipElement.src = "";
      dealerchipElement.className = "";

      this.resetAnimationChips = true;


      setTimeout(() => {


        // winpopuprspelement.classList.add("winPopupForMptSwOS");
        // winamtElement.classList.add("winamtMpSwOS");

        this.setState({
          infoText: res.message,
          totalwinRussian: res.totalWinAmount,
        }
        )
      }, 1800)

      gsap.fromTo(winpopuprspelement,
        {
          autoAlpha: 0, scale: 0, duration: 0.5,
        },
        {
          autoAlpha: 1, scale: 1, duration: 0.5, delay: 1.8, rotate: 0, onStart: () => {
          }
        },
      )

      document.getElementById("betactiveOS").src = "";
      document.getElementById("bettextOS").style.color = "";
      document.getElementById("betactiveOS").classList.remove("betactiveOS");

      // let t1 = gsap.timeline()
      if (window.innerHeight > window.innerWidth) {
        gsap.to("#chipcenterpositionTP", { x: -20, y: -740, duration: 1, });
        gsap.to("#betchipsaddtobetTP", {
          x: -20, y: -1260, duration: 1, delay: 0.5, onComplete: () => {
            betText.textContent = this.topLable_rsp(Number((res.anteWinAmount + res.winAmount).toFixed(2)));
          }
        });
        gsap.to("#betTextaddtoBetTP", { x: 10, y: -1860, duration: 1, delay: 0.5 });

        setTimeout(() => {
          winpopuprspelement.classList.add("winPopupForMptSwOS");
          winamtElement.classList.add("winamtMpSwOS");
        }, 1800)

      } else {

        if (document.getElementById("chipcenterpositionTP")) {
          gsap.to("#chipcenterpositionTP", { x: -630, y: -10, duration: 0.5 });
        }

        if (document.getElementById("betchipsaddtobetTP")) {
          gsap.to("#betchipsaddtobetTP", { x: -1065, y: -10, duration: 0.5, delay: 0.6 });
        }
        if (document.getElementById("betTextaddtoBetTP")) {
          gsap.to("#betTextaddtoBetTP", {
            x: -1065, y: -10, duration: 0.5, delay: 0.6, onComplete: () => {
              betText.textContent = this.topLable_rsp(Number((res.anteWinAmount + res.winAmount).toFixed(2)));
            }
          });
        }

        winpopuprspelement.classList.add("winPopupForMLspOS");
        winamtElement.classList.add("winamtMpSwOS");

        winpopuprspelement.classList.remove("winPopupForMptSwOS");
      }

      this.winPopupContainer.current.showWinAnimationAndMinAmount(res.totalWinAmount);
      this.Howlersounds.current?.playSound("playerWin");
      if (this.wanttobuydelercrd === true) {
        let t1 = gsap.timeline()
        t1.to(this.buyDealerCardDrawn.current, { x: -190, y: -2200, duration: 0.5 });
        t1.to(this.buyDealerCardDrawn.current, { autoAlpha: 0, });
        t1.to(this.buyDealerCardDrawn.current, { autoAlpha: 0, x: 0, y: 0, zIndex: -5 });
        t1.play();
      }

      this.setState({ betbutton: "REBET", buttontext: "REBETX2", disablemultibutton: false, betchipincrementbtn: false, betdecreamentbtn: false })




    }, 2000)

    this.resetPyrWnCpsAmn = true;

    this.clertime54 = setTimeout(() => {
      gsap.fromTo(winpopuprspelement, { scale: 1, duration: 0.5, rotate: 360 }, {
        autoAlpha: 0, scale: 0, duration: 0.5, onComplete: () => {
          winpopuprspelement.classList.remove("winPopupForMptSwOS");
          winamtElement.classList.remove("winamtMpSwOS");
        }
      })
      this.updateplayerbalnace();
      this.setState({
        totalwinRussian: 0,
        totalbet: 0,
        infoText: this.props.language.Play_Njoy,
        storeantebetchips: [],
      });

      // ......................................this.intialEnter
      // document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
      // betbutton.src = Betbtn;
      // // Object.assign(betbutton.style, porttraitejson.Betbtnportraite);
      // Object.assign(betbutton.style, this.state.betbuttoncss);

      // betbtntextElement.classList.remove('noinsurencePortraitOS', 'betportraiteOS');

      // betbtntextElement.textContent = this.props.language.Rebet;


      // // betbtntextElement.classList.add("betportraitOS");
      // betbtntextElement.classList.add(`${this.state.betbtntextcss}`);

      // // Object.assign(betbtntextElement.style, porttraitejson.betportraiteTP);

      // foldbutton.src = Foldbnwindows;
      // // Object.assign(foldbutton.style, porttraitejson.foldbtnportraite);
      // Object.assign(foldbutton.style, this.state.foldbuttoncss);

      // foldtextElement.classList.remove('insurencePortraitOS', 'foldtextportraiteOS', 'foldtextportraitOS');
      // foldtextElement.textContent = this.props.language.RebetX2;
      // // foldtextElement.classList.add("rebettextportraitOS");
      // foldtextElement.classList.add(`${this.state.foldbtntextcss}`);
      // ......................................this.intialEnter

      if (this.resetAnimationChips) {
        if (document.getElementById("chipcenterpositionTP")) {
          gsap.to("#chipcenterpositionTP", { x: 13, y: 1200, duration: 0.00001, zIndex: -2, autoAlpha: 0 });
        }

        if (document.getElementById("betchipsaddtobetTP")) {
          gsap.to("#betchipsaddtobetTP", { x: 1, y: 76, duration: 0.00001, zIndex: -2, autoAlpha: 0 });
          gsap.to("#betTextaddtoBetTP", { x: 153, y: 185, duration: 0.00001, zIndex: -2, autoAlpha: 0 });
        }

        // gsap.to(this.chipdrawref.current, { x: 548, y: 140, duration: 0.5, delay: 1, zIndex: -5, autoAlpha: 1 });
        // gsap.to(this.chipdrawref.current, { x: 608, y: -116, duration: 0.00001, zIndex: -5, autoAlpha: 0 });

        if (this.wanttobuydelercrd === true) {
          gsap.to(this.buyDealerCardDrawn.current, { x: 0, y: 0, duration: 0.00001, zIndex: -2, autoAlpha: 0 });
        }
      }

      // }, 4000)
    }, 6000)
    // }, 100000)
  }

  muteunmutesounds() {
    this.Howlersounds.current?.playSound("selectCard")
    // this.selectCard.currentTime = 0;
    // if (this.state.mutesounds) {
    //   this.selectCard.play();
    // } else {
    //   this.selectCard.pause();
    // }

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      document.getElementById('volumeTropical').classList.add("addpointerOS")
    }

    if (!this.state.mutesounds) {
      this.setState({ mutesounds: true })
      document.getElementById('volumeTropical').src = mutesnds;

    }
    else {
      this.setState({ mutesounds: false })
      document.getElementById('volumeTropical').src = volumeimg;

    }
  }
  Dealerbetstoplayer = (response) => {

    if (response.anteWinAmount > response.anteBetAmount) {

      let dealerchipTP = document.getElementById("dealerchipTP")
      dealerchipTP.src = this.ReturnChipBasedAmount(response.anteBetAmount)

      Object.assign(dealerchipTP.style, porttraitejson.dealerchipstoplayer)
      let tl = gsap.timeline()
      tl.to(dealerchipTP, {
        x: -22,
        y: 983,
        duration: 0.8,
        autoAlpha: 1,
        //  delay: 1.5,
        ease: "power2.inOut",
        onComplete: () => {
          gsap.set(dealerchipTP, { autoAlpha: 0 })
        }
      });
      tl.to(dealerchipTP, {
        x: 31,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
      });
      // tl.play();
    }

  }


  hidepopup_betshigh = () => {

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_greaterthanbalnceTP");
      if (document.getElementById("popupbet_greaterthanbalnceTP")) {
        gsap.to(popupbetGreaterthanBalnceElement, {
          scale: 0,
          duration: 0.25,
          rotate: 0,
          autoAlpha: 0,
          ease: "power2.out",
          onComplete: () => {
            popupbetGreaterthanBalnceElement.className = "";
            popupbetGreaterthanBalnceElement.classList.add("popupbetshighMobileIntialOS");
          }

        }
        );
      }
    } else {
      this.setState({ betshigh_balnce: false })
      const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_greaterthanbalnceTP");
      if (document.getElementById("popupbet_greaterthanbalnceTP")) {
        gsap.to(popupbetGreaterthanBalnceElement, {
          scale: 0,
          duration: 0.25,
          rotate: 0,
          autoAlpha: 0,
          ease: "power2.out",
          onComplete: () => {
            popupbetGreaterthanBalnceElement.className = "";
            popupbetGreaterthanBalnceElement.classList.add("popupbetshighMobileIntialOS");
          }

        }
        );
      }
    }
  }

  updatePlayerInfo() {

    this.setState({ isplayerinfoupdate: true })

    this.setState({
      betdeductions: 0
    });

    //  const rankinginfoElement = document.getElementById("rankinginfoOS");
    //  if (rankinginfoElement) {
    //   if (this.state.isMobilePortraitLndsp) {
    //      rankinginfoElement.style.left = "34%";
    //    }
    //  }
  }
  showAnteBetchips = () => {
    return (
      this.state.storeantebetchips.map((eachchip, index) => (
        <div key={index} id="chipcenterpositionTP" className={`${this.state.antebetpdvcss}`}>
          <img
            className={`${this.state.antechpimgcss}`}
            src={eachchip.chip}
            alt="Chip"
          />
          <span className={`${eachchip.chipcolor1} ${this.state.antespntxtcss}`} >{eachchip.chipvalue}</span>
        </div>
      ))
    )
  }




  ShowHistory() {
    this.setState({ ShowHistory: !this.state.ShowHistory, ShowGamerules: false, ShowLimits: this.state.ShowLimits ? false : this.state.ShowLimits, ishistorytable: true }, () => {

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        if (document.getElementById("histry_oasis")) {
          document.getElementById("histry_oasis")?.classList.remove("histry_oasisprotraite")

        }
        if (document.getElementById("exithistoryTP")) {
          document.getElementById("exithistoryTP")?.classList.remove("exihstrybuttonportraiteOS")

        }
        if (document.getElementById("prevhistoryTP")) {
          document.getElementById("prevhistoryTP")?.classList.remove("showprevhsrytbleportraiteOS")

        }
        if (document.getElementById("histry_bodyOS")) {
          document.getElementById("histry_bodyOS")?.classList.remove("histry_bodyportraiteOS")
        }
        if (document.getElementById("heading_hstiryOS")) {
          document.getElementById("heading_hstiryOS")?.classList.remove("heading_hstiryportraiteOS")

        }
        if (document.getElementById("histry_oasis")) {
          document.getElementById("histry_oasis")?.classList.remove("histry_Oasislndspe")

        }
        if (document.getElementById("exithistoryTP")) {
          document.getElementById("exithistoryTP")?.classList.remove("exihstrybuttonlndspeOS")

        }
        if (document.getElementById("prevhistoryTP")) {
          document.getElementById("prevhistoryTP")?.classList.remove("showprevhsrytblelndspeOS")

        }
        if (document.getElementById("histry_bodyOS")) {
          document.getElementById("histry_bodyOS")?.classList.remove("histry_bodylndspeOS")

        }
        if (document.getElementById("heading_hstiryOS")) {
          document.getElementById("heading_hstiryOS")?.classList.remove("heading_hstirylndspeOS")

        }


        if (document.getElementById("histry_oasis")) {
          document.getElementById("histry_oasis").classList.add("histry_oasis")

        }
        if (document.getElementById("exithistoryTP")) {
          document.getElementById("exithistoryTP").classList.add("exihstrybuttonOS")

        }
        // setTimeout(() => {
        if (document.getElementById("prevhistoryTP")) {
          document.getElementById("prevhistoryTP").classList.add("showprevhsrytbleOS")
        }
        // }, 100)
        if (document.getElementById("histry_bodyOS")) {
          document.getElementById("histry_bodyOS").classList.add("histry_bodyOS")

        }
        if (document.getElementById("heading_hstiryOS")) {
          document.getElementById("heading_hstiryOS").classList.add("heading_hstiryOS")

        }

        // document.getElementById("dealercards_hstryTP").classList.add("dealercards_hstryTP")
        // document.getElementById("dealerhand_hstryTP").classList.add("dealerhand_hstryTP")
        // document.getElementById("playercards_hstryTP").classList.add("playercards_hstryTP")
        // document.getElementById("playerhand_hstry").classList.add("playerhand_hstry")
        // document.getElementById("totalbet_histry").classList.add("totalbet_histry")
        // document.getElementById("totalwin_hstry").classList.add("totalwin_hstry")

      }
      else {

        if (window.innerHeight > window.innerWidth) {

          if (document.getElementById("histry_oasis")) {
            document.getElementById("histry_oasis")?.classList.remove("histry_Oasislndspe")

          }
          if (document.getElementById("exithistoryTP")) {
            document.getElementById("exithistoryTP")?.classList.remove("exihstrybuttonlndspeOS")

          }
          if (document.getElementById("prevhistoryTP")) {
            document.getElementById("prevhistoryTP")?.classList.remove("showprevhsrytblelndspeOS")

          }
          if (document.getElementById("histry_bodyOS")) {
            document.getElementById("histry_bodyOS")?.classList.remove("histry_bodylndspeOS")

          }
          if (document.getElementById("heading_hstiryOS")) {
            document.getElementById("heading_hstiryOS")?.classList.remove("heading_hstirylndspeOS")

          }
          if (document.getElementById("histry_oasis")) {
            document.getElementById("histry_oasis")?.classList.remove("histry_oasis")

          }
          if (document.getElementById("exithistoryTP")) {
            document.getElementById("exithistoryTP")?.classList.remove("exihstrybuttonOS")

          }
          if (document.getElementById("prevhistoryTP")) {
            document.getElementById("prevhistoryTP")?.classList.remove("showprevhsrytbleOS")

          }
          if (document.getElementById("histry_bodyOS")) {
            document.getElementById("histry_bodyOS")?.classList.remove("histry_bodyOS")

          }
          if (document.getElementById("heading_hstiryOS")) {
            document.getElementById("heading_hstiryOS").classList.add("heading_hstiryOS")

          }

          if (document.getElementById("histry_oasis")) {
            document.getElementById("histry_oasis").classList.add("histry_oasisprotraite")

          }
          if (document.getElementById("exithistoryTP")) {
            document.getElementById("exithistoryTP").classList.add("exihstrybuttonportraiteOS")

          }
          // setTimeout(() => {
          if (document.getElementById("prevhistoryTP")) {
            document.getElementById("prevhistoryTP").classList.add("showprevhsrytbleportraiteOS")

          }
          // }, 500)
          if (document.getElementById("histry_bodyOS")) {
            document.getElementById("histry_bodyOS").classList.add("histry_bodyportraiteOS")

            if (document.getElementById("heading_hstiryOS")) {
              document.getElementById("heading_hstiryOS").classList.add("heading_hstiryportraiteOS")

            }

          }
        }
        else {


          if (document.getElementById("histry_oasis")) {
            document.getElementById("histry_oasis")?.classList.remove("histry_oasis")

          }
          if (document.getElementById("exithistoryTP")) {
            document.getElementById("exithistoryTP")?.classList.remove("exihstrybuttonOS")

          }
          if (document.getElementById("prevhistoryTP")) {
            document.getElementById("prevhistoryTP")?.classList.remove("showprevhsrytbleOS")

          }
          if (document.getElementById("histry_bodyOS")) {
            document.getElementById("histry_bodyOS")?.classList.remove("histry_bodyOS")

          }
          if (document.getElementById("heading_hstiryOS")) {
            document.getElementById("heading_hstiryOS")?.classList.remove("heading_hstiryOS")

          }

          if (document.getElementById("histry_oasis")) {
            document.getElementById("histry_oasis")?.classList.remove("histry_oasisprotraite")

          }
          if (document.getElementById("exithistoryTP")) {
            document.getElementById("exithistoryTP")?.classList.remove("exihstrybuttonportraiteOS")

          }
          if (document.getElementById("prevhistoryTP")) {
            document.getElementById("prevhistoryTP")?.classList.remove("showprevhsrytbleportraiteOS")

          }
          if (document.getElementById("histry_bodyOS")) {
            document.getElementById("histry_bodyOS")?.classList.remove("histry_bodyportraiteOS")
          }
          if (document.getElementById("heading_hstiryOS")) {
            document.getElementById("heading_hstiryOS").classList.remove("heading_hstiryportraiteOS")

          }

          if (document.getElementById("histry_oasis")) {
            document.getElementById("histry_oasis").classList.add("histry_Oasislndspe")

          }
          if (document.getElementById("exithistoryTP")) {
            document.getElementById("exithistoryTP").classList.add("exihstrybuttonlndspeOS")

          }
          if (document.getElementById("prevhistoryTP")) {
            document.getElementById("prevhistoryTP").classList.add("showprevhsrytblelndspeOS")

          }
          if (document.getElementById("histry_bodyOS")) {
            document.getElementById("histry_bodyOS").classList.add("histry_bodylndspeOS")

          }
          if (document.getElementById("heading_hstiryOS")) {
            document.getElementById("heading_hstiryOS").classList.add("heading_hstirylndspeOS")

          }
        }

      }

    })
  }
  exithistoryTP() {
    this.setState({ ShowHistory: false })

  }
  hideshowoptionmenu() {

    this.setState({ isoptionmenu: false, ShowLimits: false })
  }
  // animexit(){

  //   if(document.getElementById("exithistoryTP")){
  //     document.getElementById("exithistoryTP").classList.add("exithistoryTP")

  //   }

  // }
  confirmfoldresp() {

  }


  confirmFoldactin(cnfrmtext) {
    this.Howlersounds.current?.playSound("betchipsnd");
    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }
    const confirmbuydealerPopupElement = document.getElementById("confirmbuydealer_popupTP");
    if (cnfrmtext === true) {
      let betexttodraw = document.getElementById("betchipsaddtodrawTextTP");
      betexttodraw.classList.remove("bet-text-addtodrawOS", "bet-text-addtoinsurence10OS")
      const drawtextElement = document.getElementById("drawtextTP");
      const buybutton = document.getElementById("buybtnTP");
      const drawbutton = document.getElementById("drawbtnTP");
      buybutton.src = "";
      drawbutton.src = "";
      drawtextElement.textContent = "";
      document.getElementById("alertTxtOS").classList.remove("alertTxtOS");

      document.getElementById("alertTxtOS").innerHTML = "";
      document.getElementById("confirmbuydealer_popupTP").style.display = "none";
      document.getElementById("confirmbuydealer_popupTP").classList.remove("popup_cnfrmbuydealrcardOS");
      document.getElementById("yesTP").classList.remove("yesbutton_popupOS")
      document.getElementById("noTP").classList.remove("nobutton_popupOS")

      confirmbuydealerPopupElement.className = "";
      confirmbuydealerPopupElement.style.display = "none";
      confirmbuydealerPopupElement.classList.remove("popup_cnfrmbuydealrcardPortrait_OS");
      document.getElementById("alertTxtOS").innerHTML = "";
      document.getElementById("alertTxtOS").classList.remove('alertTxtPortraitOS');
      document.getElementById("yesTP").classList.remove("yesbutton_popup_portraitOS")
      document.getElementById("noTP").classList.remove("nobutton_popup_portraitOS")



      confirmbuydealerPopupElement.classList.remove("popup_cnfrmbuydealrcardLndsp_OS");
      document.getElementById("alertTxtOS").innerHTML = "";
      document.getElementById("alertTxtOS").classList.remove('alertTxtPortraitOS');
      document.getElementById("yesTP").classList.remove("yesbutton_popup_portraitOS")
      document.getElementById("noTP").classList.remove("nobutton_popup_portraitOS")

      const body = {
        sessionId: sessionStorage.getItem("sessionId"),

        CN: "POKER_GOLDEN_OASIS_BET",
        object: {
          action: "CONFIRM_FOLD",
          gameId: this.props.gameId,
          playerId: Number(this.props.playerId),
          handId: Number(this.props.gameState.handId)
        },
      };

      this.props.network.sendof(body);

    }

    else {

      if (this.drawReplaceCards === true) {
        this.showParamBetStatus(true);
      } else {
        this.showParamBetStatus(false);
      }
      document.getElementById("alertTxtOS").classList.remove("alertTxtOS");

      document.getElementById("alertTxtOS").innerHTML = "";
      document.getElementById("confirmbuydealer_popupTP").classList.remove("popup_cnfrmbuydealrcardOS");
      document.getElementById("yesTP").classList.remove("yesbutton_popupOS")
      document.getElementById("noTP").classList.remove("nobutton_popupOS")

      confirmbuydealerPopupElement.className = "";
      confirmbuydealerPopupElement.style.display = "none";
      confirmbuydealerPopupElement.classList.remove("popup_cnfrmbuydealrcardPortrait_OS");
      document.getElementById("alertTxtOS").innerHTML = "";
      document.getElementById("alertTxtOS").classList.remove('alertTxtPortraitOS');
      document.getElementById("yesTP").classList.remove("yesbutton_popup_portraitOS")
      document.getElementById("noTP").classList.remove("nobutton_popup_portraitOS")



      confirmbuydealerPopupElement.classList.remove("popup_cnfrmbuydealrcardLndsp_OS");
      document.getElementById("alertTxtOS").innerHTML = "";
      document.getElementById("alertTxtOS").classList.remove('alertTxtPortraitOS');
      document.getElementById("yesTP").classList.remove("yesbutton_popup_portraitOS")
      document.getElementById("noTP").classList.remove("nobutton_popup_portraitOS")

    }

  }




  ShowLimits() {
    this.setState({ ShowLimits: !this.state.ShowLimits, ShowGamerules: false, ShowHistory: this.state.ShowHistory ? false : this.state.ShowHistory }, () => {

      // exitLimits
      const exitLimitsElement = document.getElementById("exitLimits");
      // exitLimitsElement.className = "";
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        document.getElementById("Limits")?.classList.remove("LimitsPopup_landspeOS")
        document.getElementById("Limits")?.classList.remove("LimitsPopup_portraiteOS")
        document.getElementById("Limits")?.classList.add("LimitsPopupOS");
        // exitLimitsElement.classList.add("exihstrybuttonportraiteOS");
      }
      else {
        if (window.innerHeight > window.innerWidth) {
          document.getElementById("Limits")?.classList.remove("LimitsPopupOS")
          document.getElementById("Limits")?.classList.remove("LimitsPopup_landspeOS")
          document.getElementById("Limits")?.classList.add("LimitsPopup_portraiteOS")
          // exitLimitsElement.classList.add("exihstrybuttonportraiteOS");

        }
        else {

          document.getElementById("Limits")?.classList.remove("LimitsPopupOS")
          document.getElementById("Limits")?.classList.remove("LimitsPopup_portraiteOS")
          document.getElementById("Limits")?.classList.add("LimitsPopup_landspeOS")
          // exitLimitsElement.classList.add("exihstrybuttonportraiteOS");

        }
      }

    })

  }

  exitLimits = () => {
    this.setState({ ShowLimits: false })
  }
  Gamerules = () => {
    this.setState({ ShowGamerules: !this.state.ShowGamerules, ShowHistory: false, ShowLimits: false }, () => {

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        // this.setState({ShowGamerules:true},()=>{


        document.getElementById("ShowGamerulesTP")?.classList.remove("GamerulescontainerportOS")
        document.getElementById("gameruleMainHeadingOS")?.classList.remove("gameruleMainHeadingportOS")
        document.getElementById("unorderedlistitemsOS")?.classList.remove("unorderedlistitemsportOS")
        document.getElementById("ShowGamerulesTP")?.classList.remove("GamerulescontainerlndOS")
        document.getElementById("gameruleMainHeadingOS")?.classList.remove("gameruleMainHeadinglndOS")
        document.getElementById("unorderedlistitemsOS")?.classList.remove("unorderedlistitemslndOS")

        document.getElementById("ShowGamerulesTP")?.classList.add("GamerulescontainerOS")
        document.getElementById("gameruleMainHeadingOS")?.classList.add("gameruleMainHeadingOS")
        document.getElementById("unorderedlistitemsOS")?.classList.add("unorderedlistitemsOS")

        // })

      }
      else {
        if (window.innerHeight > window.innerWidth) {


          document.getElementById("ShowGamerulesTP")?.classList.remove("GamerulescontainerOS")
          document.getElementById("gameruleMainHeadingOS")?.classList.remove("gameruleMainHeadingOS")
          document.getElementById("unorderedlistitemsOS")?.classList.remove("unorderedlistitemsOS")
          document.getElementById("ShowGamerulesTP")?.classList.remove("GamerulescontainerlndOS")
          document.getElementById("gameruleMainHeadingOS")?.classList.remove("gameruleMainHeadinglndOS")
          document.getElementById("unorderedlistitemsOS")?.classList.remove("unorderedlistitemslndOS")

          document.getElementById("ShowGamerulesTP")?.classList.add("GamerulescontainerportOS")
          document.getElementById("gameruleMainHeadingOS")?.classList.add("gameruleMainHeadingportOS")
          document.getElementById("unorderedlistitemsOS")?.classList.add("unorderedlistitemsportOS")
        }
        else {

          document.getElementById("ShowGamerulesTP")?.classList.remove("GamerulescontainerOS")
          document.getElementById("gameruleMainHeadingOS")?.classList.remove("gameruleMainHeadingOS")
          document.getElementById("unorderedlistitemsOS")?.classList.remove("unorderedlistitemsOS")
          document.getElementById("ShowGamerulesTP")?.classList.remove("GamerulescontainerportOS")
          document.getElementById("gameruleMainHeadingOS")?.classList.remove("gameruleMainHeadingportOS")
          document.getElementById("unorderedlistitemsOS")?.classList.remove("unorderedlistitemsportOS")
          document.getElementById("ShowGamerulesTP")?.classList.add("GamerulescontainerlndOS")
          document.getElementById("gameruleMainHeadingOS")?.classList.add("gameruleMainHeadinglndOS")
          document.getElementById("unorderedlistitemsOS")?.classList.add("unorderedlistitemslndOS")
        }
      }
    })
  }

  closeMenuOption = () => {
    this.setState({
      isoptionmenu: false,
      ShowLimits: false,
      ShowHistory: false,
      ShowGamerules: false,
    })
  }

  showTableImage = () => {

    const pokertable = document.getElementById("pokertableimos");
    const pokertablelnspe = document.getElementById("pokertablelandscapeos");
    const Russiantblewindows = document.getElementById("Osntblewindows");

    // if (pokertable && pokertable) {
    //   if (pokertable.style?.cssText && pokertable?.src) {
    //     pokertable.style.cssText = "";
    //     pokertable.src = "";
    //   }
    // }

    // if (pokertablelnspe && pokertablelnspe) {
    //   if (pokertablelnspe.style?.cssText && pokertablelnspe?.src) {
    //     pokertablelnspe.style.cssText = "";
    //     pokertablelnspe.src = "";
    //   }

    // }

    // if (Russiantblewindows && Russiantblewindows) {
    //   if (Russiantblewindows.style?.cssText && Russiantblewindows?.src) {
    //     Russiantblewindows.style.cssText = "";
    //     Russiantblewindows.src = "";
    //   }

    // }

    // // if (navigator.userAgentData?.platform === "Windows" || navigator.userAgent.includes("Windows")) {
    // //   if (Russiantblewindows) {
    // //     Russiantblewindows.src = Rutablewindows;
    // //     Object.assign(Russiantblewindows.style, porttraitejson.russtablewindows)
    // //   }

    // // 
    // if (navigator.userAgentData?.platform === "Windows" || navigator.userAgent.includes("Windows")) {
    //   import("../../../../../assets/games/oasisgoldenpoker/OasisPokerwinTable.png").then((module) => {
    //     const Rutablewindows = module.default;
    //     if (Russiantblewindows) {
    //       Russiantblewindows.src = Rutablewindows;
    //       Object.assign(Russiantblewindows.style, porttraitejson.russtablewindows);
    //     }
    //   });
    // }
    // else {
    //   if (window.innerHeight > window.innerWidth) {
    //     if (pokertable) {

    //       pokertable.style.backgroundSize = "cover";

    //       import("../../../../../assets/games/oasisgoldenpoker/OSprotraiteTable.png").then((module) => {
    //         const pokertableruss = module.default;
    //         pokertable.src = pokertableruss;
    //       });
    //       Object.assign(pokertable.style, porttraitejson.pokertable);
    //     }

    //   } else {
    //     if (pokertablelnspe) {
    //       Object.assign(pokertablelnspe.style, porttraitejson.pokertableland);
    //       import("../../../../../assets/games/oasisgoldenpoker/land.png").then((module) => {
    //         const pokertablelandsp = module.default;
    //         pokertablelnspe.src = pokertablelandsp;
    //       });

    //     }

    //   }

    // }





    // start new code  that not blinking table 

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      if (pokertable && pokertable) {
        if (pokertable.style?.cssText && pokertable?.src) {
          pokertable.style.cssText = "";
          pokertable.src = "";
        }
      }

      if (pokertablelnspe && pokertablelnspe) {
        if (pokertablelnspe.style?.cssText && pokertablelnspe?.src) {
          pokertablelnspe.style.cssText = "";
          pokertablelnspe.src = "";
        }
      }

      import("../../../../../assets/games/oasisgoldenpoker/OasisPokerwinTable.webp").then((module) => {
        const Rutablewindows = module.default;
        if (Russiantblewindows) {
          Russiantblewindows.src = Rutablewindows;
          Object.assign(Russiantblewindows.style, porttraitejson.russtablewindows);
        }
      });
    } else {

      if (window.innerHeight > window.innerWidth) {

        if (pokertablelnspe && pokertablelnspe) {
          if (pokertablelnspe.style?.cssText && pokertablelnspe?.src) {
            pokertablelnspe.style.cssText = "";
            pokertablelnspe.src = "";
          }
        }

        if (Russiantblewindows && Russiantblewindows) {
          if (Russiantblewindows.style?.cssText && Russiantblewindows?.src) {
            Russiantblewindows.style.cssText = "";
            Russiantblewindows.src = "";
          }
        }


        if (pokertable) {

          pokertable.style.backgroundSize = "cover";

          import("../../../../../assets/games/oasisgoldenpoker/OSprotraiteTable.webp").then((module) => {
            const pokertableruss = module.default;
            pokertable.src = pokertableruss;
          });
          Object.assign(pokertable.style, porttraitejson.pokertable);
        }

      } else {
        if (pokertable && pokertable) {
          if (pokertable.style?.cssText && pokertable?.src) {
            pokertable.style.cssText = "";
            pokertable.src = "";
          }
        }

        if (Russiantblewindows && Russiantblewindows) {
          if (Russiantblewindows.style?.cssText && Russiantblewindows?.src) {
            Russiantblewindows.style.cssText = "";
            Russiantblewindows.src = "";
          }
        }

        if (pokertablelnspe) {
          Object.assign(pokertablelnspe.style, porttraitejson.pokertableland);
          import("../../../../../assets/games/oasisgoldenpoker/land.webp").then((module) => {
            const pokertablelandsp = module.default;
            pokertablelnspe.src = pokertablelandsp;
          });

        }
      }
    }
  }

  showPayoutBonusTable12() {
    this.Howlersounds.current?.playSound("selectCard");
    this.setState({
      PayoutTableToggle: true
      // PayoutTableToggle: !this.state.PayoutTableToggle
    }, () => {
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        if (document.getElementById("PAYOUTTABLETPS")) {
          document.getElementById("PAYOUTTABLETPS").classList.add("showPayoutOS")
        }
      } else {

        if (window.innerHeight > window.innerWidth) {
          if (document.getElementById("PAYOUTTABLETPS")) {
            document.getElementById("PAYOUTTABLETPS").classList.add("showPayoutOSprtrt")
          }

        } else {

          if (document.getElementById("PAYOUTTABLETPS")) {
            document.getElementById("PAYOUTTABLETPS").classList.add("showPayoutLandscpeOS")
          }
        }
      }

      if (document.getElementById("Payout_TPS")) {
        document.getElementById("Payout_TPS").classList.add("payout_winsow_OS")
      }

      if (document.getElementById("payout_bodyTPS")) {
        document.getElementById("payout_bodyTPS").classList.add("payout_bodyOS")

      }

      if (document.getElementById("heading_payout_TPS")) {
        document.getElementById("heading_payout_TPS").classList.add("payoutheadingOS")

      }
    })
    console.log(this.state.PayoutTableToggle)
  }
  handleImageLoad = () => {
    const { assestsLoaderFunction } = this.props;
    assestsLoaderFunction()
  }
  updateMessage = () => {
    this.setState({
      infoText: this.props.infoText
    })
  }


  allowPlaceBetForNextRound = () => {
    const isActiveWindowsMode =
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0));


    const isActivePortraitMode = window.innerHeight > window.innerWidth;
    const isActiveLandscapeMode = window.innerWidth > window.innerHeight;

    const betbutton = document.getElementById("betbtnTP");
    const foldbutton = document.getElementById("FoldbtnTP");
    const drawtextElement = document.getElementById("drawtextTP");
    const betbtntextElement = document.getElementById("betbtntextTP");
    const foldtextElement = document.getElementById("foldtextTP");

    if (isActiveWindowsMode && this.intialEnter === false) {
      this.setSafeTimeout(() => {
        document.getElementById("buttons_coverOS").classList.remove("buttons_coverOS")
        document.getElementById("betpannelTropicalcover").style.display = "none";
        document.getElementById("betpannelTropicalcover").classList.remove("bet_pannelcoverOS");
        betbutton.src = Betbtn;
        Object.assign(betbutton.style, porttraitejson.Betbtnwindows)

        foldbutton.src = Foldbnwindows;
        Object.assign(foldbutton.style, porttraitejson.foldbtnwindows)

        document.getElementById("foldtextTP").textContent = "";

        document.getElementById("betbtntextTP").textContent = this.props.language.Rebet;
        document.getElementById("betbtntextTP").classList.add("betwindowsOS");
        document.getElementById("foldtextTP").classList.add("rebettextwindowsOS");
        document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;

        this.intialEnter = true;
      }, 1000)
    } else if (isActivePortraitMode && this.intialEnter === false) {
      this.setSafeTimeout(() => {

        document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
        this.setState({ infoText: this.props.language.Place_antebet, totalwinRussian: 0, storeantebetchips: [], });
        betbutton.src = Betbtn;
        // Object.assign(betbutton.style, porttraitejson.Betbtnportraite);
        Object.assign(betbutton.style, this.state.betbuttoncss);

        foldbutton.src = Foldbn;
        // Object.assign(foldbutton.style, porttraitejson.foldbtnportraite);
        Object.assign(foldbutton.style, this.state.foldbuttoncss);
        document.getElementById("betbtntextTP").textContent = this.props.language.Rebet;

        document.getElementById("betbtntextTP").classList.add(`${this.state.betbtntextcss}`);
        document.getElementById("foldtextTP").classList.add(`${this.state.foldbtntextcss}`);
        // document.getElementById("betbtntextTP").classList.add("betportraitOS");
        // document.getElementById("foldtextTP").classList.add("rebettextportraitOS");

        document.getElementById("foldtextTP").textContent = this.props.language.RebetX2;
        this.intialEnter = true;
      }, 1000)

    } else if (isActiveLandscapeMode && this.intialEnter === false) {
      this.setSafeTimeout(() => {

        document.getElementById("mobileAntiMaskCoverOS").style.display = "none";
        betbutton.src = Betbtn;
        Object.assign(betbutton.style, this.state.betbuttoncss);
        betbtntextElement.textContent = this.props.language.Rebet;
        // betbtntextElement.classList.add('betLandscapeOS');
        betbtntextElement.classList.add(`${this.state.betbtntextcss}`);

        foldbutton.src = Foldbn;
        Object.assign(foldbutton.style, this.state.foldbuttoncss);
        foldtextElement.textContent = this.props.language.RebetX2;
        // foldtextElement.classList.add("foldtextLandscapeOS");
        foldtextElement.classList.add(`${this.state.foldbtntextcss}`);
        this.intialEnter = true;
      }, 1000)

    }


  }




  render() {

    const isWindows = navigator.userAgentData?.platform === "Windows" || navigator.userAgent.includes("Windows");
    const isPortrait = window.innerHeight > window.innerWidth;
    this.roundNumber = this.props.balance - this.state.betdeductions
    this.betAmount = (this.roundNumber)
    // console.log(this.betAmount)
    // this.state.balance_rsp = this.topLable_rsp(this.betAmount);
    // this.state.updateBet = this.topLable_rsp(this.state.totalbet)

    // let balance_rsp = this.topLable_rsp(this.betAmount);
    // let updateBet = this.topLable_rsp(this.state.totalbet)
    let balance_rsp = Number(this.betAmount.toFixed(2));
    let updateBet = Number(this.state.totalbet.toFixed(2));
    let popup_winamount = this.topLable_rsp(this.state.totalwinRussian)
    // console.log(this.props.balance, "     ",this.state.betdeductions,"         ",this.roundNumber,balance_rsp)
    const {
      heightOfLayer,
      widthOfLayer,
      dealerDistanceFromX,
      playerDistanceFromX,
      dealerPlayerDistanceFromY,
      isMobilePortraitLndsp,
      dealerDistanceFromY,
      PlayerDistanceFromY,
      pokerranking
    } = this.state;


    return (
      <Fragment>
        <CoinBurst
          ref={this.winPopupContainer}
        />
        <div id="bacaratbgimTP" className="RP_MainDivOS oasisfragment" onClick={() => {

          if (this.state.isoptionmenu === true) {
            this.closeMenuOption();
          }
        }}>

          <img src={this.showTableImage()} id="pokertableimos" alt="" />
          <img src={this.showTableImage()} id="pokertablelandscapeos" alt="" />
          <img src={this.tableImg} alt="Hidden Loader" className="hidden" onLoad={this.handleImageLoad} />
          {/* <img src="" id="pokertableimTP" alt="" />
          <img src="" id="pokertablelandscapeos" alt="" /> */}

          <img id="TspoptionTP" src="" onClick={(e) => { e.preventDefault(); this.Showoptionsmenu(); }} alt="" />


          <div style={{ display: 'none' }}>
            <img src="" id="tropicaltitle" alt="" style={{ display: 'none' }} />

          </div>

          <img src="" id="balnceiconTP" alt="" />
          <span id="balance">{balance_rsp}</span>
          <img src="" id="beticonTP" alt="" />
          <span id="betsTP">{updateBet}</span>
          <img src="" id="exitbtnTP" alt="" />
          <img src="" id="winnericonTP" alt="" />
          <div id="playerDetailsTP">
            <span>P ID :  {this.props.playerId}</span>
            <span>ID :  {this.props.gameState.handId}</span>
          </div>
          <div id="winsTP">
            <span id="winamount_rsp">{this.state.totalwinRussian}</span>
          </div>

          <div id="betcontainerTP" className="betpannelOasis">
            <button disabled={this.state.antebetcircle}>
              <img src="" id="TPbetcircle"
                onClick={(e) => { e.preventDefault(); this.anteclick(); }}
                // onPointerDown={(e) => { e.preventDefault(); this.anteclick(); }}
                // onPointerUp={(e) => { e.preventDefault(); this.removeChipSound() }}
                alt="" />
            </button>

            <img src="" id="betactiveOS" alt="" className={this.state.betactvglwcss} />
            <img src="" id="buydrawTropical" alt="" />
            <img src="" id="betTropical" alt="" />
            <span id="bettextOS">{this.props.language.Bet}</span>
            <span id="buydrawtextOS">
              {this.props.language.Draw}
              <br />
              {/* {`/${this.props.language.Buy}`} */}
            </span>
            <span id="antetextTP">{this.props.language.Ante}</span>
          </div>

          <div ref={this.buyDealerCardDrawn} id="dealerBuyCardOS">
            <button type="button" id="dealerChipsAddToBuyButtonOS"> <img src="" id="dealerChipsAddToBuyTP" alt="" /></button>
            <span id="dealerChipsAddToBuyTextTP"></span>
          </div>

          <div id="betpannelTropicalcover" className={this.state.betpannelrussiancovercss}></div>
          <div id="betpannelinsurececoverTP"></div>

          <div id="mobileAntiMaskCoverOS" className={this.state.mobileAntiMaskCovercss}></div>


          <div className="player-dealer-card-containerOS" id="playerDealerCardContainerTP">

            <div id="container_playerdealerOS">
              <h1 id="Dealer">
                DEALER
              </h1>
              <h2 id="Player">
                PLAYER
              </h2>
            </div>
            {/* <Stage width={window.innerWidth} height={window.innerHeight} > */}
            {/* <Stage width={2350} height={heightOfLayer}> */}
            <Stage width={widthOfLayer} height={heightOfLayer}
              style={{ width: `${widthOfLayer}px`, height: `${heightOfLayer}px` }}
              pixelRatio={1}
            >
              <Layer>
                <Group x={dealerDistanceFromX} y={dealerDistanceFromY} stroke="black">
                  <DealerCardsContainer ref={this.dealerCardsContainer} x={450} y={400} xPadding={18}
                    scaleX={this.state.scaleX} scaleY={this.state.scaleY}
                    isMobilePortrait={isMobilePortraitLndsp} activeScreen={this.state.activeScreen} mutesounds={this.state.mutesounds} />
                </Group>
                <Group x={playerDistanceFromX} y={PlayerDistanceFromY} stroke="black">
                  <Cards ref={this.cardsRef} x={450} y={400} xPadding={18} previousGamestateCardLength6={this.props.previousGamestateCardLength6}
                    scaleX={this.state.scaleX} scaleY={this.state.scaleY}
                    ratioed={1} hidecardPos={30} numberOfCardsToBeDraw={this.numberOfCardsToBeDraw}
                    isMobilePortrait={isMobilePortraitLndsp} mutesounds={this.state.mutesounds} activeScreen={this.state.activeScreen} />
                </Group>
              </Layer>

            </Stage>
          </div>
          {(this.state.isMobilePortraitLndsp === true) && (
            <div id="chipsstoredcontainerTP" ref={this.chipsarray} className={this.state.chipsstoredcontainercss}>
              {/* {this.state.storebetchips} */}
              {this.showAnteBetchips()}
            </div>
          )}

          <button id="drawbtnButton" disabled={this.state.drawbuttonhandle}>
            <img id="drawbtnTP" onClick={(e) => { e.preventDefault(); this.drawCard(false); }} alt="" style={this.state.drawbtncss} />
          </button>
          <div style={{ display: 'none' }}>
            <button disabled={this.state.disableBuyButton} type="button" >
              <img src="" id="buybtnTP" alt="" style={this.state.buybtncss} />
            </button>
          </div>
          <button disabled={this.state.multibuttonsebledsble}>
            <img style={this.state.betbuttoncss} id="betbtnTP"

              onClick={(e) => {
                e.preventDefault();

                if (this.state.betbutton === "Bet") {
                  this.TropicalpokerBet();
                } else if (this.state.betbutton === "DEAL") {
                  this.anteBet();
                } else if (this.state.betbutton === "REBET") {
                  this.anteclick(this.state.betbutton);
                }
              }}
              alt="" />
          </button>

          <button disabled={this.state.disablemultibutton}>
            <img style={this.state.foldbuttoncss}

              id="FoldbtnTP"
              onClick={(e) => {
                e.preventDefault();
                if (this.state.buttontext == "clear") {
                  this.clearbets();
                } else if (this.state.buttontext == "fold") {
                  this.FoldCards();
                } else if (this.state.buttontext == "REBETX2") {
                  this.anteclick(this.state.buttontext);
                }
              }
              }
              alt="" />
          </button>
          <img src="" id="infrmiconTP" onMouseDown={(e) => {
            e.preventDefault();
            this.showPayoutBonusTable12()
          }}

            alt="" />
          <img src="" id="volumeTropical" onClick={(e) => { e.preventDefault(); this.muteunmutesounds(); }} alt="" />
          <button disabled={this.state.betchipincrementbtn}>
            <img src="" id="betincrenetTP" onClick={(e) => { e.preventDefault(); this.IncreamentBetchips(); }} alt="" />
          </button>
          <button disabled={this.state.betdecreamentbtn}>

            <img src="" id="betdecrementTP"
              onClick={(e) => { e.preventDefault(); this.DecreamentBetchips(); }} alt="" />
          </button>
          <img src="" id="betchipsTP" alt="" />
          {this.chipVal.map((obj, i) => (
            <span key={i} className={`valtext${i}`} id={`val${i}`}></span>
          ))}

          <img src="" ref={this.chipref} id={`betchipsaddtoanteTP${this.state.idincrement}`} alt="" style={this.state.betchipstoantebetcss} />
          <img src="" id="betchipsaddtoantecclickTP" ref={this.chiprefee} alt="" />



          <div ref={this.chipdrawref} id="betchipsaddtodrawContainerTP" className={this.state.buydrawcontainer}>
            <img src="" id="betchipsaddtodrawOS" alt="" className={this.state.drawchipcss} />
            <span id="betchipsaddtodrawTextTP" className={this.state.drawchiptextcss}></span>
          </div>
          <div >
            <img src="" id="betchipsaddtconfrmTP" alt="" />
          </div>

          <span id="betTextaddtodrawOS"></span>

          <img src="" id="betchipsaddtobetTP" ref={this.chipbetref} alt="" style={this.state.betchiptobetbtncss} />
          <span id="betTextaddtoBetTP" className={this.state.betbtntxtcss}></span>
          <div id="delaerchipanimTP">
            <img src="" id="dealerchipTP" alt="" />
          </div>
          <img src="" id="playerwinchip" alt="" />
          <img src="" id="useridTP" alt="" />
          <span id="useridtextTP">{this.props.user}</span>
          <img src="" id="Tropicalbgwindows" onClick={(e) => { e.preventDefault(); this.hidepopup_betshigh() }}
          />
          {/* <h1 id="paytable">PAY TABLE</h1> */}

          <img src={this.showTableImage()} id="Osntblewindows" alt="" />

          <div id="landscapeInfoTP">
            <span id="infoTroppicalland" className={this.state.inforussiancss}>{this.state.infoText}</span>
          </div>


          <span id="drawtextTP" className={this.state.drawbtntxtcss}></span>
          <span id="betbtntextTP" className={this.state.betbtntextcss}></span>
          <span id="foldtextTP" className={this.state.foldbtntextcss}></span>
          <span id="pokerinfotext"></span>
          <span id="bet_val"></span>
          <div id="topcardscontainerTP"></div>
        </div>

        {(this.state.isMobilePortraitLndsp === false) && (
          <div id="chipsstoredcontainerTP" ref={this.chipsarray} className={this.state.chipsstoredcontainercss}>
            {this.state.storebetchips}
          </div>

        )}

        <div id="infocontainerTP">
          <span id="infoTropicalP" className={this.state.inforussiancss}>{this.state.infoText}</span>
        </div>


        <div id="rankinginfoOS">
          {pokerranking ? pokerranking : ""}
        </div>


        <div id="TropicaPokerDeck">
          <img id="tropicaldeck" src="" />
        </div>
        <div>
          <span id="rankinginfodelerOS">{this.state.pokerrankingdeler}</span>
        </div>

        <div id="anitecircleactiveTP"></div>
        {this.state.isoptionmenu ? (
          <div id="optionsmenubuttonTP">
            {/* <div id="optiontopmenuTP">
              <span id="optiontextTP">OPTIONS</span>
            </div> */}
            <div id="buttontscontainerTP">
              <button id="limits" onClick={(e) => {
                e.preventDefault();
                this.ShowLimits();
              }}>LIMITS</button>
              <button id="help" onClick={(e) => {
                e.preventDefault();
                this.Gamerules();
              }}>HELP</button>
              <button id="history"
                onClick={(e) => {
                  e.preventDefault();
                  this.ShowHistory()
                }}>HISTORY</button>
              {/* <button id="arrow">
                <img
                  // src={exitrussian}
                  src={popupExit}
                  id="exitmenuTP"
                  onClick={(e) => {
                    e.preventDefault();
                    this.hideshowoptionmenu();
                  }} /></button> */}

            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.ShowLimits ? (
          <div id="Limits">
            <span>MinBet : {this.props.minBetAmt}</span>
            <span>MaxBet : {this.props.maxBetAmt}</span>
            {/* <button id="exitLimits" onClick={(e) => {
              e.preventDefault();
              this.exitLimits()
            }}
            // onMouseOver={() => this.animexit()}
            >EXIT</button> */}
          </div>
        ) : ""}



        {this.state.ShowGamerules ? (
          <div id="ShowGamerulesTP">
            <h1 id="gameruleMainHeadingOS">GAME RULES</h1>
            <ul id="unorderedlistitemsOS">
              {/* <hr id="hrline" /> */}
              {this.GameRules.map((val, key) => (
                <li>{val.name}</li>
              ))}
            </ul>
            {/* <button id="exitLimits" onClick={(e) => {
      e.preventDefault();
      this.exitLimits();
    }}
    // onMouseOver={() => this.animexit()}
    >EXIT</button> */}
          </div>

        ) : ""}

        {this.state.ShowHistory ? (
          <div id="prevhistoryTP">
            {/* <div id="prevhistoryTP" className="historyscaleOS"> */}
            <table id="histry_oasis">
              <thead id="heading_hstiryOS">
                <tr>
                  <th rowSpan="2">Hand Id</th>
                  <th rowSpan="2">Dealer Cards</th>
                  <th rowSpan="2">Dealer Hand</th>
                  <th rowSpan="2">Player Cards</th>
                  <th rowSpan="2">Player Hand</th>
                  <th colSpan="2">Ante</th>
                  <th colSpan="2">Bet</th>
                  <th colSpan="2">Total</th>
                </tr>
                <tr id="russianpoker_nestedhaedings">
                  <th>Wager</th>
                  <th>Win</th>
                  <th>Wager</th>
                  <th>Win</th>
                  <th>Wager</th>
                  <th>Win</th>
                </tr>
              </thead>

              <tbody id="histry_bodyOS">
                {this.props.gameState.history.map((obj, i) => (
                  <tr key={`card-${i}`} id={`${i}`}>
                    <td id="dealercards_hstryTP">{obj.result.handId}</td>
                    <td id="dealercards_hstryTP">
                      {console.log(obj.result.dealerFinalCards)}
                      {obj.result.dealerFinalCards.map((card_num, index) => {
                        const matchingCard = resultCards.find(res => res.rsc_val === card_num);
                        return (
                          <img
                            className="cardsimagesOS"
                            key={index}
                            src={matchingCard ? matchingCard.src : ''}
                            alt={card_num}
                          />


                        );
                      })}
                    </td>
                    <td id="dealerhand_hstryTP">{obj.result.dealerHand}</td>
                    <td id="playercards_hstryTP">
                      {obj.result.playerFinalCards.map((card_num, index) => {
                        const matchingCard = resultCards.find(res => res.rsc_val === card_num);
                        return (
                          <img
                            className="cardsimagesOS"
                            key={index}
                            src={matchingCard ? matchingCard.src : ''}
                            alt={card_num}
                          />
                        );
                      })}
                    </td>
                    <td id="playerhand_hstry">{obj.result.playerHand}</td>
                    <td id="totalbet_histry">{obj.result.anteBetAmount ? obj.result.anteBetAmount : 0}</td>
                    <td id="totalwin_hstry">{obj.result.anteWinAmount ? obj.result.anteWinAmount : 0}</td>
                    <td id="totalwin_hstry">{obj.result.betAmount ? obj.result.betAmount : 0}</td>
                    <td id="playerhand_hstry">{obj.result.winAmount ? obj.result.winAmount : 0}</td>
                    <td id="playerhand_hstry">{obj.result.totalBetAmount ? obj.result.totalBetAmount : 0}</td>
                    <td id="totalbet_histry">{obj.result.totalWinAmount ? obj.result.totalWinAmount : 0}</td>

                  </tr>
                ))}
              </tbody>
            </table>
            {/* <button id="exithistoryTP" onClick={(e) => {
              e.preventDefault();
              this.exithistoryTP()
            }}
            // onMouseOver={() => this.animexit()}
            >EXIT</button> */}
          </div>
        ) : null}

        <div id="Tropicalgamecover">
        </div>
        <div id="crdscoverOS"></div>
        <div id="buttons_coverOS"></div>

        <div id="winpopup_TP">
          <span id="winamt_TPS">{popup_winamount ? popup_winamount : ""}</span>
        </div>

        <div id="minmaxbetsTP">
          <span>Min : {this.props.minBetAmt}</span>
          <span>Max : {this.props.maxBetAmt}</span>
        </div>

        <div id="popupbet_greaterthanbalnceTP">
          {(this.state.betshigh_balnce !== null) &&
            <button className="exit_popupOS" id="exitPopup" onClick={this.hidepopup_betshigh}><img src={popupExit} alt={popupExit} /></button>
          }
          <span id="textbets_highTP">
            <h4 id="attentionTP">Attention!</h4>
            {this.state.lowBalaceErrorInfo}
          </span>

        </div>

        <div id="confirmbuydealer_popupTP" className="confirmbuydealerPopupcss">
          <span id="alertTxtOS" ></span>
          <button id="yesTP" onClick={(e) => {

            if (this.state.cmfrmdealeraction === 1) {
            }
            else {
              this.confirmFoldactin(true);
            }
          }}>YES</button>
          <button id="noTP" ref={this.no}
            onClick={(e) => {
              if (this.state.cmfrmdealeractionNO === 1) {
              }
              else {
                this.confirmFoldactin(false);
              }
            }}

          >NO</button>
        </div>

        <div>
          {this.state.PayoutTableToggle ? (
            <div id="PAYOUTTABLETPS">
              <div className="dis_flex_evnOS">
              </div>
              <table id="Payout_TPS" >
                <thead id="heading_payout_TPS">
                  <tr>
                    <th className="showpayoutwndsTheadOS">PLAYER HAND</th>
                    <th className="showpayoutwndsTheadOS">AMOUNT</th>
                  </tr>
                </thead>

                <tbody id="payout_bodyTPS">
                  {/* {this.props.OS_payouts.map((obj, i) => ( */}
                  {this.state.PayouyBetBounusData.map((obj, i) => {
                    return (
                      <tr key={`card-${i}`} id={`${i}`}>
                        <td id="playerhandTPS">
                          {obj.key}
                        </td>
                        <td id="playerwinamountTPS">{obj.value}</td>
                      </tr>
                    )
                  })}
                </tbody>

              </table>

            </div>
          ) : null}
        </div>
        <Howlersounds ref={this.Howlersounds} mutesounds={this.state.mutesounds} />
      </Fragment>
    );
  }
}
const mapStatesToProps = (state) => {
  return {
    language: state.languageObjs.languageObj
  }
}

export default connect(mapStatesToProps)(OasisPoker)
